!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("babylonjs")) : "function" == typeof define && define.amd ? define("babylonjs-gui", ["babylonjs"], e) : "object" == typeof exports ? exports["babylonjs-gui"] = e(require("babylonjs")) : (t.BABYLON = t.BABYLON || {}, t.BABYLON.GUI = e(t.BABYLON));
}(window, function (t) {
  return function (t) {
    var e = {};

    function i(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, i), o.l = !0, o.exports;
    }

    return i.m = t, i.c = e, i.d = function (t, e, r) {
      i.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, i.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, i.t = function (t, e) {
      if (1 & e && (t = i(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (i.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        i.d(r, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return r;
    }, i.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return i.d(e, "a", e), e;
    }, i.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, i.p = "", i(i.s = 27);
  }([function (e, i) {
    e.exports = t;
  }, function (t, e, i) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var r = i(2),
        o = i(0),
        n = i(7),
        s = i(17),
        a = function () {
      function t(e) {
        this.name = e, this._alpha = 1, this._alphaSet = !1, this._zIndex = 0, this._currentMeasure = n.Measure.Empty(), this._fontFamily = "Arial", this._fontStyle = "", this._fontWeight = "", this._fontSize = new r.ValueAndUnit(18, r.ValueAndUnit.UNITMODE_PIXEL, !1), this._width = new r.ValueAndUnit(1, r.ValueAndUnit.UNITMODE_PERCENTAGE, !1), this._height = new r.ValueAndUnit(1, r.ValueAndUnit.UNITMODE_PERCENTAGE, !1), this._color = "", this._style = null, this._horizontalAlignment = t.HORIZONTAL_ALIGNMENT_CENTER, this._verticalAlignment = t.VERTICAL_ALIGNMENT_CENTER, this._isDirty = !0, this._tempParentMeasure = n.Measure.Empty(), this._cachedParentMeasure = n.Measure.Empty(), this._paddingLeft = new r.ValueAndUnit(0), this._paddingRight = new r.ValueAndUnit(0), this._paddingTop = new r.ValueAndUnit(0), this._paddingBottom = new r.ValueAndUnit(0), this._left = new r.ValueAndUnit(0), this._top = new r.ValueAndUnit(0), this._scaleX = 1, this._scaleY = 1, this._rotation = 0, this._transformCenterX = .5, this._transformCenterY = .5, this._transformMatrix = s.Matrix2D.Identity(), this._invertTransformMatrix = s.Matrix2D.Identity(), this._transformedPosition = o.Vector2.Zero(), this._onlyMeasureMode = !1, this._isMatrixDirty = !0, this._isVisible = !0, this._fontSet = !1, this._dummyVector2 = o.Vector2.Zero(), this._downCount = 0, this._enterCount = -1, this._doNotRender = !1, this._downPointerIds = {}, this._isEnabled = !0, this._disabledColor = "#9a9a9a", this.isHitTestVisible = !0, this.isPointerBlocker = !1, this.isFocusInvisible = !1, this.shadowOffsetX = 0, this.shadowOffsetY = 0, this.shadowBlur = 0, this.shadowColor = "#000", this.hoverCursor = "", this._linkOffsetX = new r.ValueAndUnit(0), this._linkOffsetY = new r.ValueAndUnit(0), this.onPointerMoveObservable = new o.Observable(), this.onPointerOutObservable = new o.Observable(), this.onPointerDownObservable = new o.Observable(), this.onPointerUpObservable = new o.Observable(), this.onPointerClickObservable = new o.Observable(), this.onPointerEnterObservable = new o.Observable(), this.onDirtyObservable = new o.Observable(), this.onAfterDrawObservable = new o.Observable();
      }

      return Object.defineProperty(t.prototype, "typeName", {
        get: function get() {
          return this._getTypeName();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "fontOffset", {
        get: function get() {
          return this._fontOffset;
        },
        set: function set(t) {
          this._fontOffset = t;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "alpha", {
        get: function get() {
          return this._alpha;
        },
        set: function set(t) {
          this._alpha !== t && (this._alphaSet = !0, this._alpha = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "scaleX", {
        get: function get() {
          return this._scaleX;
        },
        set: function set(t) {
          this._scaleX !== t && (this._scaleX = t, this._markAsDirty(), this._markMatrixAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "scaleY", {
        get: function get() {
          return this._scaleY;
        },
        set: function set(t) {
          this._scaleY !== t && (this._scaleY = t, this._markAsDirty(), this._markMatrixAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "rotation", {
        get: function get() {
          return this._rotation;
        },
        set: function set(t) {
          this._rotation !== t && (this._rotation = t, this._markAsDirty(), this._markMatrixAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "transformCenterY", {
        get: function get() {
          return this._transformCenterY;
        },
        set: function set(t) {
          this._transformCenterY !== t && (this._transformCenterY = t, this._markAsDirty(), this._markMatrixAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "transformCenterX", {
        get: function get() {
          return this._transformCenterX;
        },
        set: function set(t) {
          this._transformCenterX !== t && (this._transformCenterX = t, this._markAsDirty(), this._markMatrixAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "horizontalAlignment", {
        get: function get() {
          return this._horizontalAlignment;
        },
        set: function set(t) {
          this._horizontalAlignment !== t && (this._horizontalAlignment = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "verticalAlignment", {
        get: function get() {
          return this._verticalAlignment;
        },
        set: function set(t) {
          this._verticalAlignment !== t && (this._verticalAlignment = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "width", {
        get: function get() {
          return this._width.toString(this._host);
        },
        set: function set(t) {
          this._width.toString(this._host) !== t && this._width.fromString(t) && this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "widthInPixels", {
        get: function get() {
          return this._width.getValueInPixel(this._host, this._cachedParentMeasure.width);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "height", {
        get: function get() {
          return this._height.toString(this._host);
        },
        set: function set(t) {
          this._height.toString(this._host) !== t && this._height.fromString(t) && this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "heightInPixels", {
        get: function get() {
          return this._height.getValueInPixel(this._host, this._cachedParentMeasure.height);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "fontFamily", {
        get: function get() {
          return this._fontFamily;
        },
        set: function set(t) {
          this._fontFamily !== t && (this._fontFamily = t, this._resetFontCache());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "fontStyle", {
        get: function get() {
          return this._fontStyle;
        },
        set: function set(t) {
          this._fontStyle !== t && (this._fontStyle = t, this._resetFontCache());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "fontWeight", {
        get: function get() {
          return this._fontWeight;
        },
        set: function set(t) {
          this._fontWeight !== t && (this._fontWeight = t, this._resetFontCache());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "style", {
        get: function get() {
          return this._style;
        },
        set: function set(t) {
          var e = this;
          this._style && (this._style.onChangedObservable.remove(this._styleObserver), this._styleObserver = null), this._style = t, this._style && (this._styleObserver = this._style.onChangedObservable.add(function () {
            e._markAsDirty(), e._resetFontCache();
          })), this._markAsDirty(), this._resetFontCache();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "_isFontSizeInPercentage", {
        get: function get() {
          return this._fontSize.isPercentage;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "fontSizeInPixels", {
        get: function get() {
          var t = this._style ? this._style._fontSize : this._fontSize;
          return t.isPixel ? t.getValue(this._host) : t.getValueInPixel(this._host, this._tempParentMeasure.height || this._cachedParentMeasure.height);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "fontSize", {
        get: function get() {
          return this._fontSize.toString(this._host);
        },
        set: function set(t) {
          this._fontSize.toString(this._host) !== t && this._fontSize.fromString(t) && (this._markAsDirty(), this._resetFontCache());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "color", {
        get: function get() {
          return this._color;
        },
        set: function set(t) {
          this._color !== t && (this._color = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "zIndex", {
        get: function get() {
          return this._zIndex;
        },
        set: function set(t) {
          this.zIndex !== t && (this._zIndex = t, this._root && this._root._reOrderControl(this));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "notRenderable", {
        get: function get() {
          return this._doNotRender;
        },
        set: function set(t) {
          this._doNotRender !== t && (this._doNotRender = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "isVisible", {
        get: function get() {
          return this._isVisible;
        },
        set: function set(t) {
          this._isVisible !== t && (this._isVisible = t, this._markAsDirty(!0));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "isDirty", {
        get: function get() {
          return this._isDirty;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "linkedMesh", {
        get: function get() {
          return this._linkedMesh;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "paddingLeft", {
        get: function get() {
          return this._paddingLeft.toString(this._host);
        },
        set: function set(t) {
          this._paddingLeft.fromString(t) && this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "paddingLeftInPixels", {
        get: function get() {
          return this._paddingLeft.getValueInPixel(this._host, this._cachedParentMeasure.width);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "paddingRight", {
        get: function get() {
          return this._paddingRight.toString(this._host);
        },
        set: function set(t) {
          this._paddingRight.fromString(t) && this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "paddingRightInPixels", {
        get: function get() {
          return this._paddingRight.getValueInPixel(this._host, this._cachedParentMeasure.width);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "paddingTop", {
        get: function get() {
          return this._paddingTop.toString(this._host);
        },
        set: function set(t) {
          this._paddingTop.fromString(t) && this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "paddingTopInPixels", {
        get: function get() {
          return this._paddingTop.getValueInPixel(this._host, this._cachedParentMeasure.height);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "paddingBottom", {
        get: function get() {
          return this._paddingBottom.toString(this._host);
        },
        set: function set(t) {
          this._paddingBottom.fromString(t) && this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "paddingBottomInPixels", {
        get: function get() {
          return this._paddingBottom.getValueInPixel(this._host, this._cachedParentMeasure.height);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "left", {
        get: function get() {
          return this._left.toString(this._host);
        },
        set: function set(t) {
          this._left.fromString(t) && this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "leftInPixels", {
        get: function get() {
          return this._left.getValueInPixel(this._host, this._cachedParentMeasure.width);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "top", {
        get: function get() {
          return this._top.toString(this._host);
        },
        set: function set(t) {
          this._top.fromString(t) && this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "topInPixels", {
        get: function get() {
          return this._top.getValueInPixel(this._host, this._cachedParentMeasure.height);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "linkOffsetX", {
        get: function get() {
          return this._linkOffsetX.toString(this._host);
        },
        set: function set(t) {
          this._linkOffsetX.fromString(t) && this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "linkOffsetXInPixels", {
        get: function get() {
          return this._linkOffsetX.getValueInPixel(this._host, this._cachedParentMeasure.width);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "linkOffsetY", {
        get: function get() {
          return this._linkOffsetY.toString(this._host);
        },
        set: function set(t) {
          this._linkOffsetY.fromString(t) && this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "linkOffsetYInPixels", {
        get: function get() {
          return this._linkOffsetY.getValueInPixel(this._host, this._cachedParentMeasure.height);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "centerX", {
        get: function get() {
          return this._currentMeasure.left + this._currentMeasure.width / 2;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "centerY", {
        get: function get() {
          return this._currentMeasure.top + this._currentMeasure.height / 2;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "isEnabled", {
        get: function get() {
          return this._isEnabled;
        },
        set: function set(t) {
          this._isEnabled !== t && (this._isEnabled = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "disabledColor", {
        get: function get() {
          return this._disabledColor;
        },
        set: function set(t) {
          this._disabledColor !== t && (this._disabledColor = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype._getTypeName = function () {
        return "Control";
      }, t.prototype._resetFontCache = function () {
        this._fontSet = !0, this._markAsDirty();
      }, t.prototype.isAscendant = function (t) {
        return !!this.parent && (this.parent === t || this.parent.isAscendant(t));
      }, t.prototype.getLocalCoordinates = function (t) {
        var e = o.Vector2.Zero();
        return this.getLocalCoordinatesToRef(t, e), e;
      }, t.prototype.getLocalCoordinatesToRef = function (t, e) {
        return e.x = t.x - this._currentMeasure.left, e.y = t.y - this._currentMeasure.top, this;
      }, t.prototype.getParentLocalCoordinates = function (t) {
        var e = o.Vector2.Zero();
        return e.x = t.x - this._cachedParentMeasure.left, e.y = t.y - this._cachedParentMeasure.top, e;
      }, t.prototype.moveToVector3 = function (e, i) {
        if (this._host && this._root === this._host._rootContainer) {
          this.horizontalAlignment = t.HORIZONTAL_ALIGNMENT_LEFT, this.verticalAlignment = t.VERTICAL_ALIGNMENT_TOP;

          var r = this._host._getGlobalViewport(i),
              n = o.Vector3.Project(e, o.Matrix.Identity(), i.getTransformMatrix(), r);

          this._moveToProjectedPosition(n), n.z < 0 || n.z > 1 ? this.notRenderable = !0 : this.notRenderable = !1;
        } else o.Tools.Error("Cannot move a control to a vector3 if the control is not at root level");
      }, t.prototype.linkWithMesh = function (e) {
        if (!this._host || this._root && this._root !== this._host._rootContainer) e && o.Tools.Error("Cannot link a control to a mesh if the control is not at root level");else {
          var i = this._host._linkedControls.indexOf(this);

          if (-1 !== i) return this._linkedMesh = e, void (e || this._host._linkedControls.splice(i, 1));
          e && (this.horizontalAlignment = t.HORIZONTAL_ALIGNMENT_LEFT, this.verticalAlignment = t.VERTICAL_ALIGNMENT_TOP, this._linkedMesh = e, this._onlyMeasureMode = 0 === this._currentMeasure.width || 0 === this._currentMeasure.height, this._host._linkedControls.push(this));
        }
      }, t.prototype._moveToProjectedPosition = function (t) {
        var e = this._left.getValue(this._host),
            i = this._top.getValue(this._host),
            r = t.x + this._linkOffsetX.getValue(this._host) - this._currentMeasure.width / 2,
            o = t.y + this._linkOffsetY.getValue(this._host) - this._currentMeasure.height / 2;

        this._left.ignoreAdaptiveScaling && this._top.ignoreAdaptiveScaling && (Math.abs(r - e) < .5 && (r = e), Math.abs(o - i) < .5 && (o = i)), this.left = r + "px", this.top = o + "px", this._left.ignoreAdaptiveScaling = !0, this._top.ignoreAdaptiveScaling = !0;
      }, t.prototype._markMatrixAsDirty = function () {
        this._isMatrixDirty = !0, this._flagDescendantsAsMatrixDirty();
      }, t.prototype._flagDescendantsAsMatrixDirty = function () {}, t.prototype._markAsDirty = function (t) {
        void 0 === t && (t = !1), (this._isVisible || t) && (this._isDirty = !0, this._host && this._host.markAsDirty());
      }, t.prototype._markAllAsDirty = function () {
        this._markAsDirty(), this._font && this._prepareFont();
      }, t.prototype._link = function (t, e) {
        this._root = t, this._host = e;
      }, t.prototype._transform = function (t) {
        if (this._isMatrixDirty || 1 !== this._scaleX || 1 !== this._scaleY || 0 !== this._rotation) {
          var e = this._currentMeasure.width * this._transformCenterX + this._currentMeasure.left,
              i = this._currentMeasure.height * this._transformCenterY + this._currentMeasure.top;
          t.translate(e, i), t.rotate(this._rotation), t.scale(this._scaleX, this._scaleY), t.translate(-e, -i), (this._isMatrixDirty || this._cachedOffsetX !== e || this._cachedOffsetY !== i) && (this._cachedOffsetX = e, this._cachedOffsetY = i, this._isMatrixDirty = !1, this._flagDescendantsAsMatrixDirty(), s.Matrix2D.ComposeToRef(-e, -i, this._rotation, this._scaleX, this._scaleY, this._root ? this._root._transformMatrix : null, this._transformMatrix), this._transformMatrix.invertToRef(this._invertTransformMatrix));
        }
      }, t.prototype._applyStates = function (t) {
        this._isFontSizeInPercentage && (this._fontSet = !0), this._fontSet && (this._prepareFont(), this._fontSet = !1), this._font && (t.font = this._font), this._color && (t.fillStyle = this._color), this._alphaSet && (t.globalAlpha = this.parent ? this.parent.alpha * this._alpha : this._alpha);
      }, t.prototype._processMeasures = function (t, e) {
        return !this._isDirty && this._cachedParentMeasure.isEqualsTo(t) || (this._isDirty = !1, this._currentMeasure.copyFrom(t), this._preMeasure(t, e), this._measure(), this._computeAlignment(t, e), this._currentMeasure.left = 0 | this._currentMeasure.left, this._currentMeasure.top = 0 | this._currentMeasure.top, this._currentMeasure.width = 0 | this._currentMeasure.width, this._currentMeasure.height = 0 | this._currentMeasure.height, this._additionalProcessing(t, e), this._cachedParentMeasure.copyFrom(t), this.onDirtyObservable.hasObservers() && this.onDirtyObservable.notifyObservers(this)), !(this._currentMeasure.left > t.left + t.width) && !(this._currentMeasure.left + this._currentMeasure.width < t.left) && !(this._currentMeasure.top > t.top + t.height) && !(this._currentMeasure.top + this._currentMeasure.height < t.top) && (this._transform(e), this._onlyMeasureMode ? (this._onlyMeasureMode = !1, !1) : (this._clip(e), e.clip(), !0));
      }, t.prototype._clip = function (t) {
        if (t.beginPath(), this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
          var e = this.shadowOffsetX,
              i = this.shadowOffsetY,
              r = this.shadowBlur,
              o = Math.min(Math.min(e, 0) - 2 * r, 0),
              n = Math.max(Math.max(e, 0) + 2 * r, 0),
              s = Math.min(Math.min(i, 0) - 2 * r, 0),
              a = Math.max(Math.max(i, 0) + 2 * r, 0);
          t.rect(this._currentMeasure.left + o, this._currentMeasure.top + s, this._currentMeasure.width + n - o, this._currentMeasure.height + a - s);
        } else t.rect(this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height);
      }, t.prototype._measure = function () {
        this._width.isPixel ? this._currentMeasure.width = this._width.getValue(this._host) : this._currentMeasure.width *= this._width.getValue(this._host), this._height.isPixel ? this._currentMeasure.height = this._height.getValue(this._host) : this._currentMeasure.height *= this._height.getValue(this._host);
      }, t.prototype._computeAlignment = function (e, i) {
        var r = this._currentMeasure.width,
            o = this._currentMeasure.height,
            n = e.width,
            s = e.height,
            a = 0,
            h = 0;

        switch (this.horizontalAlignment) {
          case t.HORIZONTAL_ALIGNMENT_LEFT:
            a = 0;
            break;

          case t.HORIZONTAL_ALIGNMENT_RIGHT:
            a = n - r;
            break;

          case t.HORIZONTAL_ALIGNMENT_CENTER:
            a = (n - r) / 2;
        }

        switch (this.verticalAlignment) {
          case t.VERTICAL_ALIGNMENT_TOP:
            h = 0;
            break;

          case t.VERTICAL_ALIGNMENT_BOTTOM:
            h = s - o;
            break;

          case t.VERTICAL_ALIGNMENT_CENTER:
            h = (s - o) / 2;
        }

        this._paddingLeft.isPixel ? (this._currentMeasure.left += this._paddingLeft.getValue(this._host), this._currentMeasure.width -= this._paddingLeft.getValue(this._host)) : (this._currentMeasure.left += n * this._paddingLeft.getValue(this._host), this._currentMeasure.width -= n * this._paddingLeft.getValue(this._host)), this._paddingRight.isPixel ? this._currentMeasure.width -= this._paddingRight.getValue(this._host) : this._currentMeasure.width -= n * this._paddingRight.getValue(this._host), this._paddingTop.isPixel ? (this._currentMeasure.top += this._paddingTop.getValue(this._host), this._currentMeasure.height -= this._paddingTop.getValue(this._host)) : (this._currentMeasure.top += s * this._paddingTop.getValue(this._host), this._currentMeasure.height -= s * this._paddingTop.getValue(this._host)), this._paddingBottom.isPixel ? this._currentMeasure.height -= this._paddingBottom.getValue(this._host) : this._currentMeasure.height -= s * this._paddingBottom.getValue(this._host), this._left.isPixel ? this._currentMeasure.left += this._left.getValue(this._host) : this._currentMeasure.left += n * this._left.getValue(this._host), this._top.isPixel ? this._currentMeasure.top += this._top.getValue(this._host) : this._currentMeasure.top += s * this._top.getValue(this._host), this._currentMeasure.left += a, this._currentMeasure.top += h;
      }, t.prototype._preMeasure = function (t, e) {}, t.prototype._additionalProcessing = function (t, e) {}, t.prototype._draw = function (t, e) {}, t.prototype.contains = function (t, e) {
        return this._invertTransformMatrix.transformCoordinates(t, e, this._transformedPosition), t = this._transformedPosition.x, e = this._transformedPosition.y, !(t < this._currentMeasure.left) && !(t > this._currentMeasure.left + this._currentMeasure.width) && !(e < this._currentMeasure.top) && !(e > this._currentMeasure.top + this._currentMeasure.height) && (this.isPointerBlocker && (this._host._shouldBlockPointer = !0), !0);
      }, t.prototype._processPicking = function (t, e, i, r, o) {
        return !!this._isEnabled && !(!this.isHitTestVisible || !this.isVisible || this._doNotRender) && !!this.contains(t, e) && (this._processObservables(i, t, e, r, o), !0);
      }, t.prototype._onPointerMove = function (t, e) {
        this.onPointerMoveObservable.notifyObservers(e, -1, t, this) && null != this.parent && this.parent._onPointerMove(t, e);
      }, t.prototype._onPointerEnter = function (t) {
        return !!this._isEnabled && !(this._enterCount > 0) && (-1 === this._enterCount && (this._enterCount = 0), this._enterCount++, this.onPointerEnterObservable.notifyObservers(this, -1, t, this) && null != this.parent && this.parent._onPointerEnter(t), !0);
      }, t.prototype._onPointerOut = function (t) {
        this._isEnabled && (this._enterCount = 0, this.onPointerOutObservable.notifyObservers(this, -1, t, this) && null != this.parent && this.parent._onPointerOut(t));
      }, t.prototype._onPointerDown = function (t, e, i, r) {
        return this._onPointerEnter(this), 0 === this._downCount && (this._downCount++, this._downPointerIds[i] = !0, this.onPointerDownObservable.notifyObservers(new s.Vector2WithInfo(e, r), -1, t, this) && null != this.parent && this.parent._onPointerDown(t, e, i, r), !0);
      }, t.prototype._onPointerUp = function (t, e, i, r, o) {
        if (this._isEnabled) {
          this._downCount = 0, delete this._downPointerIds[i];
          var n = o;
          o && (this._enterCount > 0 || -1 === this._enterCount) && (n = this.onPointerClickObservable.notifyObservers(new s.Vector2WithInfo(e, r), -1, t, this)), this.onPointerUpObservable.notifyObservers(new s.Vector2WithInfo(e, r), -1, t, this) && null != this.parent && this.parent._onPointerUp(t, e, i, r, n);
        }
      }, t.prototype._forcePointerUp = function (t) {
        if (void 0 === t && (t = null), null !== t) this._onPointerUp(this, o.Vector2.Zero(), t, 0, !0);else for (var e in this._downPointerIds) {
          this._onPointerUp(this, o.Vector2.Zero(), +e, 0, !0);
        }
      }, t.prototype._processObservables = function (t, e, i, r, n) {
        if (!this._isEnabled) return !1;

        if (this._dummyVector2.copyFromFloats(e, i), t === o.PointerEventTypes.POINTERMOVE) {
          this._onPointerMove(this, this._dummyVector2);

          var s = this._host._lastControlOver[r];
          return s && s !== this && s._onPointerOut(this), s !== this && this._onPointerEnter(this), this._host._lastControlOver[r] = this, !0;
        }

        return t === o.PointerEventTypes.POINTERDOWN ? (this._onPointerDown(this, this._dummyVector2, r, n), this._host._lastControlDown[r] = this, this._host._lastPickedControl = this, !0) : t === o.PointerEventTypes.POINTERUP && (this._host._lastControlDown[r] && this._host._lastControlDown[r]._onPointerUp(this, this._dummyVector2, r, n, !0), delete this._host._lastControlDown[r], !0);
      }, t.prototype._prepareFont = function () {
        (this._font || this._fontSet) && (this._style ? this._font = this._style.fontStyle + " " + this._style.fontWeight + " " + this.fontSizeInPixels + "px " + this._style.fontFamily : this._font = this._fontStyle + " " + this._fontWeight + " " + this.fontSizeInPixels + "px " + this._fontFamily, this._fontOffset = t._GetFontOffset(this._font));
      }, t.prototype.dispose = function () {
        (this.onDirtyObservable.clear(), this.onAfterDrawObservable.clear(), this.onPointerDownObservable.clear(), this.onPointerEnterObservable.clear(), this.onPointerMoveObservable.clear(), this.onPointerOutObservable.clear(), this.onPointerUpObservable.clear(), this.onPointerClickObservable.clear(), this._styleObserver && this._style && (this._style.onChangedObservable.remove(this._styleObserver), this._styleObserver = null), this._root && (this._root.removeControl(this), this._root = null), this._host) && this._host._linkedControls.indexOf(this) > -1 && this.linkWithMesh(null);
      }, Object.defineProperty(t, "HORIZONTAL_ALIGNMENT_LEFT", {
        get: function get() {
          return t._HORIZONTAL_ALIGNMENT_LEFT;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t, "HORIZONTAL_ALIGNMENT_RIGHT", {
        get: function get() {
          return t._HORIZONTAL_ALIGNMENT_RIGHT;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t, "HORIZONTAL_ALIGNMENT_CENTER", {
        get: function get() {
          return t._HORIZONTAL_ALIGNMENT_CENTER;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t, "VERTICAL_ALIGNMENT_TOP", {
        get: function get() {
          return t._VERTICAL_ALIGNMENT_TOP;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t, "VERTICAL_ALIGNMENT_BOTTOM", {
        get: function get() {
          return t._VERTICAL_ALIGNMENT_BOTTOM;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t, "VERTICAL_ALIGNMENT_CENTER", {
        get: function get() {
          return t._VERTICAL_ALIGNMENT_CENTER;
        },
        enumerable: !0,
        configurable: !0
      }), t._GetFontOffset = function (e) {
        if (t._FontHeightSizes[e]) return t._FontHeightSizes[e];
        var i = document.createElement("span");
        i.innerHTML = "Hg", i.style.font = e;
        var r = document.createElement("div");
        r.style.display = "inline-block", r.style.width = "1px", r.style.height = "0px", r.style.verticalAlign = "bottom";
        var o = document.createElement("div");
        o.appendChild(i), o.appendChild(r), document.body.appendChild(o);
        var n = 0,
            s = 0;

        try {
          s = r.getBoundingClientRect().top - i.getBoundingClientRect().top, r.style.verticalAlign = "baseline", n = r.getBoundingClientRect().top - i.getBoundingClientRect().top;
        } finally {
          document.body.removeChild(o);
        }

        var a = {
          ascent: n,
          height: s,
          descent: s - n
        };
        return t._FontHeightSizes[e] = a, a;
      }, t.drawEllipse = function (t, e, i, r, o) {
        o.translate(t, e), o.scale(i, r), o.beginPath(), o.arc(0, 0, 1, 0, 2 * Math.PI), o.closePath(), o.scale(1 / i, 1 / r), o.translate(-t, -e);
      }, t._HORIZONTAL_ALIGNMENT_LEFT = 0, t._HORIZONTAL_ALIGNMENT_RIGHT = 1, t._HORIZONTAL_ALIGNMENT_CENTER = 2, t._VERTICAL_ALIGNMENT_TOP = 0, t._VERTICAL_ALIGNMENT_BOTTOM = 1, t._VERTICAL_ALIGNMENT_CENTER = 2, t._FontHeightSizes = {}, t.AddHeader = function () {}, t;
    }();

    e.Control = a;
  }, function (t, e, i) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var r = function () {
      function t(e, i, r) {
        void 0 === i && (i = t.UNITMODE_PIXEL), void 0 === r && (r = !0), this.unit = i, this.negativeValueAllowed = r, this._value = 1, this.ignoreAdaptiveScaling = !1, this._value = e;
      }

      return Object.defineProperty(t.prototype, "isPercentage", {
        get: function get() {
          return this.unit === t.UNITMODE_PERCENTAGE;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "isPixel", {
        get: function get() {
          return this.unit === t.UNITMODE_PIXEL;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "internalValue", {
        get: function get() {
          return this._value;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.getValueInPixel = function (t, e) {
        return this.isPixel ? this.getValue(t) : this.getValue(t) * e;
      }, t.prototype.getValue = function (e) {
        if (e && !this.ignoreAdaptiveScaling && this.unit !== t.UNITMODE_PERCENTAGE) {
          var i = 0,
              r = 0;
          if (e.idealWidth && (i = this._value * e.getSize().width / e.idealWidth), e.idealHeight && (r = this._value * e.getSize().height / e.idealHeight), e.useSmallestIdeal && e.idealWidth && e.idealHeight) return window.innerWidth < window.innerHeight ? i : r;
          if (e.idealWidth) return i;
          if (e.idealHeight) return r;
        }

        return this._value;
      }, t.prototype.toString = function (e) {
        switch (this.unit) {
          case t.UNITMODE_PERCENTAGE:
            return 100 * this.getValue(e) + "%";

          case t.UNITMODE_PIXEL:
            return this.getValue(e) + "px";
        }

        return this.unit.toString();
      }, t.prototype.fromString = function (e) {
        var i = t._Regex.exec(e.toString());

        if (!i || 0 === i.length) return !1;
        var r = parseFloat(i[1]),
            o = this.unit;
        if (this.negativeValueAllowed || r < 0 && (r = 0), 4 === i.length) switch (i[3]) {
          case "px":
            o = t.UNITMODE_PIXEL;
            break;

          case "%":
            o = t.UNITMODE_PERCENTAGE, r /= 100;
        }
        return (r !== this._value || o !== this.unit) && (this._value = r, this.unit = o, !0);
      }, Object.defineProperty(t, "UNITMODE_PERCENTAGE", {
        get: function get() {
          return t._UNITMODE_PERCENTAGE;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t, "UNITMODE_PIXEL", {
        get: function get() {
          return t._UNITMODE_PIXEL;
        },
        enumerable: !0,
        configurable: !0
      }), t._Regex = /(^-?\d*(\.\d+)?)(%|px)?/, t._UNITMODE_PERCENTAGE = 0, t._UNITMODE_PIXEL = 1, t;
    }();

    e.ValueAndUnit = r;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t = function t(e, i) {
        return (_t = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(13),
        n = i(0),
        s = function (t) {
      function e(e) {
        var i = t.call(this, e) || this;
        return i._blockLayout = !1, i._children = new Array(), i;
      }

      return r(e, t), Object.defineProperty(e.prototype, "children", {
        get: function get() {
          return this._children;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "blockLayout", {
        get: function get() {
          return this._blockLayout;
        },
        set: function set(t) {
          this._blockLayout !== t && (this._blockLayout = t, this._blockLayout || this._arrangeChildren());
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.updateLayout = function () {
        return this._arrangeChildren(), this;
      }, e.prototype.containsControl = function (t) {
        return -1 !== this._children.indexOf(t);
      }, e.prototype.addControl = function (t) {
        return -1 !== this._children.indexOf(t) ? this : (t.parent = this, t._host = this._host, this._children.push(t), this._host.utilityLayer && (t._prepareNode(this._host.utilityLayer.utilityLayerScene), t.node && (t.node.parent = this.node), this.blockLayout || this._arrangeChildren()), this);
      }, e.prototype._arrangeChildren = function () {}, e.prototype._createNode = function (t) {
        return new n.TransformNode("ContainerNode", t);
      }, e.prototype.removeControl = function (t) {
        var e = this._children.indexOf(t);

        return -1 !== e && (this._children.splice(e, 1), t.parent = null, t._disposeNode()), this;
      }, e.prototype._getTypeName = function () {
        return "Container3D";
      }, e.prototype.dispose = function () {
        for (var e = 0, i = this._children; e < i.length; e++) {
          i[e].dispose();
        }

        this._children = [], t.prototype.dispose.call(this);
      }, e.UNSET_ORIENTATION = 0, e.FACEORIGIN_ORIENTATION = 1, e.FACEORIGINREVERSED_ORIENTATION = 2, e.FACEFORWARD_ORIENTATION = 3, e.FACEFORWARDREVERSED_ORIENTATION = 4, e;
    }(o.Control3D);

    e.Container3D = s;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t2 = function t(e, i) {
        return (_t2 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t2(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(1),
        n = i(7),
        s = function (t) {
      function e(e) {
        var i = t.call(this, e) || this;
        return i.name = e, i._children = new Array(), i._measureForChildren = n.Measure.Empty(), i._adaptWidthToChildren = !1, i._adaptHeightToChildren = !1, i;
      }

      return r(e, t), Object.defineProperty(e.prototype, "adaptHeightToChildren", {
        get: function get() {
          return this._adaptHeightToChildren;
        },
        set: function set(t) {
          this._adaptHeightToChildren !== t && (this._adaptHeightToChildren = t, t && (this.height = "100%"), this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "adaptWidthToChildren", {
        get: function get() {
          return this._adaptWidthToChildren;
        },
        set: function set(t) {
          this._adaptWidthToChildren !== t && (this._adaptWidthToChildren = t, t && (this.width = "100%"), this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "background", {
        get: function get() {
          return this._background;
        },
        set: function set(t) {
          this._background !== t && (this._background = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "children", {
        get: function get() {
          return this._children;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._getTypeName = function () {
        return "Container";
      }, e.prototype._flagDescendantsAsMatrixDirty = function () {
        for (var t = 0, e = this.children; t < e.length; t++) {
          e[t]._markMatrixAsDirty();
        }
      }, e.prototype.getChildByName = function (t) {
        for (var e = 0, i = this.children; e < i.length; e++) {
          var r = i[e];
          if (r.name === t) return r;
        }

        return null;
      }, e.prototype.getChildByType = function (t, e) {
        for (var i = 0, r = this.children; i < r.length; i++) {
          var o = r[i];
          if (o.typeName === e) return o;
        }

        return null;
      }, e.prototype.containsControl = function (t) {
        return -1 !== this.children.indexOf(t);
      }, e.prototype.addControl = function (t) {
        return t ? -1 !== this._children.indexOf(t) ? this : (t._link(this, this._host), t._markAllAsDirty(), this._reOrderControl(t), this._markAsDirty(), this) : this;
      }, e.prototype.clearControls = function () {
        for (var t = 0, e = this._children.slice(); t < e.length; t++) {
          var i = e[t];
          this.removeControl(i);
        }

        return this;
      }, e.prototype.removeControl = function (t) {
        var e = this._children.indexOf(t);

        return -1 !== e && (this._children.splice(e, 1), t.parent = null), t.linkWithMesh(null), this._host && this._host._cleanControlAfterRemoval(t), this._markAsDirty(), this;
      }, e.prototype._reOrderControl = function (t) {
        this.removeControl(t);

        for (var e = 0; e < this._children.length; e++) {
          if (this._children[e].zIndex > t.zIndex) return void this._children.splice(e, 0, t);
        }

        this._children.push(t), t.parent = this, this._markAsDirty();
      }, e.prototype._markAllAsDirty = function () {
        t.prototype._markAllAsDirty.call(this);

        for (var e = 0; e < this._children.length; e++) {
          this._children[e]._markAllAsDirty();
        }
      }, e.prototype._localDraw = function (t) {
        this._background && ((this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (t.shadowColor = this.shadowColor, t.shadowBlur = this.shadowBlur, t.shadowOffsetX = this.shadowOffsetX, t.shadowOffsetY = this.shadowOffsetY), t.fillStyle = this._background, t.fillRect(this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height), (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (t.shadowBlur = 0, t.shadowOffsetX = 0, t.shadowOffsetY = 0));
      }, e.prototype._link = function (e, i) {
        t.prototype._link.call(this, e, i);

        for (var r = 0, o = this._children; r < o.length; r++) {
          o[r]._link(this, i);
        }
      }, e.prototype._draw = function (t, e) {
        if (this.isVisible && !this.notRenderable) {
          if (e.save(), this._applyStates(e), this._processMeasures(t, e)) {
            this._localDraw(e), this._clipForChildren(e);

            for (var i = -1, r = -1, o = 0, n = this._children; o < n.length; o++) {
              var s = n[o];
              s.isVisible && !s.notRenderable && (s._tempParentMeasure.copyFrom(this._measureForChildren), s._draw(this._measureForChildren, e), s.onAfterDrawObservable.hasObservers() && s.onAfterDrawObservable.notifyObservers(s), this.adaptWidthToChildren && s._width.isPixel && (i = Math.max(i, s._currentMeasure.width)), this.adaptHeightToChildren && s._height.isPixel && (r = Math.max(r, s._currentMeasure.height)));
            }

            this.adaptWidthToChildren && i >= 0 && (this.width = i + "px"), this.adaptHeightToChildren && r >= 0 && (this.height = r + "px");
          }

          e.restore(), this.onAfterDrawObservable.hasObservers() && this.onAfterDrawObservable.notifyObservers(this);
        }
      }, e.prototype._processPicking = function (e, i, r, o, n) {
        if (!this.isVisible || this.notRenderable) return !1;
        if (!t.prototype.contains.call(this, e, i)) return !1;

        for (var s = this._children.length - 1; s >= 0; s--) {
          var a = this._children[s];
          if (a._processPicking(e, i, r, o, n)) return a.hoverCursor && this._host._changeCursor(a.hoverCursor), !0;
        }

        return !!this.isHitTestVisible && this._processObservables(r, e, i, o, n);
      }, e.prototype._clipForChildren = function (t) {}, e.prototype._additionalProcessing = function (e, i) {
        t.prototype._additionalProcessing.call(this, e, i), this._measureForChildren.copyFrom(this._currentMeasure);
      }, e.prototype.dispose = function () {
        t.prototype.dispose.call(this);

        for (var e = 0, i = this._children; e < i.length; e++) {
          i[e].dispose();
        }
      }, e;
    }(o.Control);

    e.Container = s;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t3 = function t(e, i) {
        return (_t3 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t3(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var o,
        n = i(0),
        s = i(2),
        a = i(1);
    !function (t) {
      t[t.Clip = 0] = "Clip", t[t.WordWrap = 1] = "WordWrap", t[t.Ellipsis = 2] = "Ellipsis";
    }(o = e.TextWrapping || (e.TextWrapping = {}));

    var h = function (t) {
      function e(e, i) {
        void 0 === i && (i = "");
        var r = t.call(this, e) || this;
        return r.name = e, r._text = "", r._textWrapping = o.Clip, r._textHorizontalAlignment = a.Control.HORIZONTAL_ALIGNMENT_CENTER, r._textVerticalAlignment = a.Control.VERTICAL_ALIGNMENT_CENTER, r._resizeToFit = !1, r._lineSpacing = new s.ValueAndUnit(0), r._outlineWidth = 0, r._outlineColor = "white", r.onTextChangedObservable = new n.Observable(), r.onLinesReadyObservable = new n.Observable(), r.text = i, r;
      }

      return r(e, t), Object.defineProperty(e.prototype, "lines", {
        get: function get() {
          return this._lines;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "resizeToFit", {
        get: function get() {
          return this._resizeToFit;
        },
        set: function set(t) {
          this._resizeToFit = t, this._resizeToFit && (this._width.ignoreAdaptiveScaling = !0, this._height.ignoreAdaptiveScaling = !0);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "textWrapping", {
        get: function get() {
          return this._textWrapping;
        },
        set: function set(t) {
          this._textWrapping !== t && (this._textWrapping = +t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "text", {
        get: function get() {
          return this._text;
        },
        set: function set(t) {
          this._text !== t && (this._text = t, this._markAsDirty(), this.onTextChangedObservable.notifyObservers(this));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "textHorizontalAlignment", {
        get: function get() {
          return this._textHorizontalAlignment;
        },
        set: function set(t) {
          this._textHorizontalAlignment !== t && (this._textHorizontalAlignment = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "textVerticalAlignment", {
        get: function get() {
          return this._textVerticalAlignment;
        },
        set: function set(t) {
          this._textVerticalAlignment !== t && (this._textVerticalAlignment = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "lineSpacing", {
        get: function get() {
          return this._lineSpacing.toString(this._host);
        },
        set: function set(t) {
          this._lineSpacing.fromString(t) && this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "outlineWidth", {
        get: function get() {
          return this._outlineWidth;
        },
        set: function set(t) {
          this._outlineWidth !== t && (this._outlineWidth = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "outlineColor", {
        get: function get() {
          return this._outlineColor;
        },
        set: function set(t) {
          this._outlineColor !== t && (this._outlineColor = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._getTypeName = function () {
        return "TextBlock";
      }, e.prototype._drawText = function (t, e, i, r) {
        var o = this._currentMeasure.width,
            n = 0;

        switch (this._textHorizontalAlignment) {
          case a.Control.HORIZONTAL_ALIGNMENT_LEFT:
            n = 0;
            break;

          case a.Control.HORIZONTAL_ALIGNMENT_RIGHT:
            n = o - e;
            break;

          case a.Control.HORIZONTAL_ALIGNMENT_CENTER:
            n = (o - e) / 2;
        }

        (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (r.shadowColor = this.shadowColor, r.shadowBlur = this.shadowBlur, r.shadowOffsetX = this.shadowOffsetX, r.shadowOffsetY = this.shadowOffsetY), this.outlineWidth && r.strokeText(t, this._currentMeasure.left + n, i), r.fillText(t, this._currentMeasure.left + n, i);
      }, e.prototype._draw = function (t, e) {
        e.save(), this._applyStates(e), this._processMeasures(t, e) && this._renderLines(e), e.restore();
      }, e.prototype._applyStates = function (e) {
        t.prototype._applyStates.call(this, e), this.outlineWidth && (e.lineWidth = this.outlineWidth, e.strokeStyle = this.outlineColor);
      }, e.prototype._additionalProcessing = function (t, e) {
        this._lines = this._breakLines(this._currentMeasure.width, e), this.onLinesReadyObservable.notifyObservers(this);
      }, e.prototype._breakLines = function (t, e) {
        var i = [],
            r = this.text.split("\n");
        if (this._textWrapping !== o.Ellipsis || this._resizeToFit) {
          if (this._textWrapping !== o.WordWrap || this._resizeToFit) for (var n = 0, s = r; n < s.length; n++) {
            l = s[n];
            i.push(this._parseLine(l, e));
          } else for (var a = 0, h = r; a < h.length; a++) {
            var l = h[a];
            i.push.apply(i, this._parseLineWordWrap(l, t, e));
          }
        } else for (var u = 0, c = r; u < c.length; u++) {
          var l = c[u];
          i.push(this._parseLineEllipsis(l, t, e));
        }
        return i;
      }, e.prototype._parseLine = function (t, e) {
        return void 0 === t && (t = ""), {
          text: t,
          width: e.measureText(t).width
        };
      }, e.prototype._parseLineEllipsis = function (t, e, i) {
        void 0 === t && (t = "");
        var r = i.measureText(t).width;

        for (r > e && (t += "…"); t.length > 2 && r > e;) {
          t = t.slice(0, -2) + "…", r = i.measureText(t).width;
        }

        return {
          text: t,
          width: r
        };
      }, e.prototype._parseLineWordWrap = function (t, e, i) {
        void 0 === t && (t = "");

        for (var r = [], o = t.split(" "), n = 0, s = 0; s < o.length; s++) {
          var a = s > 0 ? t + " " + o[s] : o[0],
              h = i.measureText(a).width;
          h > e && s > 0 ? (r.push({
            text: t,
            width: n
          }), t = o[s], n = i.measureText(t).width) : (n = h, t = a);
        }

        return r.push({
          text: t,
          width: n
        }), r;
      }, e.prototype._renderLines = function (t) {
        var e = this._currentMeasure.height;
        this._fontOffset || (this._fontOffset = a.Control._GetFontOffset(t.font));
        var i = 0;

        switch (this._textVerticalAlignment) {
          case a.Control.VERTICAL_ALIGNMENT_TOP:
            i = this._fontOffset.ascent;
            break;

          case a.Control.VERTICAL_ALIGNMENT_BOTTOM:
            i = e - this._fontOffset.height * (this._lines.length - 1) - this._fontOffset.descent;
            break;

          case a.Control.VERTICAL_ALIGNMENT_CENTER:
            i = this._fontOffset.ascent + (e - this._fontOffset.height * this._lines.length) / 2;
        }

        i += this._currentMeasure.top;

        for (var r = 0, o = 0; o < this._lines.length; o++) {
          var n = this._lines[o];
          0 !== o && 0 !== this._lineSpacing.internalValue && (this._lineSpacing.isPixel ? i += this._lineSpacing.getValue(this._host) : i += this._lineSpacing.getValue(this._host) * this._height.getValueInPixel(this._host, this._cachedParentMeasure.height)), this._drawText(n.text, n.width, i, t), i += this._fontOffset.height, n.width > r && (r = n.width);
        }

        this._resizeToFit && (this.width = this.paddingLeftInPixels + this.paddingRightInPixels + r + "px", this.height = this.paddingTopInPixels + this.paddingBottomInPixels + this._fontOffset.height * this._lines.length + "px");
      }, e.prototype.computeExpectedHeight = function () {
        if (this.text && this.widthInPixels) {
          var t = document.createElement("canvas").getContext("2d");

          if (t) {
            this._applyStates(t), this._fontOffset || (this._fontOffset = a.Control._GetFontOffset(t.font));
            var e = this._lines ? this._lines : this._breakLines(this.widthInPixels - this.paddingLeftInPixels - this.paddingRightInPixels, t);
            return this.paddingTopInPixels + this.paddingBottomInPixels + this._fontOffset.height * e.length;
          }
        }

        return 0;
      }, e.prototype.dispose = function () {
        t.prototype.dispose.call(this), this.onTextChangedObservable.clear();
      }, e;
    }(a.Control);

    e.TextBlock = h;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t4 = function t(e, i) {
        return (_t4 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t4(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(4),
        n = i(7),
        s = i(1),
        a = function (t) {
      function e(e) {
        var i = t.call(this, e) || this;
        return i.name = e, i._isVertical = !0, i._manualWidth = !1, i._manualHeight = !1, i._doNotTrackManualChanges = !1, i._tempMeasureStore = n.Measure.Empty(), i;
      }

      return r(e, t), Object.defineProperty(e.prototype, "isVertical", {
        get: function get() {
          return this._isVertical;
        },
        set: function set(t) {
          this._isVertical !== t && (this._isVertical = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "width", {
        get: function get() {
          return this._width.toString(this._host);
        },
        set: function set(t) {
          this._doNotTrackManualChanges || (this._manualWidth = !0), this._width.toString(this._host) !== t && this._width.fromString(t) && this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "height", {
        get: function get() {
          return this._height.toString(this._host);
        },
        set: function set(t) {
          this._doNotTrackManualChanges || (this._manualHeight = !0), this._height.toString(this._host) !== t && this._height.fromString(t) && this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._getTypeName = function () {
        return "StackPanel";
      }, e.prototype._preMeasure = function (e, i) {
        for (var r = 0, o = 0, n = 0, a = this._children; n < a.length; n++) {
          var h = a[n];
          this._tempMeasureStore.copyFrom(h._currentMeasure), h._currentMeasure.copyFrom(e), h._measure(), this._isVertical ? (h.top = o + "px", h._top.ignoreAdaptiveScaling || h._markAsDirty(), h._top.ignoreAdaptiveScaling = !0, o += h._currentMeasure.height, h._currentMeasure.width > r && (r = h._currentMeasure.width), h.verticalAlignment = s.Control.VERTICAL_ALIGNMENT_TOP) : (h.left = r + "px", h._left.ignoreAdaptiveScaling || h._markAsDirty(), h._left.ignoreAdaptiveScaling = !0, r += h._currentMeasure.width, h._currentMeasure.height > o && (o = h._currentMeasure.height), h.horizontalAlignment = s.Control.HORIZONTAL_ALIGNMENT_LEFT), h._currentMeasure.copyFrom(this._tempMeasureStore);
        }

        this._doNotTrackManualChanges = !0;
        var l,
            u,
            c = this.height,
            _ = this.width;
        this._manualHeight || (this.height = o + "px"), this._manualWidth || (this.width = r + "px"), l = _ !== this.width || !this._width.ignoreAdaptiveScaling, (u = c !== this.height || !this._height.ignoreAdaptiveScaling) && (this._height.ignoreAdaptiveScaling = !0), l && (this._width.ignoreAdaptiveScaling = !0), this._doNotTrackManualChanges = !1, (l || u) && this._markAllAsDirty(), t.prototype._preMeasure.call(this, e, i);
      }, e;
    }(o.Container);

    e.StackPanel = a;
  }, function (t, e, i) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var r = function () {
      function t(t, e, i, r) {
        this.left = t, this.top = e, this.width = i, this.height = r;
      }

      return t.prototype.copyFrom = function (t) {
        this.left = t.left, this.top = t.top, this.width = t.width, this.height = t.height;
      }, t.prototype.isEqualsTo = function (t) {
        return this.left === t.left && this.top === t.top && this.width === t.width && this.height === t.height;
      }, t.Empty = function () {
        return new t(0, 0, 0, 0);
      }, t;
    }();

    e.Measure = r;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t5 = function t(e, i) {
        return (_t5 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t5(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(3),
        n = i(0),
        s = function (t) {
      function e() {
        var e = t.call(this) || this;
        return e._columns = 10, e._rows = 0, e._rowThenColum = !0, e._orientation = o.Container3D.FACEORIGIN_ORIENTATION, e.margin = 0, e;
      }

      return r(e, t), Object.defineProperty(e.prototype, "orientation", {
        get: function get() {
          return this._orientation;
        },
        set: function set(t) {
          var e = this;
          this._orientation !== t && (this._orientation = t, n.Tools.SetImmediate(function () {
            e._arrangeChildren();
          }));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "columns", {
        get: function get() {
          return this._columns;
        },
        set: function set(t) {
          var e = this;
          this._columns !== t && (this._columns = t, this._rowThenColum = !0, n.Tools.SetImmediate(function () {
            e._arrangeChildren();
          }));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "rows", {
        get: function get() {
          return this._rows;
        },
        set: function set(t) {
          var e = this;
          this._rows !== t && (this._rows = t, this._rowThenColum = !1, n.Tools.SetImmediate(function () {
            e._arrangeChildren();
          }));
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._arrangeChildren = function () {
        this._cellWidth = 0, this._cellHeight = 0;

        for (var t = 0, e = 0, i = 0, r = n.Matrix.Invert(this.node.computeWorldMatrix(!0)), o = 0, s = this._children; o < s.length; o++) {
          if ((b = s[o]).mesh) {
            i++, b.mesh.computeWorldMatrix(!0);
            var a = b.mesh.getHierarchyBoundingVectors(),
                h = n.Tmp.Vector3[0],
                l = n.Tmp.Vector3[1];
            a.max.subtractToRef(a.min, l), l.scaleInPlace(.5), n.Vector3.TransformNormalToRef(l, r, h), this._cellWidth = Math.max(this._cellWidth, 2 * h.x), this._cellHeight = Math.max(this._cellHeight, 2 * h.y);
          }
        }

        this._cellWidth += 2 * this.margin, this._cellHeight += 2 * this.margin, this._rowThenColum ? (e = this._columns, t = Math.ceil(i / this._columns)) : (t = this._rows, e = Math.ceil(i / this._rows));
        var u = .5 * e * this._cellWidth,
            c = .5 * t * this._cellHeight,
            _ = [],
            f = 0;
        if (this._rowThenColum) for (var p = 0; p < t; p++) {
          for (var d = 0; d < e && (_.push(new n.Vector3(d * this._cellWidth - u + this._cellWidth / 2, p * this._cellHeight - c + this._cellHeight / 2, 0)), !(++f > i)); d++) {
            ;
          }
        } else for (d = 0; d < e; d++) {
          for (p = 0; p < t && (_.push(new n.Vector3(d * this._cellWidth - u + this._cellWidth / 2, p * this._cellHeight - c + this._cellHeight / 2, 0)), !(++f > i)); p++) {
            ;
          }
        }
        f = 0;

        for (var y = 0, g = this._children; y < g.length; y++) {
          var b;
          (b = g[y]).mesh && (this._mapGridNode(b, _[f]), f++);
        }

        this._finalProcessing();
      }, e.prototype._finalProcessing = function () {}, e;
    }(o.Container3D);

    e.VolumeBasedPanel = s;
  }, function (t, e, i) {
    "use strict";

    function r(t) {
      for (var i in t) {
        e.hasOwnProperty(i) || (e[i] = t[i]);
      }
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), r(i(16)), r(i(18)), r(i(30)), r(i(4)), r(i(1)), r(i(31)), r(i(32)), r(i(11)), r(i(19)), r(i(33)), r(i(34)), r(i(35)), r(i(21)), r(i(6)), r(i(36)), r(i(5)), r(i(37)), r(i(22)), r(i(10)), r(i(38)), r(i(39));
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t6 = function t(e, i) {
        return (_t6 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t6(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = function (t) {
      function e(e) {
        var i = t.call(this, e) || this;
        return i.name = e, i._thickness = 1, i._cornerRadius = 0, i;
      }

      return r(e, t), Object.defineProperty(e.prototype, "thickness", {
        get: function get() {
          return this._thickness;
        },
        set: function set(t) {
          this._thickness !== t && (this._thickness = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "cornerRadius", {
        get: function get() {
          return this._cornerRadius;
        },
        set: function set(t) {
          t < 0 && (t = 0), this._cornerRadius !== t && (this._cornerRadius = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._getTypeName = function () {
        return "Rectangle";
      }, e.prototype._localDraw = function (t) {
        t.save(), (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (t.shadowColor = this.shadowColor, t.shadowBlur = this.shadowBlur, t.shadowOffsetX = this.shadowOffsetX, t.shadowOffsetY = this.shadowOffsetY), this._background && (t.fillStyle = this._background, this._cornerRadius ? (this._drawRoundedRect(t, this._thickness / 2), t.fill()) : t.fillRect(this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height)), this._thickness && ((this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (t.shadowBlur = 0, t.shadowOffsetX = 0, t.shadowOffsetY = 0), this.color && (t.strokeStyle = this.color), t.lineWidth = this._thickness, this._cornerRadius ? (this._drawRoundedRect(t, this._thickness / 2), t.stroke()) : t.strokeRect(this._currentMeasure.left + this._thickness / 2, this._currentMeasure.top + this._thickness / 2, this._currentMeasure.width - this._thickness, this._currentMeasure.height - this._thickness)), t.restore();
      }, e.prototype._additionalProcessing = function (e, i) {
        t.prototype._additionalProcessing.call(this, e, i), this._measureForChildren.width -= 2 * this._thickness, this._measureForChildren.height -= 2 * this._thickness, this._measureForChildren.left += this._thickness, this._measureForChildren.top += this._thickness;
      }, e.prototype._drawRoundedRect = function (t, e) {
        void 0 === e && (e = 0);
        var i = this._currentMeasure.left + e,
            r = this._currentMeasure.top + e,
            o = this._currentMeasure.width - 2 * e,
            n = this._currentMeasure.height - 2 * e,
            s = Math.min(n / 2 - 2, Math.min(o / 2 - 2, this._cornerRadius));
        t.beginPath(), t.moveTo(i + s, r), t.lineTo(i + o - s, r), t.quadraticCurveTo(i + o, r, i + o, r + s), t.lineTo(i + o, r + n - s), t.quadraticCurveTo(i + o, r + n, i + o - s, r + n), t.lineTo(i + s, r + n), t.quadraticCurveTo(i, r + n, i, r + n - s), t.lineTo(i, r + s), t.quadraticCurveTo(i, r, i + s, r), t.closePath();
      }, e.prototype._clipForChildren = function (t) {
        this._cornerRadius && (this._drawRoundedRect(t, this._thickness), t.clip());
      }, e;
    }(i(4).Container);

    e.Rectangle = o;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t7 = function t(e, i) {
        return (_t7 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t7(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(1),
        n = i(0),
        s = function (t) {
      function e(i, r) {
        void 0 === r && (r = null);
        var o = t.call(this, i) || this;
        return o.name = i, o._loaded = !1, o._stretch = e.STRETCH_FILL, o._autoScale = !1, o._sourceLeft = 0, o._sourceTop = 0, o._sourceWidth = 0, o._sourceHeight = 0, o._cellWidth = 0, o._cellHeight = 0, o._cellId = -1, o.source = r, o;
      }

      return r(e, t), Object.defineProperty(e.prototype, "sourceLeft", {
        get: function get() {
          return this._sourceLeft;
        },
        set: function set(t) {
          this._sourceLeft !== t && (this._sourceLeft = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "sourceTop", {
        get: function get() {
          return this._sourceTop;
        },
        set: function set(t) {
          this._sourceTop !== t && (this._sourceTop = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "sourceWidth", {
        get: function get() {
          return this._sourceWidth;
        },
        set: function set(t) {
          this._sourceWidth !== t && (this._sourceWidth = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "sourceHeight", {
        get: function get() {
          return this._sourceHeight;
        },
        set: function set(t) {
          this._sourceHeight !== t && (this._sourceHeight = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "autoScale", {
        get: function get() {
          return this._autoScale;
        },
        set: function set(t) {
          this._autoScale !== t && (this._autoScale = t, t && this._loaded && this.synchronizeSizeWithContent());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "stretch", {
        get: function get() {
          return this._stretch;
        },
        set: function set(t) {
          this._stretch !== t && (this._stretch = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "domImage", {
        get: function get() {
          return this._domImage;
        },
        set: function set(t) {
          var e = this;
          this._domImage = t, this._loaded = !1, this._domImage.width ? this._onImageLoaded() : this._domImage.onload = function () {
            e._onImageLoaded();
          };
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._onImageLoaded = function () {
        this._imageWidth = this._domImage.width, this._imageHeight = this._domImage.height, this._loaded = !0, this._autoScale && this.synchronizeSizeWithContent(), this._markAsDirty();
      }, Object.defineProperty(e.prototype, "source", {
        set: function set(t) {
          var e = this;
          this._source !== t && (this._loaded = !1, this._source = t, this._domImage = document.createElement("img"), this._domImage.onload = function () {
            e._onImageLoaded();
          }, t && (n.Tools.SetCorsBehavior(t, this._domImage), this._domImage.src = t));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "cellWidth", {
        get: function get() {
          return this._cellWidth;
        },
        set: function set(t) {
          this._cellWidth !== t && (this._cellWidth = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "cellHeight", {
        get: function get() {
          return this._cellHeight;
        },
        set: function set(t) {
          this._cellHeight !== t && (this._cellHeight = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "cellId", {
        get: function get() {
          return this._cellId;
        },
        set: function set(t) {
          this._cellId !== t && (this._cellId = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._getTypeName = function () {
        return "Image";
      }, e.prototype.synchronizeSizeWithContent = function () {
        this._loaded && (this.width = this._domImage.width + "px", this.height = this._domImage.height + "px");
      }, e.prototype._draw = function (t, i) {
        var r, o, n, s;
        if (i.save(), (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (i.shadowColor = this.shadowColor, i.shadowBlur = this.shadowBlur, i.shadowOffsetX = this.shadowOffsetX, i.shadowOffsetY = this.shadowOffsetY), -1 == this.cellId) r = this._sourceLeft, o = this._sourceTop, n = this._sourceWidth ? this._sourceWidth : this._imageWidth, s = this._sourceHeight ? this._sourceHeight : this._imageHeight;else {
          var a = this._domImage.naturalWidth / this.cellWidth,
              h = this.cellId / a >> 0,
              l = this.cellId % a;
          r = this.cellWidth * l, o = this.cellHeight * h, n = this.cellWidth, s = this.cellHeight;
        }
        if (this._applyStates(i), this._processMeasures(t, i) && this._loaded) switch (this._stretch) {
          case e.STRETCH_NONE:
          case e.STRETCH_FILL:
            i.drawImage(this._domImage, r, o, n, s, this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height);
            break;

          case e.STRETCH_UNIFORM:
            var u = this._currentMeasure.width / n,
                c = this._currentMeasure.height / s,
                _ = Math.min(u, c),
                f = (this._currentMeasure.width - n * _) / 2,
                p = (this._currentMeasure.height - s * _) / 2;

            i.drawImage(this._domImage, r, o, n, s, this._currentMeasure.left + f, this._currentMeasure.top + p, n * _, s * _);
            break;

          case e.STRETCH_EXTEND:
            i.drawImage(this._domImage, r, o, n, s, this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height), this._autoScale && this.synchronizeSizeWithContent(), this._root && this._root.parent && (this._root.width = this.width, this._root.height = this.height);
        }
        i.restore();
      }, e.STRETCH_NONE = 0, e.STRETCH_FILL = 1, e.STRETCH_UNIFORM = 2, e.STRETCH_EXTEND = 3, e;
    }(o.Control);

    e.Image = s;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t8 = function t(e, i) {
        return (_t8 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t8(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(0),
        n = i(4),
        s = i(23),
        a = i(7),
        h = function (t) {
      function e(e, i, r, s, a, h) {
        void 0 === i && (i = 0), void 0 === r && (r = 0), void 0 === a && (a = !1), void 0 === h && (h = o.Texture.NEAREST_SAMPLINGMODE);
        var l = t.call(this, e, {
          width: i,
          height: r
        }, s, a, h, o.Engine.TEXTUREFORMAT_RGBA) || this;
        return l._isDirty = !1, l._rootContainer = new n.Container("root"), l._lastControlOver = {}, l._lastControlDown = {}, l._capturingControl = {}, l._linkedControls = new Array(), l._isFullscreen = !1, l._fullscreenViewport = new o.Viewport(0, 0, 1, 1), l._idealWidth = 0, l._idealHeight = 0, l._useSmallestIdeal = !1, l._renderAtIdealSize = !1, l._blockNextFocusCheck = !1, l._renderScale = 1, l.premulAlpha = !1, (s = l.getScene()) && l._texture ? (l._rootCanvas = s.getEngine().getRenderingCanvas(), l._renderObserver = s.onBeforeCameraRenderObservable.add(function (t) {
          return l._checkUpdate(t);
        }), l._preKeyboardObserver = s.onPreKeyboardObservable.add(function (t) {
          l._focusedControl && (t.type === o.KeyboardEventTypes.KEYDOWN && l._focusedControl.processKeyboard(t.event), t.skipOnPointerObservable = !0);
        }), l._rootContainer._link(null, l), l.hasAlpha = !0, i && r || (l._resizeObserver = s.getEngine().onResizeObservable.add(function () {
          return l._onResize();
        }), l._onResize()), l._texture.isReady = !0, l) : l;
      }

      return r(e, t), Object.defineProperty(e.prototype, "renderScale", {
        get: function get() {
          return this._renderScale;
        },
        set: function set(t) {
          t !== this._renderScale && (this._renderScale = t, this._onResize());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "background", {
        get: function get() {
          return this._background;
        },
        set: function set(t) {
          this._background !== t && (this._background = t, this.markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "idealWidth", {
        get: function get() {
          return this._idealWidth;
        },
        set: function set(t) {
          this._idealWidth !== t && (this._idealWidth = t, this.markAsDirty(), this._rootContainer._markAllAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "idealHeight", {
        get: function get() {
          return this._idealHeight;
        },
        set: function set(t) {
          this._idealHeight !== t && (this._idealHeight = t, this.markAsDirty(), this._rootContainer._markAllAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "useSmallestIdeal", {
        get: function get() {
          return this._useSmallestIdeal;
        },
        set: function set(t) {
          this._useSmallestIdeal !== t && (this._useSmallestIdeal = t, this.markAsDirty(), this._rootContainer._markAllAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "renderAtIdealSize", {
        get: function get() {
          return this._renderAtIdealSize;
        },
        set: function set(t) {
          this._renderAtIdealSize !== t && (this._renderAtIdealSize = t, this._onResize());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "layer", {
        get: function get() {
          return this._layerToDispose;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "rootContainer", {
        get: function get() {
          return this._rootContainer;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "focusedControl", {
        get: function get() {
          return this._focusedControl;
        },
        set: function set(t) {
          this._focusedControl != t && (this._focusedControl && this._focusedControl.onBlur(), t && t.onFocus(), this._focusedControl = t);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "isForeground", {
        get: function get() {
          return !this.layer || !this.layer.isBackground;
        },
        set: function set(t) {
          this.layer && this.layer.isBackground !== !t && (this.layer.isBackground = !t);
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.executeOnAllControls = function (t, e) {
        e || (e = this._rootContainer), t(e);

        for (var i = 0, r = e.children; i < r.length; i++) {
          var o = r[i];
          o.children ? this.executeOnAllControls(t, o) : t(o);
        }
      }, e.prototype.markAsDirty = function () {
        this._isDirty = !0;
      }, e.prototype.createStyle = function () {
        return new s.Style(this);
      }, e.prototype.addControl = function (t) {
        return this._rootContainer.addControl(t), this;
      }, e.prototype.removeControl = function (t) {
        return this._rootContainer.removeControl(t), this;
      }, e.prototype.dispose = function () {
        var e = this.getScene();
        e && (this._rootCanvas = null, e.onBeforeCameraRenderObservable.remove(this._renderObserver), this._resizeObserver && e.getEngine().onResizeObservable.remove(this._resizeObserver), this._pointerMoveObserver && e.onPrePointerObservable.remove(this._pointerMoveObserver), this._pointerObserver && e.onPointerObservable.remove(this._pointerObserver), this._preKeyboardObserver && e.onPreKeyboardObservable.remove(this._preKeyboardObserver), this._canvasPointerOutObserver && e.getEngine().onCanvasPointerOutObservable.remove(this._canvasPointerOutObserver), this._layerToDispose && (this._layerToDispose.texture = null, this._layerToDispose.dispose(), this._layerToDispose = null), this._rootContainer.dispose(), t.prototype.dispose.call(this));
      }, e.prototype._onResize = function () {
        var t = this.getScene();

        if (t) {
          var e = t.getEngine(),
              i = this.getSize(),
              r = e.getRenderWidth() * this._renderScale,
              o = e.getRenderHeight() * this._renderScale;

          this._renderAtIdealSize && (this._idealWidth ? (o = o * this._idealWidth / r, r = this._idealWidth) : this._idealHeight && (r = r * this._idealHeight / o, o = this._idealHeight)), i.width === r && i.height === o || (this.scaleTo(r, o), this.markAsDirty(), (this._idealWidth || this._idealHeight) && this._rootContainer._markAllAsDirty());
        }
      }, e.prototype._getGlobalViewport = function (t) {
        var e = t.getEngine();
        return this._fullscreenViewport.toGlobal(e.getRenderWidth(), e.getRenderHeight());
      }, e.prototype.getProjectedPosition = function (t, e) {
        var i = this.getScene();
        if (!i) return o.Vector2.Zero();

        var r = this._getGlobalViewport(i),
            n = o.Vector3.Project(t, e, i.getTransformMatrix(), r);

        return n.scaleInPlace(this.renderScale), new o.Vector2(n.x, n.y);
      }, e.prototype._checkUpdate = function (t) {
        if (!this._layerToDispose || 0 != (t.layerMask & this._layerToDispose.layerMask)) {
          if (this._isFullscreen && this._linkedControls.length) {
            var e = this.getScene();
            if (!e) return;

            for (var i = this._getGlobalViewport(e), r = 0, n = this._linkedControls; r < n.length; r++) {
              var s = n[r];

              if (s.isVisible) {
                var a = s._linkedMesh;

                if (a && !a.isDisposed()) {
                  var h = a.getBoundingInfo().boundingSphere.center,
                      l = o.Vector3.Project(h, a.getWorldMatrix(), e.getTransformMatrix(), i);
                  l.z < 0 || l.z > 1 ? s.notRenderable = !0 : (s.notRenderable = !1, l.scaleInPlace(this.renderScale), s._moveToProjectedPosition(l));
                } else o.Tools.SetImmediate(function () {
                  s.linkWithMesh(null);
                });
              }
            }
          }

          (this._isDirty || this._rootContainer.isDirty) && (this._isDirty = !1, this._render(), this.update(!0, this.premulAlpha));
        }
      }, e.prototype._render = function () {
        var t = this.getSize(),
            e = t.width,
            i = t.height,
            r = this.getContext();
        r.clearRect(0, 0, e, i), this._background && (r.save(), r.fillStyle = this._background, r.fillRect(0, 0, e, i), r.restore()), r.font = "18px Arial", r.strokeStyle = "white";
        var o = new a.Measure(0, 0, e, i);

        this._rootContainer._draw(o, r);
      }, e.prototype._changeCursor = function (t) {
        this._rootCanvas && (this._rootCanvas.style.cursor = t);
      }, e.prototype._doPicking = function (t, e, i, r, n) {
        var s = this.getScene();

        if (s) {
          var a = s.getEngine(),
              h = this.getSize();
          this._isFullscreen && (t *= h.width / a.getRenderWidth(), e *= h.height / a.getRenderHeight()), this._capturingControl[r] ? this._capturingControl[r]._processObservables(i, t, e, r, n) : (this._rootContainer._processPicking(t, e, i, r, n) || (this._changeCursor(""), i === o.PointerEventTypes.POINTERMOVE && (this._lastControlOver[r] && this._lastControlOver[r]._onPointerOut(this._lastControlOver[r]), delete this._lastControlOver[r])), this._manageFocus());
        }
      }, e.prototype._cleanControlAfterRemovalFromList = function (t, e) {
        for (var i in t) {
          if (t.hasOwnProperty(i)) t[i] === e && delete t[i];
        }
      }, e.prototype._cleanControlAfterRemoval = function (t) {
        this._cleanControlAfterRemovalFromList(this._lastControlDown, t), this._cleanControlAfterRemovalFromList(this._lastControlOver, t);
      }, e.prototype.attach = function () {
        var t = this,
            e = this.getScene();
        e && (this._pointerMoveObserver = e.onPrePointerObservable.add(function (i, r) {
          if (!e.isPointerCaptured(i.event.pointerId) && (i.type === o.PointerEventTypes.POINTERMOVE || i.type === o.PointerEventTypes.POINTERUP || i.type === o.PointerEventTypes.POINTERDOWN) && e) {
            var n = e.cameraToUseForPointers || e.activeCamera;

            if (n) {
              var s = e.getEngine(),
                  a = n.viewport,
                  h = (e.pointerX / s.getHardwareScalingLevel() - a.x * s.getRenderWidth()) / a.width,
                  l = (e.pointerY / s.getHardwareScalingLevel() - a.y * s.getRenderHeight()) / a.height;
              t._shouldBlockPointer = !1, t._doPicking(h, l, i.type, i.event.pointerId || 0, i.event.button), t._shouldBlockPointer && (i.skipOnPointerObservable = t._shouldBlockPointer);
            }
          }
        }), this._attachToOnPointerOut(e));
      }, e.prototype.attachToMesh = function (t, e) {
        var i = this;
        void 0 === e && (e = !0);
        var r = this.getScene();
        r && (this._pointerObserver = r.onPointerObservable.add(function (e, r) {
          if (e.type === o.PointerEventTypes.POINTERMOVE || e.type === o.PointerEventTypes.POINTERUP || e.type === o.PointerEventTypes.POINTERDOWN) {
            var n = e.event.pointerId || 0;

            if (e.pickInfo && e.pickInfo.hit && e.pickInfo.pickedMesh === t) {
              var s = e.pickInfo.getTextureCoordinates();

              if (s) {
                var a = i.getSize();

                i._doPicking(s.x * a.width, (1 - s.y) * a.height, e.type, n, e.event.button);
              }
            } else if (e.type === o.PointerEventTypes.POINTERUP) {
              if (i._lastControlDown[n] && i._lastControlDown[n]._forcePointerUp(n), delete i._lastControlDown[n], i.focusedControl) {
                var h = i.focusedControl.keepsFocusWith(),
                    l = !0;
                if (h) for (var u = 0, c = h; u < c.length; u++) {
                  var _ = c[u];

                  if (i !== _._host) {
                    var f = _._host;

                    if (f._lastControlOver[n] && f._lastControlOver[n].isAscendant(_)) {
                      l = !1;
                      break;
                    }
                  }
                }
                l && (i.focusedControl = null);
              }
            } else e.type === o.PointerEventTypes.POINTERMOVE && (i._lastControlOver[n] && i._lastControlOver[n]._onPointerOut(i._lastControlOver[n]), delete i._lastControlOver[n]);
          }
        }), t.enablePointerMoveEvents = e, this._attachToOnPointerOut(r));
      }, e.prototype.moveFocusToControl = function (t) {
        this.focusedControl = t, this._lastPickedControl = t, this._blockNextFocusCheck = !0;
      }, e.prototype._manageFocus = function () {
        if (this._blockNextFocusCheck) return this._blockNextFocusCheck = !1, void (this._lastPickedControl = this._focusedControl);

        if (this._focusedControl && this._focusedControl !== this._lastPickedControl) {
          if (this._lastPickedControl.isFocusInvisible) return;
          this.focusedControl = null;
        }
      }, e.prototype._attachToOnPointerOut = function (t) {
        var e = this;
        this._canvasPointerOutObserver = t.getEngine().onCanvasPointerOutObservable.add(function (t) {
          e._lastControlOver[t.pointerId] && e._lastControlOver[t.pointerId]._onPointerOut(e._lastControlOver[t.pointerId]), delete e._lastControlOver[t.pointerId], e._lastControlDown[t.pointerId] && e._lastControlDown[t.pointerId]._forcePointerUp(), delete e._lastControlDown[t.pointerId];
        });
      }, e.CreateForMesh = function (t, i, r, n, s) {
        void 0 === i && (i = 1024), void 0 === r && (r = 1024), void 0 === n && (n = !0), void 0 === s && (s = !1);
        var a = new e(t.name + " AdvancedDynamicTexture", i, r, t.getScene(), !0, o.Texture.TRILINEAR_SAMPLINGMODE),
            h = new o.StandardMaterial("AdvancedDynamicTextureMaterial", t.getScene());
        return h.backFaceCulling = !1, h.diffuseColor = o.Color3.Black(), h.specularColor = o.Color3.Black(), s ? (h.diffuseTexture = a, h.emissiveTexture = a, a.hasAlpha = !0) : (h.emissiveTexture = a, h.opacityTexture = a), t.material = h, a.attachToMesh(t, n), a;
      }, e.CreateFullscreenUI = function (t, i, r, n) {
        void 0 === i && (i = !0), void 0 === r && (r = null), void 0 === n && (n = o.Texture.BILINEAR_SAMPLINGMODE);
        var s = new e(t, 0, 0, r, !1, n),
            a = new o.Layer(t + "_layer", null, r, !i);
        return a.texture = s, s._layerToDispose = a, s._isFullscreen = !0, s.attach(), s;
      }, e;
    }(o.DynamicTexture);

    e.AdvancedDynamicTexture = h;
  }, function (t, e, i) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var r = i(0),
        o = i(25),
        n = function () {
      function t(t) {
        this.name = t, this._downCount = 0, this._enterCount = -1, this._downPointerIds = {}, this._isVisible = !0, this.onPointerMoveObservable = new r.Observable(), this.onPointerOutObservable = new r.Observable(), this.onPointerDownObservable = new r.Observable(), this.onPointerUpObservable = new r.Observable(), this.onPointerClickObservable = new r.Observable(), this.onPointerEnterObservable = new r.Observable(), this._behaviors = new Array();
      }

      return Object.defineProperty(t.prototype, "position", {
        get: function get() {
          return this._node ? this._node.position : r.Vector3.Zero();
        },
        set: function set(t) {
          this._node && (this._node.position = t);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "scaling", {
        get: function get() {
          return this._node ? this._node.scaling : new r.Vector3(1, 1, 1);
        },
        set: function set(t) {
          this._node && (this._node.scaling = t);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "behaviors", {
        get: function get() {
          return this._behaviors;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.addBehavior = function (t) {
        var e = this;
        if (-1 !== this._behaviors.indexOf(t)) return this;
        t.init();
        var i = this._host.scene;
        return i.isLoading ? i.onDataLoadedObservable.addOnce(function () {
          t.attach(e);
        }) : t.attach(this), this._behaviors.push(t), this;
      }, t.prototype.removeBehavior = function (t) {
        var e = this._behaviors.indexOf(t);

        return -1 === e ? this : (this._behaviors[e].detach(), this._behaviors.splice(e, 1), this);
      }, t.prototype.getBehaviorByName = function (t) {
        for (var e = 0, i = this._behaviors; e < i.length; e++) {
          var r = i[e];
          if (r.name === t) return r;
        }

        return null;
      }, Object.defineProperty(t.prototype, "isVisible", {
        get: function get() {
          return this._isVisible;
        },
        set: function set(t) {
          if (this._isVisible !== t) {
            this._isVisible = t;
            var e = this.mesh;
            e && e.setEnabled(t);
          }
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "typeName", {
        get: function get() {
          return this._getTypeName();
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype._getTypeName = function () {
        return "Control3D";
      }, Object.defineProperty(t.prototype, "node", {
        get: function get() {
          return this._node;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "mesh", {
        get: function get() {
          return this._node instanceof r.AbstractMesh ? this._node : null;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.linkToTransformNode = function (t) {
        return this._node && (this._node.parent = t), this;
      }, t.prototype._prepareNode = function (t) {
        if (!this._node) {
          if (this._node = this._createNode(t), !this.node) return;
          this._node.metadata = this, this._node.position = this.position, this._node.scaling = this.scaling;
          var e = this.mesh;
          e && (e.isPickable = !0, this._affectMaterial(e));
        }
      }, t.prototype._createNode = function (t) {
        return null;
      }, t.prototype._affectMaterial = function (t) {
        t.material = null;
      }, t.prototype._onPointerMove = function (t, e) {
        this.onPointerMoveObservable.notifyObservers(e, -1, t, this);
      }, t.prototype._onPointerEnter = function (t) {
        return !(this._enterCount > 0) && (-1 === this._enterCount && (this._enterCount = 0), this._enterCount++, this.onPointerEnterObservable.notifyObservers(this, -1, t, this), this.pointerEnterAnimation && this.pointerEnterAnimation(), !0);
      }, t.prototype._onPointerOut = function (t) {
        this._enterCount = 0, this.onPointerOutObservable.notifyObservers(this, -1, t, this), this.pointerOutAnimation && this.pointerOutAnimation();
      }, t.prototype._onPointerDown = function (t, e, i, r) {
        return 0 === this._downCount && (this._downCount++, this._downPointerIds[i] = !0, this.onPointerDownObservable.notifyObservers(new o.Vector3WithInfo(e, r), -1, t, this), this.pointerDownAnimation && this.pointerDownAnimation(), !0);
      }, t.prototype._onPointerUp = function (t, e, i, r, n) {
        this._downCount = 0, delete this._downPointerIds[i], n && (this._enterCount > 0 || -1 === this._enterCount) && this.onPointerClickObservable.notifyObservers(new o.Vector3WithInfo(e, r), -1, t, this), this.onPointerUpObservable.notifyObservers(new o.Vector3WithInfo(e, r), -1, t, this), this.pointerUpAnimation && this.pointerUpAnimation();
      }, t.prototype.forcePointerUp = function (t) {
        if (void 0 === t && (t = null), null !== t) this._onPointerUp(this, r.Vector3.Zero(), t, 0, !0);else for (var e in this._downPointerIds) {
          this._onPointerUp(this, r.Vector3.Zero(), +e, 0, !0);
        }
      }, t.prototype._processObservables = function (t, e, i, o) {
        if (t === r.PointerEventTypes.POINTERMOVE) {
          this._onPointerMove(this, e);

          var n = this._host._lastControlOver[i];
          return n && n !== this && n._onPointerOut(this), n !== this && this._onPointerEnter(this), this._host._lastControlOver[i] = this, !0;
        }

        return t === r.PointerEventTypes.POINTERDOWN ? (this._onPointerDown(this, e, i, o), this._host._lastControlDown[i] = this, this._host._lastPickedControl = this, !0) : t === r.PointerEventTypes.POINTERUP && (this._host._lastControlDown[i] && this._host._lastControlDown[i]._onPointerUp(this, e, i, o, !0), delete this._host._lastControlDown[i], !0);
      }, t.prototype._disposeNode = function () {
        this._node && (this._node.dispose(), this._node = null);
      }, t.prototype.dispose = function () {
        this.onPointerDownObservable.clear(), this.onPointerEnterObservable.clear(), this.onPointerMoveObservable.clear(), this.onPointerOutObservable.clear(), this.onPointerUpObservable.clear(), this.onPointerClickObservable.clear(), this._disposeNode();

        for (var t = 0, e = this._behaviors; t < e.length; t++) {
          e[t].detach();
        }
      }, t;
    }();

    e.Control3D = n;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t9 = function t(e, i) {
        return (_t9 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t9(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(24),
        n = i(0),
        s = i(12),
        a = function (t) {
      function e(e) {
        var i = t.call(this, e) || this;
        return i._contentResolution = 512, i._contentScaleRatio = 2, i.pointerEnterAnimation = function () {
          i.mesh && (i._currentMaterial.emissiveColor = n.Color3.Red());
        }, i.pointerOutAnimation = function () {
          i._currentMaterial.emissiveColor = n.Color3.Black();
        }, i.pointerDownAnimation = function () {
          i.mesh && i.mesh.scaling.scaleInPlace(.95);
        }, i.pointerUpAnimation = function () {
          i.mesh && i.mesh.scaling.scaleInPlace(1 / .95);
        }, i;
      }

      return r(e, t), Object.defineProperty(e.prototype, "contentResolution", {
        get: function get() {
          return this._contentResolution;
        },
        set: function set(t) {
          this._contentResolution !== t && (this._contentResolution = t, this._resetContent());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "contentScaleRatio", {
        get: function get() {
          return this._contentScaleRatio;
        },
        set: function set(t) {
          this._contentScaleRatio !== t && (this._contentScaleRatio = t, this._resetContent());
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._disposeFacadeTexture = function () {
        this._facadeTexture && (this._facadeTexture.dispose(), this._facadeTexture = null);
      }, e.prototype._resetContent = function () {
        this._disposeFacadeTexture(), this.content = this._content;
      }, Object.defineProperty(e.prototype, "content", {
        get: function get() {
          return this._content;
        },
        set: function set(t) {
          this._content = t, this._host && this._host.utilityLayer && (this._facadeTexture || (this._facadeTexture = new s.AdvancedDynamicTexture("Facade", this._contentResolution, this._contentResolution, this._host.utilityLayer.utilityLayerScene, !0, n.Texture.TRILINEAR_SAMPLINGMODE), this._facadeTexture.rootContainer.scaleX = this._contentScaleRatio, this._facadeTexture.rootContainer.scaleY = this._contentScaleRatio, this._facadeTexture.premulAlpha = !0), this._facadeTexture.addControl(t), this._applyFacade(this._facadeTexture));
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._applyFacade = function (t) {
        this._currentMaterial.emissiveTexture = t;
      }, e.prototype._getTypeName = function () {
        return "Button3D";
      }, e.prototype._createNode = function (t) {
        for (var e = new Array(6), i = 0; i < 6; i++) {
          e[i] = new n.Vector4(0, 0, 0, 0);
        }

        return e[1] = new n.Vector4(0, 0, 1, 1), n.MeshBuilder.CreateBox(this.name + "_rootMesh", {
          width: 1,
          height: 1,
          depth: .08,
          faceUV: e
        }, t);
      }, e.prototype._affectMaterial = function (t) {
        var e = new n.StandardMaterial(this.name + "Material", t.getScene());
        e.specularColor = n.Color3.Black(), t.material = e, this._currentMaterial = e, this._resetContent();
      }, e.prototype.dispose = function () {
        t.prototype.dispose.call(this), this._disposeFacadeTexture(), this._currentMaterial && this._currentMaterial.dispose();
      }, e;
    }(o.AbstractButton3D);

    e.Button3D = a;
  }, function (t, e, i) {
    "use strict";

    function r(t) {
      for (var i in t) {
        e.hasOwnProperty(i) || (e[i] = t[i]);
      }
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), r(i(29)), r(i(40));
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t10 = function t(e, i) {
        return (_t10 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t10(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(10),
        n = i(1),
        s = i(5),
        a = i(11),
        h = function (t) {
      function e(e) {
        var i = t.call(this, e) || this;
        return i.name = e, i.thickness = 1, i.isPointerBlocker = !0, i.pointerEnterAnimation = function () {
          i.alpha -= .1;
        }, i.pointerOutAnimation = function () {
          i.alpha += .1;
        }, i.pointerDownAnimation = function () {
          i.scaleX -= .05, i.scaleY -= .05;
        }, i.pointerUpAnimation = function () {
          i.scaleX += .05, i.scaleY += .05;
        }, i;
      }

      return r(e, t), e.prototype._getTypeName = function () {
        return "Button";
      }, e.prototype._processPicking = function (e, i, r, o, n) {
        return !(!this.isHitTestVisible || !this.isVisible || this.notRenderable) && !!t.prototype.contains.call(this, e, i) && (this._processObservables(r, e, i, o, n), !0);
      }, e.prototype._onPointerEnter = function (e) {
        return !!t.prototype._onPointerEnter.call(this, e) && (this.pointerEnterAnimation && this.pointerEnterAnimation(), !0);
      }, e.prototype._onPointerOut = function (e) {
        this.pointerOutAnimation && this.pointerOutAnimation(), t.prototype._onPointerOut.call(this, e);
      }, e.prototype._onPointerDown = function (e, i, r, o) {
        return !!t.prototype._onPointerDown.call(this, e, i, r, o) && (this.pointerDownAnimation && this.pointerDownAnimation(), !0);
      }, e.prototype._onPointerUp = function (e, i, r, o, n) {
        this.pointerUpAnimation && this.pointerUpAnimation(), t.prototype._onPointerUp.call(this, e, i, r, o, n);
      }, e.CreateImageButton = function (t, i, r) {
        var o = new e(t),
            h = new s.TextBlock(t + "_button", i);
        h.textWrapping = !0, h.textHorizontalAlignment = n.Control.HORIZONTAL_ALIGNMENT_CENTER, h.paddingLeft = "20%", o.addControl(h);
        var l = new a.Image(t + "_icon", r);
        return l.width = "20%", l.stretch = a.Image.STRETCH_UNIFORM, l.horizontalAlignment = n.Control.HORIZONTAL_ALIGNMENT_LEFT, o.addControl(l), o;
      }, e.CreateImageOnlyButton = function (t, i) {
        var r = new e(t),
            o = new a.Image(t + "_icon", i);
        return o.stretch = a.Image.STRETCH_FILL, o.horizontalAlignment = n.Control.HORIZONTAL_ALIGNMENT_LEFT, r.addControl(o), r;
      }, e.CreateSimpleButton = function (t, i) {
        var r = new e(t),
            o = new s.TextBlock(t + "_button", i);
        return o.textWrapping = !0, o.textHorizontalAlignment = n.Control.HORIZONTAL_ALIGNMENT_CENTER, r.addControl(o), r;
      }, e.CreateImageWithCenterTextButton = function (t, i, r) {
        var o = new e(t),
            h = new a.Image(t + "_icon", r);
        h.stretch = a.Image.STRETCH_FILL, o.addControl(h);
        var l = new s.TextBlock(t + "_button", i);
        return l.textWrapping = !0, l.textHorizontalAlignment = n.Control.HORIZONTAL_ALIGNMENT_CENTER, o.addControl(l), o;
      }, e;
    }(o.Rectangle);

    e.Button = h;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t11 = function t(e, i) {
        return (_t11 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t11(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(0),
        n = function (t) {
      function e(e, i) {
        void 0 === i && (i = 0);
        var r = t.call(this, e.x, e.y) || this;
        return r.buttonIndex = i, r;
      }

      return r(e, t), e;
    }(o.Vector2);

    e.Vector2WithInfo = n;

    var s = function () {
      function t(t, e, i, r, o, n) {
        this.m = new Float32Array(6), this.fromValues(t, e, i, r, o, n);
      }

      return t.prototype.fromValues = function (t, e, i, r, o, n) {
        return this.m[0] = t, this.m[1] = e, this.m[2] = i, this.m[3] = r, this.m[4] = o, this.m[5] = n, this;
      }, t.prototype.determinant = function () {
        return this.m[0] * this.m[3] - this.m[1] * this.m[2];
      }, t.prototype.invertToRef = function (t) {
        var e = this.m[0],
            i = this.m[1],
            r = this.m[2],
            n = this.m[3],
            s = this.m[4],
            a = this.m[5],
            h = this.determinant();
        if (h < o.Epsilon * o.Epsilon) return t.m[0] = 0, t.m[1] = 0, t.m[2] = 0, t.m[3] = 0, t.m[4] = 0, t.m[5] = 0, this;
        var l = 1 / h,
            u = r * a - n * s,
            c = i * s - e * a;
        return t.m[0] = n * l, t.m[1] = -i * l, t.m[2] = -r * l, t.m[3] = e * l, t.m[4] = u * l, t.m[5] = c * l, this;
      }, t.prototype.multiplyToRef = function (t, e) {
        var i = this.m[0],
            r = this.m[1],
            o = this.m[2],
            n = this.m[3],
            s = this.m[4],
            a = this.m[5],
            h = t.m[0],
            l = t.m[1],
            u = t.m[2],
            c = t.m[3],
            _ = t.m[4],
            f = t.m[5];
        return e.m[0] = i * h + r * u, e.m[1] = i * l + r * c, e.m[2] = o * h + n * u, e.m[3] = o * l + n * c, e.m[4] = s * h + a * u + _, e.m[5] = s * l + a * c + f, this;
      }, t.prototype.transformCoordinates = function (t, e, i) {
        return i.x = t * this.m[0] + e * this.m[2] + this.m[4], i.y = t * this.m[1] + e * this.m[3] + this.m[5], this;
      }, t.Identity = function () {
        return new t(1, 0, 0, 1, 0, 0);
      }, t.TranslationToRef = function (t, e, i) {
        i.fromValues(1, 0, 0, 1, t, e);
      }, t.ScalingToRef = function (t, e, i) {
        i.fromValues(t, 0, 0, e, 0, 0);
      }, t.RotationToRef = function (t, e) {
        var i = Math.sin(t),
            r = Math.cos(t);
        e.fromValues(r, i, -i, r, 0, 0);
      }, t.ComposeToRef = function (e, i, r, o, n, s, a) {
        t.TranslationToRef(e, i, t._TempPreTranslationMatrix), t.ScalingToRef(o, n, t._TempScalingMatrix), t.RotationToRef(r, t._TempRotationMatrix), t.TranslationToRef(-e, -i, t._TempPostTranslationMatrix), t._TempPreTranslationMatrix.multiplyToRef(t._TempScalingMatrix, t._TempCompose0), t._TempCompose0.multiplyToRef(t._TempRotationMatrix, t._TempCompose1), s ? (t._TempCompose1.multiplyToRef(t._TempPostTranslationMatrix, t._TempCompose2), t._TempCompose2.multiplyToRef(s, a)) : t._TempCompose1.multiplyToRef(t._TempPostTranslationMatrix, a);
      }, t._TempPreTranslationMatrix = t.Identity(), t._TempPostTranslationMatrix = t.Identity(), t._TempRotationMatrix = t.Identity(), t._TempScalingMatrix = t.Identity(), t._TempCompose0 = t.Identity(), t._TempCompose1 = t.Identity(), t._TempCompose2 = t.Identity(), t;
    }();

    e.Matrix2D = s;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t12 = function t(e, i) {
        return (_t12 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t12(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(1),
        n = i(0),
        s = i(6),
        a = i(5),
        h = function (t) {
      function e(e) {
        var i = t.call(this, e) || this;
        return i.name = e, i._isChecked = !1, i._background = "black", i._checkSizeRatio = .8, i._thickness = 1, i.onIsCheckedChangedObservable = new n.Observable(), i.isPointerBlocker = !0, i;
      }

      return r(e, t), Object.defineProperty(e.prototype, "thickness", {
        get: function get() {
          return this._thickness;
        },
        set: function set(t) {
          this._thickness !== t && (this._thickness = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "checkSizeRatio", {
        get: function get() {
          return this._checkSizeRatio;
        },
        set: function set(t) {
          t = Math.max(Math.min(1, t), 0), this._checkSizeRatio !== t && (this._checkSizeRatio = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "background", {
        get: function get() {
          return this._background;
        },
        set: function set(t) {
          this._background !== t && (this._background = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "isChecked", {
        get: function get() {
          return this._isChecked;
        },
        set: function set(t) {
          this._isChecked !== t && (this._isChecked = t, this._markAsDirty(), this.onIsCheckedChangedObservable.notifyObservers(t));
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._getTypeName = function () {
        return "CheckBox";
      }, e.prototype._draw = function (t, e) {
        if (e.save(), this._applyStates(e), this._processMeasures(t, e)) {
          var i = this._currentMeasure.width - this._thickness,
              r = this._currentMeasure.height - this._thickness;

          if ((this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (e.shadowColor = this.shadowColor, e.shadowBlur = this.shadowBlur, e.shadowOffsetX = this.shadowOffsetX, e.shadowOffsetY = this.shadowOffsetY), e.fillStyle = this._isEnabled ? this._background : this._disabledColor, e.fillRect(this._currentMeasure.left + this._thickness / 2, this._currentMeasure.top + this._thickness / 2, i, r), (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (e.shadowBlur = 0, e.shadowOffsetX = 0, e.shadowOffsetY = 0), this._isChecked) {
            e.fillStyle = this._isEnabled ? this.color : this._disabledColor;
            var o = i * this._checkSizeRatio,
                n = r * this._checkSizeRatio;
            e.fillRect(this._currentMeasure.left + this._thickness / 2 + (i - o) / 2, this._currentMeasure.top + this._thickness / 2 + (r - n) / 2, o, n);
          }

          e.strokeStyle = this.color, e.lineWidth = this._thickness, e.strokeRect(this._currentMeasure.left + this._thickness / 2, this._currentMeasure.top + this._thickness / 2, i, r);
        }

        e.restore();
      }, e.prototype._onPointerDown = function (e, i, r, o) {
        return !!t.prototype._onPointerDown.call(this, e, i, r, o) && (this.isChecked = !this.isChecked, !0);
      }, e.AddCheckBoxWithHeader = function (t, i) {
        var r = new s.StackPanel();
        r.isVertical = !1, r.height = "30px";
        var n = new e();
        n.width = "20px", n.height = "20px", n.isChecked = !0, n.color = "green", n.onIsCheckedChangedObservable.add(i), r.addControl(n);
        var h = new a.TextBlock();
        return h.text = t, h.width = "180px", h.paddingLeft = "5px", h.textHorizontalAlignment = o.Control.HORIZONTAL_ALIGNMENT_LEFT, h.color = "white", r.addControl(h), r;
      }, e;
    }(o.Control);

    e.Checkbox = h;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t13 = function t(e, i) {
        return (_t13 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t13(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(1),
        n = i(2),
        s = i(0),
        a = function (t) {
      function e(e, i) {
        void 0 === i && (i = "");
        var r = t.call(this, e) || this;
        return r.name = e, r._text = "", r._placeholderText = "", r._background = "#222222", r._focusedBackground = "#000000", r._placeholderColor = "gray", r._thickness = 1, r._margin = new n.ValueAndUnit(10, n.ValueAndUnit.UNITMODE_PIXEL), r._autoStretchWidth = !0, r._maxWidth = new n.ValueAndUnit(1, n.ValueAndUnit.UNITMODE_PERCENTAGE, !1), r._isFocused = !1, r._blinkIsEven = !1, r._cursorOffset = 0, r._deadKey = !1, r._addKey = !0, r._currentKey = "", r.promptMessage = "Please enter text:", r.onTextChangedObservable = new s.Observable(), r.onBeforeKeyAddObservable = new s.Observable(), r.onFocusObservable = new s.Observable(), r.onBlurObservable = new s.Observable(), r.text = i, r;
      }

      return r(e, t), Object.defineProperty(e.prototype, "maxWidth", {
        get: function get() {
          return this._maxWidth.toString(this._host);
        },
        set: function set(t) {
          this._maxWidth.toString(this._host) !== t && this._maxWidth.fromString(t) && this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "maxWidthInPixels", {
        get: function get() {
          return this._maxWidth.getValueInPixel(this._host, this._cachedParentMeasure.width);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "margin", {
        get: function get() {
          return this._margin.toString(this._host);
        },
        set: function set(t) {
          this._margin.toString(this._host) !== t && this._margin.fromString(t) && this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "marginInPixels", {
        get: function get() {
          return this._margin.getValueInPixel(this._host, this._cachedParentMeasure.width);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "autoStretchWidth", {
        get: function get() {
          return this._autoStretchWidth;
        },
        set: function set(t) {
          this._autoStretchWidth !== t && (this._autoStretchWidth = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "thickness", {
        get: function get() {
          return this._thickness;
        },
        set: function set(t) {
          this._thickness !== t && (this._thickness = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "focusedBackground", {
        get: function get() {
          return this._focusedBackground;
        },
        set: function set(t) {
          this._focusedBackground !== t && (this._focusedBackground = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "background", {
        get: function get() {
          return this._background;
        },
        set: function set(t) {
          this._background !== t && (this._background = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "placeholderColor", {
        get: function get() {
          return this._placeholderColor;
        },
        set: function set(t) {
          this._placeholderColor !== t && (this._placeholderColor = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "placeholderText", {
        get: function get() {
          return this._placeholderText;
        },
        set: function set(t) {
          this._placeholderText !== t && (this._placeholderText = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "deadKey", {
        get: function get() {
          return this._deadKey;
        },
        set: function set(t) {
          this._deadKey = t;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "addKey", {
        get: function get() {
          return this._addKey;
        },
        set: function set(t) {
          this._addKey = t;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "currentKey", {
        get: function get() {
          return this._currentKey;
        },
        set: function set(t) {
          this._currentKey = t;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "text", {
        get: function get() {
          return this._text;
        },
        set: function set(t) {
          this._text !== t && (this._text = t, this._markAsDirty(), this.onTextChangedObservable.notifyObservers(this));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "width", {
        get: function get() {
          return this._width.toString(this._host);
        },
        set: function set(t) {
          this._width.toString(this._host) !== t && (this._width.fromString(t) && this._markAsDirty(), this.autoStretchWidth = !1);
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.onBlur = function () {
        this._isFocused = !1, this._scrollLeft = null, this._cursorOffset = 0, clearTimeout(this._blinkTimeout), this._markAsDirty(), this.onBlurObservable.notifyObservers(this);
      }, e.prototype.onFocus = function () {
        if (this._isEnabled && (this._scrollLeft = null, this._isFocused = !0, this._blinkIsEven = !1, this._cursorOffset = 0, this._markAsDirty(), this.onFocusObservable.notifyObservers(this), -1 !== navigator.userAgent.indexOf("Mobile"))) {
          var t = prompt(this.promptMessage);
          return null !== t && (this.text = t), void (this._host.focusedControl = null);
        }
      }, e.prototype._getTypeName = function () {
        return "InputText";
      }, e.prototype.keepsFocusWith = function () {
        return this._connectedVirtualKeyboard ? [this._connectedVirtualKeyboard] : null;
      }, e.prototype.processKey = function (t, e) {
        switch (t) {
          case 32:
            e = " ";
            break;

          case 8:
            if (this._text && this._text.length > 0) if (0 === this._cursorOffset) this.text = this._text.substr(0, this._text.length - 1);else (i = this._text.length - this._cursorOffset) > 0 && (this.text = this._text.slice(0, i - 1) + this._text.slice(i));
            return;

          case 46:
            if (this._text && this._text.length > 0) {
              var i = this._text.length - this._cursorOffset;
              this.text = this._text.slice(0, i) + this._text.slice(i + 1), this._cursorOffset--;
            }

            return;

          case 13:
            return void (this._host.focusedControl = null);

          case 35:
            return this._cursorOffset = 0, this._blinkIsEven = !1, void this._markAsDirty();

          case 36:
            return this._cursorOffset = this._text.length, this._blinkIsEven = !1, void this._markAsDirty();

          case 37:
            return this._cursorOffset++, this._cursorOffset > this._text.length && (this._cursorOffset = this._text.length), this._blinkIsEven = !1, void this._markAsDirty();

          case 39:
            return this._cursorOffset--, this._cursorOffset < 0 && (this._cursorOffset = 0), this._blinkIsEven = !1, void this._markAsDirty();

          case 222:
            return void (this.deadKey = !0);
        }

        if (e && (-1 === t || 32 === t || t > 47 && t < 58 || t > 64 && t < 91 || t > 185 && t < 193 || t > 218 && t < 223 || t > 95 && t < 112) && (this._currentKey = e, this.onBeforeKeyAddObservable.notifyObservers(this), e = this._currentKey, this._addKey)) if (0 === this._cursorOffset) this.text += e;else {
          var r = this._text.length - this._cursorOffset;
          this.text = this._text.slice(0, r) + e + this._text.slice(r);
        }
      }, e.prototype.processKeyboard = function (t) {
        this.processKey(t.keyCode, t.key);
      }, e.prototype._draw = function (t, e) {
        var i = this;

        if (e.save(), this._applyStates(e), this._processMeasures(t, e)) {
          (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (e.shadowColor = this.shadowColor, e.shadowBlur = this.shadowBlur, e.shadowOffsetX = this.shadowOffsetX, e.shadowOffsetY = this.shadowOffsetY), this._isFocused ? this._focusedBackground && (e.fillStyle = this._isEnabled ? this._focusedBackground : this._disabledColor, e.fillRect(this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height)) : this._background && (e.fillStyle = this._isEnabled ? this._background : this._disabledColor, e.fillRect(this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height)), (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (e.shadowBlur = 0, e.shadowOffsetX = 0, e.shadowOffsetY = 0), this._fontOffset || (this._fontOffset = o.Control._GetFontOffset(e.font));

          var r = this._currentMeasure.left + this._margin.getValueInPixel(this._host, t.width);

          this.color && (e.fillStyle = this.color);

          var n = this._beforeRenderText(this._text);

          this._isFocused || this._text || !this._placeholderText || (n = this._placeholderText, this._placeholderColor && (e.fillStyle = this._placeholderColor)), this._textWidth = e.measureText(n).width;

          var s = 2 * this._margin.getValueInPixel(this._host, t.width);

          this._autoStretchWidth && (this.width = Math.min(this._maxWidth.getValueInPixel(this._host, t.width), this._textWidth + s) + "px");
          var a = this._fontOffset.ascent + (this._currentMeasure.height - this._fontOffset.height) / 2,
              h = this._width.getValueInPixel(this._host, t.width) - s;

          if (e.save(), e.beginPath(), e.rect(r, this._currentMeasure.top + (this._currentMeasure.height - this._fontOffset.height) / 2, h + 2, this._currentMeasure.height), e.clip(), this._isFocused && this._textWidth > h) {
            var l = r - this._textWidth + h;
            this._scrollLeft || (this._scrollLeft = l);
          } else this._scrollLeft = r;

          if (e.fillText(n, this._scrollLeft, this._currentMeasure.top + a), this._isFocused) {
            if (this._clickedCoordinate) {
              var u = this._scrollLeft + this._textWidth - this._clickedCoordinate,
                  c = 0;
              this._cursorOffset = 0;
              var _ = 0;

              do {
                this._cursorOffset && (_ = Math.abs(u - c)), this._cursorOffset++, c = e.measureText(n.substr(n.length - this._cursorOffset, this._cursorOffset)).width;
              } while (c < u && n.length >= this._cursorOffset);

              Math.abs(u - c) > _ && this._cursorOffset--, this._blinkIsEven = !1, this._clickedCoordinate = null;
            }

            if (!this._blinkIsEven) {
              var f = this.text.substr(this._text.length - this._cursorOffset),
                  p = e.measureText(f).width,
                  d = this._scrollLeft + this._textWidth - p;
              d < r ? (this._scrollLeft += r - d, d = r, this._markAsDirty()) : d > r + h && (this._scrollLeft += r + h - d, d = r + h, this._markAsDirty()), e.fillRect(d, this._currentMeasure.top + (this._currentMeasure.height - this._fontOffset.height) / 2, 2, this._fontOffset.height);
            }

            clearTimeout(this._blinkTimeout), this._blinkTimeout = setTimeout(function () {
              i._blinkIsEven = !i._blinkIsEven, i._markAsDirty();
            }, 500);
          }

          e.restore(), this._thickness && (this.color && (e.strokeStyle = this.color), e.lineWidth = this._thickness, e.strokeRect(this._currentMeasure.left + this._thickness / 2, this._currentMeasure.top + this._thickness / 2, this._currentMeasure.width - this._thickness, this._currentMeasure.height - this._thickness));
        }

        e.restore();
      }, e.prototype._onPointerDown = function (e, i, r, o) {
        return !!t.prototype._onPointerDown.call(this, e, i, r, o) && (this._clickedCoordinate = i.x, this._host.focusedControl === this ? (clearTimeout(this._blinkTimeout), this._markAsDirty(), !0) : !!this._isEnabled && (this._host.focusedControl = this, !0));
      }, e.prototype._onPointerUp = function (e, i, r, o, n) {
        t.prototype._onPointerUp.call(this, e, i, r, o, n);
      }, e.prototype._beforeRenderText = function (t) {
        return t;
      }, e.prototype.dispose = function () {
        t.prototype.dispose.call(this), this.onBlurObservable.clear(), this.onFocusObservable.clear(), this.onTextChangedObservable.clear();
      }, e;
    }(o.Control);

    e.InputText = a;
  }, function (t, e, i) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var r = i(2),
        o = i(0),
        n = function () {
      function t(t) {
        this._multiLine = t, this._x = new r.ValueAndUnit(0), this._y = new r.ValueAndUnit(0), this._point = new o.Vector2(0, 0);
      }

      return Object.defineProperty(t.prototype, "x", {
        get: function get() {
          return this._x.toString(this._multiLine._host);
        },
        set: function set(t) {
          this._x.toString(this._multiLine._host) !== t && this._x.fromString(t) && this._multiLine._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "y", {
        get: function get() {
          return this._y.toString(this._multiLine._host);
        },
        set: function set(t) {
          this._y.toString(this._multiLine._host) !== t && this._y.fromString(t) && this._multiLine._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "control", {
        get: function get() {
          return this._control;
        },
        set: function set(t) {
          this._control !== t && (this._control && this._controlObserver && (this._control.onDirtyObservable.remove(this._controlObserver), this._controlObserver = null), this._control = t, this._control && (this._controlObserver = this._control.onDirtyObservable.add(this._multiLine.onPointUpdate)), this._multiLine._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "mesh", {
        get: function get() {
          return this._mesh;
        },
        set: function set(t) {
          this._mesh !== t && (this._mesh && this._meshObserver && this._mesh.getScene().onAfterCameraRenderObservable.remove(this._meshObserver), this._mesh = t, this._mesh && (this._meshObserver = this._mesh.getScene().onAfterCameraRenderObservable.add(this._multiLine.onPointUpdate)), this._multiLine._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.resetLinks = function () {
        this.control = null, this.mesh = null;
      }, t.prototype.translate = function () {
        return this._point = this._translatePoint(), this._point;
      }, t.prototype._translatePoint = function () {
        if (null != this._mesh) return this._multiLine._host.getProjectedPosition(this._mesh.getBoundingInfo().boundingSphere.center, this._mesh.getWorldMatrix());
        if (null != this._control) return new o.Vector2(this._control.centerX, this._control.centerY);

        var t = this._multiLine._host,
            e = this._x.getValueInPixel(t, Number(t._canvas.width)),
            i = this._y.getValueInPixel(t, Number(t._canvas.height));

        return new o.Vector2(e, i);
      }, t.prototype.dispose = function () {
        this.resetLinks();
      }, t;
    }();

    e.MultiLinePoint = n;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t14 = function t(e, i) {
        return (_t14 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t14(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(1),
        n = i(0),
        s = i(9),
        a = function (t) {
      function e(e) {
        var i = t.call(this, e) || this;
        return i.name = e, i._isChecked = !1, i._background = "black", i._checkSizeRatio = .8, i._thickness = 1, i.group = "", i.onIsCheckedChangedObservable = new n.Observable(), i.isPointerBlocker = !0, i;
      }

      return r(e, t), Object.defineProperty(e.prototype, "thickness", {
        get: function get() {
          return this._thickness;
        },
        set: function set(t) {
          this._thickness !== t && (this._thickness = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "checkSizeRatio", {
        get: function get() {
          return this._checkSizeRatio;
        },
        set: function set(t) {
          t = Math.max(Math.min(1, t), 0), this._checkSizeRatio !== t && (this._checkSizeRatio = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "background", {
        get: function get() {
          return this._background;
        },
        set: function set(t) {
          this._background !== t && (this._background = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "isChecked", {
        get: function get() {
          return this._isChecked;
        },
        set: function set(t) {
          var e = this;
          this._isChecked !== t && (this._isChecked = t, this._markAsDirty(), this.onIsCheckedChangedObservable.notifyObservers(t), this._isChecked && this._host && this._host.executeOnAllControls(function (t) {
            if (t !== e && void 0 !== t.group) {
              var i = t;
              i.group === e.group && (i.isChecked = !1);
            }
          }));
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._getTypeName = function () {
        return "RadioButton";
      }, e.prototype._draw = function (t, e) {
        if (e.save(), this._applyStates(e), this._processMeasures(t, e)) {
          var i = this._currentMeasure.width - this._thickness,
              r = this._currentMeasure.height - this._thickness;

          if ((this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (e.shadowColor = this.shadowColor, e.shadowBlur = this.shadowBlur, e.shadowOffsetX = this.shadowOffsetX, e.shadowOffsetY = this.shadowOffsetY), o.Control.drawEllipse(this._currentMeasure.left + this._currentMeasure.width / 2, this._currentMeasure.top + this._currentMeasure.height / 2, this._currentMeasure.width / 2 - this._thickness / 2, this._currentMeasure.height / 2 - this._thickness / 2, e), e.fillStyle = this._isEnabled ? this._background : this._disabledColor, e.fill(), (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (e.shadowBlur = 0, e.shadowOffsetX = 0, e.shadowOffsetY = 0), e.strokeStyle = this.color, e.lineWidth = this._thickness, e.stroke(), this._isChecked) {
            e.fillStyle = this._isEnabled ? this.color : this._disabledColor;
            var n = i * this._checkSizeRatio,
                s = r * this._checkSizeRatio;
            o.Control.drawEllipse(this._currentMeasure.left + this._currentMeasure.width / 2, this._currentMeasure.top + this._currentMeasure.height / 2, n / 2 - this._thickness / 2, s / 2 - this._thickness / 2, e), e.fill();
          }
        }

        e.restore();
      }, e.prototype._onPointerDown = function (e, i, r, o) {
        return !!t.prototype._onPointerDown.call(this, e, i, r, o) && (this.isChecked || (this.isChecked = !0), !0);
      }, e.AddRadioButtonWithHeader = function (t, i, r, n) {
        var a = new s.StackPanel();
        a.isVertical = !1, a.height = "30px";
        var h = new e();
        h.width = "20px", h.height = "20px", h.isChecked = r, h.color = "green", h.group = i, h.onIsCheckedChangedObservable.add(function (t) {
          return n(h, t);
        }), a.addControl(h);
        var l = new s.TextBlock();
        return l.text = t, l.width = "180px", l.paddingLeft = "5px", l.textHorizontalAlignment = o.Control.HORIZONTAL_ALIGNMENT_LEFT, l.color = "white", a.addControl(l), a;
      }, e;
    }(o.Control);

    e.RadioButton = a;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t15 = function t(e, i) {
        return (_t15 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t15(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(1),
        n = i(2),
        s = i(0),
        a = function (t) {
      function e(e) {
        var i = t.call(this, e) || this;
        return i.name = e, i._thumbWidth = new n.ValueAndUnit(20, n.ValueAndUnit.UNITMODE_PIXEL, !1), i._minimum = 0, i._maximum = 100, i._value = 50, i._isVertical = !1, i._background = "black", i._borderColor = "white", i._barOffset = new n.ValueAndUnit(5, n.ValueAndUnit.UNITMODE_PIXEL, !1), i._isThumbCircle = !1, i._isThumbClamped = !1, i.onValueChangedObservable = new s.Observable(), i._pointerIsDown = !1, i.isPointerBlocker = !0, i;
      }

      return r(e, t), Object.defineProperty(e.prototype, "borderColor", {
        get: function get() {
          return this._borderColor;
        },
        set: function set(t) {
          this._borderColor !== t && (this._borderColor = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "background", {
        get: function get() {
          return this._background;
        },
        set: function set(t) {
          this._background !== t && (this._background = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "barOffset", {
        get: function get() {
          return this._barOffset.toString(this._host);
        },
        set: function set(t) {
          this._barOffset.toString(this._host) !== t && this._barOffset.fromString(t) && this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "barOffsetInPixels", {
        get: function get() {
          return this._barOffset.getValueInPixel(this._host, this._cachedParentMeasure.width);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "thumbWidth", {
        get: function get() {
          return this._thumbWidth.toString(this._host);
        },
        set: function set(t) {
          this._thumbWidth.toString(this._host) !== t && this._thumbWidth.fromString(t) && this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "thumbWidthInPixels", {
        get: function get() {
          return this._thumbWidth.getValueInPixel(this._host, this._cachedParentMeasure.width);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "minimum", {
        get: function get() {
          return this._minimum;
        },
        set: function set(t) {
          this._minimum !== t && (this._minimum = t, this._markAsDirty(), this.value = Math.max(Math.min(this.value, this._maximum), this._minimum));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "maximum", {
        get: function get() {
          return this._maximum;
        },
        set: function set(t) {
          this._maximum !== t && (this._maximum = t, this._markAsDirty(), this.value = Math.max(Math.min(this.value, this._maximum), this._minimum));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "value", {
        get: function get() {
          return this._value;
        },
        set: function set(t) {
          t = Math.max(Math.min(t, this._maximum), this._minimum), this._value !== t && (this._value = t, this._markAsDirty(), this.onValueChangedObservable.notifyObservers(this._value));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "isVertical", {
        get: function get() {
          return this._isVertical;
        },
        set: function set(t) {
          this._isVertical !== t && (this._isVertical = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "isThumbCircle", {
        get: function get() {
          return this._isThumbCircle;
        },
        set: function set(t) {
          this._isThumbCircle !== t && (this._isThumbCircle = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "isThumbClamped", {
        get: function get() {
          return this._isThumbClamped;
        },
        set: function set(t) {
          this._isThumbClamped !== t && (this._isThumbClamped = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._getTypeName = function () {
        return "Slider";
      }, e.prototype._getThumbThickness = function (t, e) {
        var i = 0;

        switch (t) {
          case "circle":
            i = this._thumbWidth.isPixel ? Math.max(this._thumbWidth.getValue(this._host), e) : e * this._thumbWidth.getValue(this._host);
            break;

          case "rectangle":
            i = this._thumbWidth.isPixel ? Math.min(this._thumbWidth.getValue(this._host), e) : e * this._thumbWidth.getValue(this._host);
        }

        return i;
      }, e.prototype._draw = function (t, e) {
        if (e.save(), this._applyStates(e), this._processMeasures(t, e)) {
          var i = 0,
              r = this.isThumbCircle ? "circle" : "rectangle",
              o = this._currentMeasure.left,
              n = this._currentMeasure.top,
              s = this._currentMeasure.width,
              a = this._currentMeasure.height,
              h = Math.max(this._currentMeasure.width, this._currentMeasure.height),
              l = Math.min(this._currentMeasure.width, this._currentMeasure.height),
              u = this._getThumbThickness(r, l);

          h -= u;
          var c = 0;
          if (this._isVertical && this._currentMeasure.height < this._currentMeasure.width) return void console.error("Height should be greater than width");
          l -= 2 * (i = this._barOffset.isPixel ? Math.min(this._barOffset.getValue(this._host), l) : l * this._barOffset.getValue(this._host)), this._isVertical ? (o += i, this.isThumbClamped || (n += u / 2), a = h, s = l) : (n += i, this.isThumbClamped || (o += u / 2), a = l, s = h), this.isThumbClamped && this.isThumbCircle ? (this._isVertical ? n += u / 2 : o += u / 2, c = l / 2) : c = (u - i) / 2, (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (e.shadowColor = this.shadowColor, e.shadowBlur = this.shadowBlur, e.shadowOffsetX = this.shadowOffsetX, e.shadowOffsetY = this.shadowOffsetY);

          var _ = this._isVertical ? (this._maximum - this._value) / (this._maximum - this._minimum) * h : (this._value - this._minimum) / (this._maximum - this._minimum) * h;

          e.fillStyle = this._background, this._isVertical ? this.isThumbClamped ? this.isThumbCircle ? (e.beginPath(), e.arc(o + l / 2, n, c, Math.PI, 2 * Math.PI), e.fill(), e.fillRect(o, n, s, a)) : e.fillRect(o, n, s, a + u) : e.fillRect(o, n, s, a) : this.isThumbClamped ? this.isThumbCircle ? (e.beginPath(), e.arc(o + h, n + l / 2, c, 0, 2 * Math.PI), e.fill(), e.fillRect(o, n, s, a)) : e.fillRect(o, n, s + u, a) : e.fillRect(o, n, s, a), (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (e.shadowBlur = 0, e.shadowOffsetX = 0, e.shadowOffsetY = 0), e.fillStyle = this.color, this._isVertical ? this.isThumbClamped ? this.isThumbCircle ? (e.beginPath(), e.arc(o + l / 2, n + h, c, 0, 2 * Math.PI), e.fill(), e.fillRect(o, n + _, s, a - _)) : e.fillRect(o, n + _, s, this._currentMeasure.height - _) : e.fillRect(o, n + _, s, a - _) : this.isThumbClamped && this.isThumbCircle ? (e.beginPath(), e.arc(o, n + l / 2, c, 0, 2 * Math.PI), e.fill(), e.fillRect(o, n, _, a)) : e.fillRect(o, n, _, a), (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (e.shadowColor = this.shadowColor, e.shadowBlur = this.shadowBlur, e.shadowOffsetX = this.shadowOffsetX, e.shadowOffsetY = this.shadowOffsetY), this._isThumbCircle ? (e.beginPath(), this._isVertical ? e.arc(o + l / 2, n + _, c, 0, 2 * Math.PI) : e.arc(o + _, n + l / 2, c, 0, 2 * Math.PI), e.fill(), (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (e.shadowBlur = 0, e.shadowOffsetX = 0, e.shadowOffsetY = 0), e.strokeStyle = this._borderColor, e.stroke()) : (this._isVertical ? e.fillRect(o - i, this._currentMeasure.top + _, this._currentMeasure.width, u) : e.fillRect(this._currentMeasure.left + _, this._currentMeasure.top, u, this._currentMeasure.height), (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (e.shadowBlur = 0, e.shadowOffsetX = 0, e.shadowOffsetY = 0), e.strokeStyle = this._borderColor, this._isVertical ? e.strokeRect(o - i, this._currentMeasure.top + _, this._currentMeasure.width, u) : e.strokeRect(this._currentMeasure.left + _, this._currentMeasure.top, u, this._currentMeasure.height));
        }

        e.restore();
      }, e.prototype._updateValueFromPointer = function (t, e) {
        0 != this.rotation && (this._invertTransformMatrix.transformCoordinates(t, e, this._transformedPosition), t = this._transformedPosition.x, e = this._transformedPosition.y), this._isVertical ? this.value = this._minimum + (1 - (e - this._currentMeasure.top) / this._currentMeasure.height) * (this._maximum - this._minimum) : this.value = this._minimum + (t - this._currentMeasure.left) / this._currentMeasure.width * (this._maximum - this._minimum);
      }, e.prototype._onPointerDown = function (e, i, r, o) {
        return !!t.prototype._onPointerDown.call(this, e, i, r, o) && (this._pointerIsDown = !0, this._updateValueFromPointer(i.x, i.y), this._host._capturingControl[r] = this, !0);
      }, e.prototype._onPointerMove = function (e, i) {
        this._pointerIsDown && this._updateValueFromPointer(i.x, i.y), t.prototype._onPointerMove.call(this, e, i);
      }, e.prototype._onPointerUp = function (e, i, r, o, n) {
        this._pointerIsDown = !1, delete this._host._capturingControl[r], t.prototype._onPointerUp.call(this, e, i, r, o, n);
      }, e;
    }(o.Control);

    e.Slider = a;
  }, function (t, e, i) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var r = i(0),
        o = i(2),
        n = function () {
      function t(t) {
        this._fontFamily = "Arial", this._fontStyle = "", this._fontWeight = "", this._fontSize = new o.ValueAndUnit(18, o.ValueAndUnit.UNITMODE_PIXEL, !1), this.onChangedObservable = new r.Observable(), this._host = t;
      }

      return Object.defineProperty(t.prototype, "fontSize", {
        get: function get() {
          return this._fontSize.toString(this._host);
        },
        set: function set(t) {
          this._fontSize.toString(this._host) !== t && this._fontSize.fromString(t) && this.onChangedObservable.notifyObservers(this);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "fontFamily", {
        get: function get() {
          return this._fontFamily;
        },
        set: function set(t) {
          this._fontFamily !== t && (this._fontFamily = t, this.onChangedObservable.notifyObservers(this));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "fontStyle", {
        get: function get() {
          return this._fontStyle;
        },
        set: function set(t) {
          this._fontStyle !== t && (this._fontStyle = t, this.onChangedObservable.notifyObservers(this));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "fontWeight", {
        get: function get() {
          return this._fontWeight;
        },
        set: function set(t) {
          this._fontWeight !== t && (this._fontWeight = t, this.onChangedObservable.notifyObservers(this));
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.dispose = function () {
        this.onChangedObservable.clear();
      }, t;
    }();

    e.Style = n;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t16 = function t(e, i) {
        return (_t16 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t16(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(13),
        n = i(0),
        s = function (t) {
      function e(e) {
        return t.call(this, e) || this;
      }

      return r(e, t), e.prototype._getTypeName = function () {
        return "AbstractButton3D";
      }, e.prototype._createNode = function (t) {
        return new n.TransformNode("button" + this.name);
      }, e;
    }(o.Control3D);

    e.AbstractButton3D = s;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t17 = function t(e, i) {
        return (_t17 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t17(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = function (t) {
      function e(e, i) {
        void 0 === i && (i = 0);
        var r = t.call(this, e.x, e.y, e.z) || this;
        return r.buttonIndex = i, r;
      }

      return r(e, t), e;
    }(i(0).Vector3);

    e.Vector3WithInfo = o;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t18 = function t(e, i) {
        return (_t18 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t18(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }(),
        o = this && this.__decorate || function (t, e, i, r) {
      var o,
          n = arguments.length,
          s = n < 3 ? e : null === r ? r = Object.getOwnPropertyDescriptor(e, i) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(t, e, i, r);else for (var a = t.length - 1; a >= 0; a--) {
        (o = t[a]) && (s = (n < 3 ? o(s) : n > 3 ? o(e, i, s) : o(e, i)) || s);
      }
      return n > 3 && s && Object.defineProperty(e, i, s), s;
    };

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = i(0);
    i(44).registerShader();

    var s = function (t) {
      function e() {
        var e = t.call(this) || this;
        return e.INNERGLOW = !1, e.BORDER = !1, e.HOVERLIGHT = !1, e.TEXTURE = !1, e.rebuild(), e;
      }

      return r(e, t), e;
    }(n.MaterialDefines);

    e.FluentMaterialDefines = s;

    var a = function (t) {
      function e(e, i) {
        var r = t.call(this, e, i) || this;
        return r.innerGlowColorIntensity = .5, r.innerGlowColor = new n.Color3(1, 1, 1), r.alpha = 1, r.albedoColor = new n.Color3(.3, .35, .4), r.renderBorders = !1, r.borderWidth = .5, r.edgeSmoothingValue = .02, r.borderMinValue = .1, r.renderHoverLight = !1, r.hoverRadius = 1, r.hoverColor = new n.Color4(.3, .3, .3, 1), r.hoverPosition = n.Vector3.Zero(), r;
      }

      return r(e, t), e.prototype.needAlphaBlending = function () {
        return 1 !== this.alpha;
      }, e.prototype.needAlphaTesting = function () {
        return !1;
      }, e.prototype.getAlphaTestTexture = function () {
        return null;
      }, e.prototype.isReadyForSubMesh = function (t, e, i) {
        if (this.isFrozen && this._wasPreviouslyReady && e.effect) return !0;
        e._materialDefines || (e._materialDefines = new s());
        var r = this.getScene(),
            o = e._materialDefines;
        if (!this.checkReadyOnEveryCall && e.effect && o._renderId === r.getRenderId()) return !0;
        if (o._areTexturesDirty) if (o.INNERGLOW = this.innerGlowColorIntensity > 0, o.BORDER = this.renderBorders, o.HOVERLIGHT = this.renderHoverLight, this._albedoTexture) {
          if (!this._albedoTexture.isReadyOrNotBlocking()) return !1;
          o.TEXTURE = !0;
        } else o.TEXTURE = !1;
        var a = r.getEngine();

        if (o.isDirty) {
          o.markAsProcessed(), r.resetCachedMaterial();
          var h = [n.VertexBuffer.PositionKind];
          h.push(n.VertexBuffer.NormalKind), h.push(n.VertexBuffer.UVKind);
          var l = ["world", "viewProjection", "innerGlowColor", "albedoColor", "borderWidth", "edgeSmoothingValue", "scaleFactor", "borderMinValue", "hoverColor", "hoverPosition", "hoverRadius"],
              u = ["albedoSampler"],
              c = new Array();
          n.MaterialHelper.PrepareUniformsAndSamplersList({
            uniformsNames: l,
            uniformBuffersNames: c,
            samplers: u,
            defines: o,
            maxSimultaneousLights: 4
          });

          var _ = o.toString();

          e.setEffect(r.getEngine().createEffect("fluent", {
            attributes: h,
            uniformsNames: l,
            uniformBuffersNames: c,
            samplers: u,
            defines: _,
            fallbacks: null,
            onCompiled: this.onCompiled,
            onError: this.onError,
            indexParameters: {
              maxSimultaneousLights: 4
            }
          }, a));
        }

        return !(!e.effect || !e.effect.isReady()) && (o._renderId = r.getRenderId(), this._wasPreviouslyReady = !0, !0);
      }, e.prototype.bindForSubMesh = function (t, e, i) {
        var r = this.getScene(),
            o = i._materialDefines;

        if (o) {
          var s = i.effect;
          s && (this._activeEffect = s, this.bindOnlyWorldMatrix(t), this._activeEffect.setMatrix("viewProjection", r.getTransformMatrix()), this._mustRebind(r, s) && (this._activeEffect.setColor4("albedoColor", this.albedoColor, this.alpha), o.INNERGLOW && this._activeEffect.setColor4("innerGlowColor", this.innerGlowColor, this.innerGlowColorIntensity), o.BORDER && (this._activeEffect.setFloat("borderWidth", this.borderWidth), this._activeEffect.setFloat("edgeSmoothingValue", this.edgeSmoothingValue), this._activeEffect.setFloat("borderMinValue", this.borderMinValue), e.getBoundingInfo().boundingBox.extendSize.multiplyToRef(e.scaling, n.Tmp.Vector3[0]), this._activeEffect.setVector3("scaleFactor", n.Tmp.Vector3[0])), o.HOVERLIGHT && (this._activeEffect.setDirectColor4("hoverColor", this.hoverColor), this._activeEffect.setFloat("hoverRadius", this.hoverRadius), this._activeEffect.setVector3("hoverPosition", this.hoverPosition)), o.TEXTURE && this._activeEffect.setTexture("albedoSampler", this._albedoTexture)), this._afterBind(e, this._activeEffect));
        }
      }, e.prototype.getActiveTextures = function () {
        return t.prototype.getActiveTextures.call(this);
      }, e.prototype.hasTexture = function (e) {
        return !!t.prototype.hasTexture.call(this, e);
      }, e.prototype.dispose = function (e) {
        t.prototype.dispose.call(this, e);
      }, e.prototype.clone = function (t) {
        var i = this;
        return n.SerializationHelper.Clone(function () {
          return new e(t, i.getScene());
        }, this);
      }, e.prototype.serialize = function () {
        var t = n.SerializationHelper.Serialize(this);
        return t.customType = "BABYLON.GUI.FluentMaterial", t;
      }, e.prototype.getClassName = function () {
        return "FluentMaterial";
      }, e.Parse = function (t, i, r) {
        return n.SerializationHelper.Parse(function () {
          return new e(t.name, i);
        }, t, i, r);
      }, o([n.serialize(), n.expandToProperty("_markAllSubMeshesAsTexturesDirty")], e.prototype, "innerGlowColorIntensity", void 0), o([n.serializeAsColor3()], e.prototype, "innerGlowColor", void 0), o([n.serialize()], e.prototype, "alpha", void 0), o([n.serializeAsColor3()], e.prototype, "albedoColor", void 0), o([n.serialize(), n.expandToProperty("_markAllSubMeshesAsTexturesDirty")], e.prototype, "renderBorders", void 0), o([n.serialize()], e.prototype, "borderWidth", void 0), o([n.serialize()], e.prototype, "edgeSmoothingValue", void 0), o([n.serialize()], e.prototype, "borderMinValue", void 0), o([n.serialize(), n.expandToProperty("_markAllSubMeshesAsTexturesDirty")], e.prototype, "renderHoverLight", void 0), o([n.serialize()], e.prototype, "hoverRadius", void 0), o([n.serializeAsColor4()], e.prototype, "hoverColor", void 0), o([n.serializeAsVector3()], e.prototype, "hoverPosition", void 0), o([n.serializeAsTexture("albedoTexture")], e.prototype, "_albedoTexture", void 0), o([n.expandToProperty("_markAllSubMeshesAsTexturesAndMiscDirty")], e.prototype, "albedoTexture", void 0), e;
    }(n.PushMaterial);

    e.FluentMaterial = a;
  }, function (t, e, i) {
    "use strict";

    (function (t) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = i(15),
          o = void 0 !== t ? t : "undefined" != typeof window ? window : void 0;
      void 0 !== o && (o.BABYLON = o.BABYLON || {}, o.BABYLON.GUI = r), function (t) {
        for (var i in t) {
          e.hasOwnProperty(i) || (e[i] = t[i]);
        }
      }(i(15));
    }).call(this, i(28));
  }, function (t, e) {
    var i;

    i = function () {
      return this;
    }();

    try {
      i = i || Function("return this")() || (0, eval)("this");
    } catch (t) {
      "object" == typeof window && (i = window);
    }

    t.exports = i;
  }, function (t, e, i) {
    "use strict";

    function r(t) {
      for (var i in t) {
        e.hasOwnProperty(i) || (e[i] = t[i]);
      }
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), r(i(9)), r(i(12)), r(i(17)), r(i(7)), r(i(20)), r(i(23)), r(i(2));
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t19 = function t(e, i) {
        return (_t19 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t19(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(1),
        n = i(0),
        s = function (t) {
      function e(e) {
        var i = t.call(this, e) || this;
        return i.name = e, i._value = n.Color3.Red(), i._tmpColor = new n.Color3(), i._pointerStartedOnSquare = !1, i._pointerStartedOnWheel = !1, i._squareLeft = 0, i._squareTop = 0, i._squareSize = 0, i._h = 360, i._s = 1, i._v = 1, i.onValueChangedObservable = new n.Observable(), i._pointerIsDown = !1, i.value = new n.Color3(.88, .1, .1), i.size = "200px", i.isPointerBlocker = !0, i;
      }

      return r(e, t), Object.defineProperty(e.prototype, "value", {
        get: function get() {
          return this._value;
        },
        set: function set(t) {
          this._value.equals(t) || (this._value.copyFrom(t), this._RGBtoHSV(this._value, this._tmpColor), this._h = this._tmpColor.r, this._s = Math.max(this._tmpColor.g, 1e-5), this._v = Math.max(this._tmpColor.b, 1e-5), this._markAsDirty(), this.onValueChangedObservable.notifyObservers(this._value));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "width", {
        set: function set(t) {
          this._width.toString(this._host) !== t && this._width.fromString(t) && (this._height.fromString(t), this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "height", {
        set: function set(t) {
          this._height.toString(this._host) !== t && this._height.fromString(t) && (this._width.fromString(t), this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "size", {
        get: function get() {
          return this.width;
        },
        set: function set(t) {
          this.width = t;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._getTypeName = function () {
        return "ColorPicker";
      }, e.prototype._updateSquareProps = function () {
        var t = .5 * Math.min(this._currentMeasure.width, this._currentMeasure.height),
            e = 2 * (t - .2 * t) / Math.sqrt(2),
            i = t - .5 * e;
        this._squareLeft = this._currentMeasure.left + i, this._squareTop = this._currentMeasure.top + i, this._squareSize = e;
      }, e.prototype._drawGradientSquare = function (t, e, i, r, o, n) {
        var s = n.createLinearGradient(e, i, r + e, i);
        s.addColorStop(0, "#fff"), s.addColorStop(1, "hsl(" + t + ", 100%, 50%)"), n.fillStyle = s, n.fillRect(e, i, r, o);
        var a = n.createLinearGradient(e, i, e, o + i);
        a.addColorStop(0, "rgba(0,0,0,0)"), a.addColorStop(1, "#000"), n.fillStyle = a, n.fillRect(e, i, r, o);
      }, e.prototype._drawCircle = function (t, e, i, r) {
        r.beginPath(), r.arc(t, e, i + 1, 0, 2 * Math.PI, !1), r.lineWidth = 3, r.strokeStyle = "#333333", r.stroke(), r.beginPath(), r.arc(t, e, i, 0, 2 * Math.PI, !1), r.lineWidth = 3, r.strokeStyle = "#ffffff", r.stroke();
      }, e.prototype._createColorWheelCanvas = function (t, e) {
        var i = document.createElement("canvas");
        i.width = 2 * t, i.height = 2 * t;

        for (var r = i.getContext("2d"), o = r.getImageData(0, 0, 2 * t, 2 * t), n = o.data, s = this._tmpColor, a = t * t, h = t - e, l = h * h, u = -t; u < t; u++) {
          for (var c = -t; c < t; c++) {
            var _ = u * u + c * c;

            if (!(_ > a || _ < l)) {
              var f = Math.sqrt(_),
                  p = Math.atan2(c, u);

              this._HSVtoRGB(180 * p / Math.PI + 180, f / t, 1, s);

              var d = 4 * (u + t + 2 * (c + t) * t);
              n[d] = 255 * s.r, n[d + 1] = 255 * s.g, n[d + 2] = 255 * s.b;
              var y = .2;
              y = t < 50 ? .2 : t > 150 ? .04 : -.16 * (t - 50) / 100 + .2;
              var g = (f - h) / (t - h);
              n[d + 3] = g < y ? g / y * 255 : g > 1 - y ? 255 * (1 - (g - (1 - y)) / y) : 255;
            }
          }
        }

        return r.putImageData(o, 0, 0), i;
      }, e.prototype._RGBtoHSV = function (t, e) {
        var i = t.r,
            r = t.g,
            o = t.b,
            n = Math.max(i, r, o),
            s = Math.min(i, r, o),
            a = 0,
            h = 0,
            l = n,
            u = n - s;
        0 !== n && (h = u / n), n != s && (n == i ? (a = (r - o) / u, r < o && (a += 6)) : n == r ? a = (o - i) / u + 2 : n == o && (a = (i - r) / u + 4), a *= 60), e.r = a, e.g = h, e.b = l;
      }, e.prototype._HSVtoRGB = function (t, e, i, r) {
        var o = i * e,
            n = t / 60,
            s = o * (1 - Math.abs(n % 2 - 1)),
            a = 0,
            h = 0,
            l = 0;
        n >= 0 && n <= 1 ? (a = o, h = s) : n >= 1 && n <= 2 ? (a = s, h = o) : n >= 2 && n <= 3 ? (h = o, l = s) : n >= 3 && n <= 4 ? (h = s, l = o) : n >= 4 && n <= 5 ? (a = s, l = o) : n >= 5 && n <= 6 && (a = o, l = s);
        var u = i - o;
        r.set(a + u, h + u, l + u);
      }, e.prototype._draw = function (t, e) {
        if (e.save(), this._applyStates(e), this._processMeasures(t, e)) {
          var i = .5 * Math.min(this._currentMeasure.width, this._currentMeasure.height),
              r = .2 * i,
              o = this._currentMeasure.left,
              n = this._currentMeasure.top;
          this._colorWheelCanvas && this._colorWheelCanvas.width == 2 * i || (this._colorWheelCanvas = this._createColorWheelCanvas(i, r)), this._updateSquareProps(), (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (e.shadowColor = this.shadowColor, e.shadowBlur = this.shadowBlur, e.shadowOffsetX = this.shadowOffsetX, e.shadowOffsetY = this.shadowOffsetY, e.fillRect(this._squareLeft, this._squareTop, this._squareSize, this._squareSize)), e.drawImage(this._colorWheelCanvas, o, n), (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (e.shadowBlur = 0, e.shadowOffsetX = 0, e.shadowOffsetY = 0), this._drawGradientSquare(this._h, this._squareLeft, this._squareTop, this._squareSize, this._squareSize, e);
          var s = this._squareLeft + this._squareSize * this._s,
              a = this._squareTop + this._squareSize * (1 - this._v);

          this._drawCircle(s, a, .04 * i, e);

          var h = i - .5 * r;
          s = o + i + Math.cos((this._h - 180) * Math.PI / 180) * h, a = n + i + Math.sin((this._h - 180) * Math.PI / 180) * h, this._drawCircle(s, a, .35 * r, e);
        }

        e.restore();
      }, e.prototype._updateValueFromPointer = function (t, e) {
        if (this._pointerStartedOnWheel) {
          var i = .5 * Math.min(this._currentMeasure.width, this._currentMeasure.height),
              r = i + this._currentMeasure.left,
              o = i + this._currentMeasure.top;
          this._h = 180 * Math.atan2(e - o, t - r) / Math.PI + 180;
        } else this._pointerStartedOnSquare && (this._updateSquareProps(), this._s = (t - this._squareLeft) / this._squareSize, this._v = 1 - (e - this._squareTop) / this._squareSize, this._s = Math.min(this._s, 1), this._s = Math.max(this._s, 1e-5), this._v = Math.min(this._v, 1), this._v = Math.max(this._v, 1e-5));

        this._HSVtoRGB(this._h, this._s, this._v, this._tmpColor), this.value = this._tmpColor;
      }, e.prototype._isPointOnSquare = function (t) {
        this._updateSquareProps();

        var e = this._squareLeft,
            i = this._squareTop,
            r = this._squareSize;
        return t.x >= e && t.x <= e + r && t.y >= i && t.y <= i + r;
      }, e.prototype._isPointOnWheel = function (t) {
        var e = .5 * Math.min(this._currentMeasure.width, this._currentMeasure.height),
            i = e + this._currentMeasure.left,
            r = e + this._currentMeasure.top,
            o = e - .2 * e,
            n = e * e,
            s = o * o,
            a = t.x - i,
            h = t.y - r,
            l = a * a + h * h;
        return l <= n && l >= s;
      }, e.prototype._onPointerDown = function (e, i, r, o) {
        return !!t.prototype._onPointerDown.call(this, e, i, r, o) && (this._pointerIsDown = !0, this._pointerStartedOnSquare = !1, this._pointerStartedOnWheel = !1, this._isPointOnSquare(i) ? this._pointerStartedOnSquare = !0 : this._isPointOnWheel(i) && (this._pointerStartedOnWheel = !0), this._updateValueFromPointer(i.x, i.y), this._host._capturingControl[r] = this, !0);
      }, e.prototype._onPointerMove = function (e, i) {
        this._pointerIsDown && this._updateValueFromPointer(i.x, i.y), t.prototype._onPointerMove.call(this, e, i);
      }, e.prototype._onPointerUp = function (e, i, r, o, n) {
        this._pointerIsDown = !1, delete this._host._capturingControl[r], t.prototype._onPointerUp.call(this, e, i, r, o, n);
      }, e;
    }(o.Control);

    e.ColorPicker = s;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t20 = function t(e, i) {
        return (_t20 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t20(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(4),
        n = i(1),
        s = function (t) {
      function e(e) {
        var i = t.call(this, e) || this;
        return i.name = e, i._thickness = 1, i;
      }

      return r(e, t), Object.defineProperty(e.prototype, "thickness", {
        get: function get() {
          return this._thickness;
        },
        set: function set(t) {
          this._thickness !== t && (this._thickness = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._getTypeName = function () {
        return "Ellipse";
      }, e.prototype._localDraw = function (t) {
        t.save(), (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (t.shadowColor = this.shadowColor, t.shadowBlur = this.shadowBlur, t.shadowOffsetX = this.shadowOffsetX, t.shadowOffsetY = this.shadowOffsetY), n.Control.drawEllipse(this._currentMeasure.left + this._currentMeasure.width / 2, this._currentMeasure.top + this._currentMeasure.height / 2, this._currentMeasure.width / 2 - this._thickness / 2, this._currentMeasure.height / 2 - this._thickness / 2, t), this._background && (t.fillStyle = this._background, t.fill()), (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (t.shadowBlur = 0, t.shadowOffsetX = 0, t.shadowOffsetY = 0), this._thickness && (this.color && (t.strokeStyle = this.color), t.lineWidth = this._thickness, t.stroke()), t.restore();
      }, e.prototype._additionalProcessing = function (e, i) {
        t.prototype._additionalProcessing.call(this, e, i), this._measureForChildren.width -= 2 * this._thickness, this._measureForChildren.height -= 2 * this._thickness, this._measureForChildren.left += this._thickness, this._measureForChildren.top += this._thickness;
      }, e.prototype._clipForChildren = function (t) {
        n.Control.drawEllipse(this._currentMeasure.left + this._currentMeasure.width / 2, this._currentMeasure.top + this._currentMeasure.height / 2, this._currentMeasure.width / 2, this._currentMeasure.height / 2, t), t.clip();
      }, e;
    }(o.Container);

    e.Ellipse = s;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t21 = function t(e, i) {
        return (_t21 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t21(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(4),
        n = i(2),
        s = i(1),
        a = function (t) {
      function e(e) {
        var i = t.call(this, e) || this;
        return i.name = e, i._rowDefinitions = new Array(), i._columnDefinitions = new Array(), i._cells = {}, i._childControls = new Array(), i;
      }

      return r(e, t), Object.defineProperty(e.prototype, "children", {
        get: function get() {
          return this._childControls;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.addRowDefinition = function (t, e) {
        return void 0 === e && (e = !1), this._rowDefinitions.push(new n.ValueAndUnit(t, e ? n.ValueAndUnit.UNITMODE_PIXEL : n.ValueAndUnit.UNITMODE_PERCENTAGE)), this._markAsDirty(), this;
      }, e.prototype.addColumnDefinition = function (t, e) {
        return void 0 === e && (e = !1), this._columnDefinitions.push(new n.ValueAndUnit(t, e ? n.ValueAndUnit.UNITMODE_PIXEL : n.ValueAndUnit.UNITMODE_PERCENTAGE)), this._markAsDirty(), this;
      }, e.prototype.setRowDefinition = function (t, e, i) {
        return void 0 === i && (i = !1), t < 0 || t >= this._rowDefinitions.length ? this : (this._rowDefinitions[t] = new n.ValueAndUnit(e, i ? n.ValueAndUnit.UNITMODE_PIXEL : n.ValueAndUnit.UNITMODE_PERCENTAGE), this._markAsDirty(), this);
      }, e.prototype.setColumnDefinition = function (t, e, i) {
        return void 0 === i && (i = !1), t < 0 || t >= this._columnDefinitions.length ? this : (this._columnDefinitions[t] = new n.ValueAndUnit(e, i ? n.ValueAndUnit.UNITMODE_PIXEL : n.ValueAndUnit.UNITMODE_PERCENTAGE), this._markAsDirty(), this);
      }, e.prototype._removeCell = function (e, i) {
        if (e) {
          t.prototype.removeControl.call(this, e);

          for (var r = 0, o = e.children; r < o.length; r++) {
            var n = o[r],
                s = this._childControls.indexOf(n);

            -1 !== s && this._childControls.splice(s, 1);
          }

          delete this._cells[i];
        }
      }, e.prototype._offsetCell = function (t, e) {
        if (this._cells[e]) {
          this._cells[t] = this._cells[e];

          for (var i = 0, r = this._cells[t].children; i < r.length; i++) {
            r[i]._tag = t;
          }

          delete this._cells[e];
        }
      }, e.prototype.removeColumnDefinition = function (t) {
        if (t < 0 || t >= this._columnDefinitions.length) return this;

        for (var e = 0; e < this._rowDefinitions.length; e++) {
          var i = e + ":" + t,
              r = this._cells[i];

          this._removeCell(r, i);
        }

        for (e = 0; e < this._rowDefinitions.length; e++) {
          for (var o = t + 1; o < this._columnDefinitions.length; o++) {
            var n = e + ":" + (o - 1);
            i = e + ":" + o;

            this._offsetCell(n, i);
          }
        }

        return this._columnDefinitions.splice(t, 1), this._markAsDirty(), this;
      }, e.prototype.removeRowDefinition = function (t) {
        if (t < 0 || t >= this._rowDefinitions.length) return this;

        for (var e = 0; e < this._columnDefinitions.length; e++) {
          var i = t + ":" + e,
              r = this._cells[i];

          this._removeCell(r, i);
        }

        for (e = 0; e < this._columnDefinitions.length; e++) {
          for (var o = t + 1; o < this._rowDefinitions.length; o++) {
            var n = o - 1 + ":" + e;
            i = o + ":" + e;

            this._offsetCell(n, i);
          }
        }

        return this._rowDefinitions.splice(t, 1), this._markAsDirty(), this;
      }, e.prototype.addControl = function (e, i, r) {
        void 0 === i && (i = 0), void 0 === r && (r = 0), 0 === this._rowDefinitions.length && this.addRowDefinition(1, !1), 0 === this._columnDefinitions.length && this.addColumnDefinition(1, !1);
        var n = Math.min(i, this._rowDefinitions.length - 1) + ":" + Math.min(r, this._columnDefinitions.length - 1),
            a = this._cells[n];
        return a || (a = new o.Container(n), this._cells[n] = a, a.horizontalAlignment = s.Control.HORIZONTAL_ALIGNMENT_LEFT, a.verticalAlignment = s.Control.VERTICAL_ALIGNMENT_TOP, t.prototype.addControl.call(this, a)), a.addControl(e), this._childControls.push(e), e._tag = n, this._markAsDirty(), this;
      }, e.prototype.removeControl = function (t) {
        var e = this._childControls.indexOf(t);

        -1 !== e && this._childControls.splice(e, 1);
        var i = this._cells[t._tag];
        return i && i.removeControl(t), this._markAsDirty(), this;
      }, e.prototype._getTypeName = function () {
        return "Grid";
      }, e.prototype._additionalProcessing = function (e, i) {
        for (var r = [], o = [], n = [], s = [], a = this._currentMeasure.width, h = 0, l = this._currentMeasure.height, u = 0, c = 0, _ = 0, f = this._rowDefinitions; _ < f.length; _++) {
          if ((b = f[_]).isPixel) l -= g = b.getValue(this._host), o[c] = g;else u += b.internalValue;
          c++;
        }

        var p = 0;
        c = 0;

        for (var d = 0, y = this._rowDefinitions; d < y.length; d++) {
          var g,
              b = y[d];
          if (s.push(p), b.isPixel) p += b.getValue(this._host);else p += g = b.internalValue / u * l, o[c] = g;
          c++;
        }

        c = 0;

        for (var m = 0, v = this._columnDefinitions; m < v.length; m++) {
          if ((b = v[m]).isPixel) a -= w = b.getValue(this._host), r[c] = w;else h += b.internalValue;
          c++;
        }

        var O = 0;
        c = 0;

        for (var P = 0, C = this._columnDefinitions; P < C.length; P++) {
          var w;
          b = C[P];
          if (n.push(O), b.isPixel) O += b.getValue(this._host);else O += w = b.internalValue / h * a, r[c] = w;
          c++;
        }

        for (var T in this._cells) {
          if (this._cells.hasOwnProperty(T)) {
            var M = T.split(":"),
                x = parseInt(M[0]),
                A = parseInt(M[1]),
                k = this._cells[T];
            k.left = n[A] + "px", k.top = s[x] + "px", k.width = r[A] + "px", k.height = o[x] + "px";
          }
        }

        t.prototype._additionalProcessing.call(this, e, i);
      }, e.prototype.dispose = function () {
        t.prototype.dispose.call(this);

        for (var e = 0, i = this._childControls; e < i.length; e++) {
          i[e].dispose();
        }
      }, e;
    }(o.Container);

    e.Grid = a;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t22 = function t(e, i) {
        return (_t22 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t22(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = function (t) {
      function e() {
        return null !== t && t.apply(this, arguments) || this;
      }

      return r(e, t), e.prototype._beforeRenderText = function (t) {
        for (var e = "", i = 0; i < t.length; i++) {
          e += "•";
        }

        return e;
      }, e;
    }(i(19).InputText);

    e.InputPassword = o;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t23 = function t(e, i) {
        return (_t23 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t23(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(1),
        n = i(2),
        s = i(0),
        a = function (t) {
      function e(e) {
        var i = t.call(this, e) || this;
        return i.name = e, i._lineWidth = 1, i._x1 = new n.ValueAndUnit(0), i._y1 = new n.ValueAndUnit(0), i._x2 = new n.ValueAndUnit(0), i._y2 = new n.ValueAndUnit(0), i._dash = new Array(), i.isHitTestVisible = !1, i._horizontalAlignment = o.Control.HORIZONTAL_ALIGNMENT_LEFT, i._verticalAlignment = o.Control.VERTICAL_ALIGNMENT_TOP, i;
      }

      return r(e, t), Object.defineProperty(e.prototype, "dash", {
        get: function get() {
          return this._dash;
        },
        set: function set(t) {
          this._dash !== t && (this._dash = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "connectedControl", {
        get: function get() {
          return this._connectedControl;
        },
        set: function set(t) {
          var e = this;
          this._connectedControl !== t && (this._connectedControlDirtyObserver && this._connectedControl && (this._connectedControl.onDirtyObservable.remove(this._connectedControlDirtyObserver), this._connectedControlDirtyObserver = null), t && (this._connectedControlDirtyObserver = t.onDirtyObservable.add(function () {
            return e._markAsDirty();
          })), this._connectedControl = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "x1", {
        get: function get() {
          return this._x1.toString(this._host);
        },
        set: function set(t) {
          this._x1.toString(this._host) !== t && this._x1.fromString(t) && this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "y1", {
        get: function get() {
          return this._y1.toString(this._host);
        },
        set: function set(t) {
          this._y1.toString(this._host) !== t && this._y1.fromString(t) && this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "x2", {
        get: function get() {
          return this._x2.toString(this._host);
        },
        set: function set(t) {
          this._x2.toString(this._host) !== t && this._x2.fromString(t) && this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "y2", {
        get: function get() {
          return this._y2.toString(this._host);
        },
        set: function set(t) {
          this._y2.toString(this._host) !== t && this._y2.fromString(t) && this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "lineWidth", {
        get: function get() {
          return this._lineWidth;
        },
        set: function set(t) {
          this._lineWidth !== t && (this._lineWidth = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "horizontalAlignment", {
        set: function set(t) {},
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "verticalAlignment", {
        set: function set(t) {},
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "_effectiveX2", {
        get: function get() {
          return (this._connectedControl ? this._connectedControl.centerX : 0) + this._x2.getValue(this._host);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "_effectiveY2", {
        get: function get() {
          return (this._connectedControl ? this._connectedControl.centerY : 0) + this._y2.getValue(this._host);
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._getTypeName = function () {
        return "Line";
      }, e.prototype._draw = function (t, e) {
        e.save(), (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (e.shadowColor = this.shadowColor, e.shadowBlur = this.shadowBlur, e.shadowOffsetX = this.shadowOffsetX, e.shadowOffsetY = this.shadowOffsetY), this._applyStates(e), this._processMeasures(t, e) && (e.strokeStyle = this.color, e.lineWidth = this._lineWidth, e.setLineDash(this._dash), e.beginPath(), e.moveTo(this._x1.getValue(this._host), this._y1.getValue(this._host)), e.lineTo(this._effectiveX2, this._effectiveY2), e.stroke()), e.restore();
      }, e.prototype._measure = function () {
        this._currentMeasure.width = Math.abs(this._x1.getValue(this._host) - this._effectiveX2) + this._lineWidth, this._currentMeasure.height = Math.abs(this._y1.getValue(this._host) - this._effectiveY2) + this._lineWidth;
      }, e.prototype._computeAlignment = function (t, e) {
        this._currentMeasure.left = Math.min(this._x1.getValue(this._host), this._effectiveX2) - this._lineWidth / 2, this._currentMeasure.top = Math.min(this._y1.getValue(this._host), this._effectiveY2) - this._lineWidth / 2;
      }, e.prototype.moveToVector3 = function (t, e, i) {
        if (void 0 === i && (i = !1), this._host && this._root === this._host._rootContainer) {
          var r = this._host._getGlobalViewport(e),
              o = s.Vector3.Project(t, s.Matrix.Identity(), e.getTransformMatrix(), r);

          this._moveToProjectedPosition(o, i), o.z < 0 || o.z > 1 ? this.notRenderable = !0 : this.notRenderable = !1;
        } else s.Tools.Error("Cannot move a control to a vector3 if the control is not at root level");
      }, e.prototype._moveToProjectedPosition = function (t, e) {
        void 0 === e && (e = !1);
        var i = t.x + this._linkOffsetX.getValue(this._host) + "px",
            r = t.y + this._linkOffsetY.getValue(this._host) + "px";
        e ? (this.x2 = i, this.y2 = r, this._x2.ignoreAdaptiveScaling = !0, this._y2.ignoreAdaptiveScaling = !0) : (this.x1 = i, this.y1 = r, this._x1.ignoreAdaptiveScaling = !0, this._y1.ignoreAdaptiveScaling = !0);
      }, e;
    }(o.Control);

    e.Line = a;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t24 = function t(e, i) {
        return (_t24 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t24(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(1),
        n = i(20),
        s = i(0),
        a = function (t) {
      function e(e) {
        var i = t.call(this, e) || this;
        return i.name = e, i._lineWidth = 1, i.onPointUpdate = function () {
          i._markAsDirty();
        }, i.isHitTestVisible = !1, i._horizontalAlignment = o.Control.HORIZONTAL_ALIGNMENT_LEFT, i._verticalAlignment = o.Control.VERTICAL_ALIGNMENT_TOP, i._dash = [], i._points = [], i;
      }

      return r(e, t), Object.defineProperty(e.prototype, "dash", {
        get: function get() {
          return this._dash;
        },
        set: function set(t) {
          this._dash !== t && (this._dash = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.getAt = function (t) {
        return this._points[t] || (this._points[t] = new n.MultiLinePoint(this)), this._points[t];
      }, e.prototype.add = function () {
        for (var t = this, e = [], i = 0; i < arguments.length; i++) {
          e[i] = arguments[i];
        }

        return e.map(function (e) {
          return t.push(e);
        });
      }, e.prototype.push = function (t) {
        var e = this.getAt(this._points.length);
        return null == t ? e : (t instanceof s.AbstractMesh ? e.mesh = t : t instanceof o.Control ? e.control = t : null != t.x && null != t.y && (e.x = t.x, e.y = t.y), e);
      }, e.prototype.remove = function (t) {
        var e;

        if (t instanceof n.MultiLinePoint) {
          if (-1 === (e = this._points.indexOf(t))) return;
        } else e = t;

        var i = this._points[e];
        i && (i.dispose(), this._points.splice(e, 1));
      }, e.prototype.reset = function () {
        for (; this._points.length > 0;) {
          this.remove(this._points.length - 1);
        }
      }, e.prototype.resetLinks = function () {
        this._points.forEach(function (t) {
          null != t && t.resetLinks();
        });
      }, Object.defineProperty(e.prototype, "lineWidth", {
        get: function get() {
          return this._lineWidth;
        },
        set: function set(t) {
          this._lineWidth !== t && (this._lineWidth = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "horizontalAlignment", {
        set: function set(t) {},
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "verticalAlignment", {
        set: function set(t) {},
        enumerable: !0,
        configurable: !0
      }), e.prototype._getTypeName = function () {
        return "MultiLine";
      }, e.prototype._draw = function (t, e) {
        if (e.save(), (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) && (e.shadowColor = this.shadowColor, e.shadowBlur = this.shadowBlur, e.shadowOffsetX = this.shadowOffsetX, e.shadowOffsetY = this.shadowOffsetY), this._applyStates(e), this._processMeasures(t, e)) {
          e.strokeStyle = this.color, e.lineWidth = this._lineWidth, e.setLineDash(this._dash), e.beginPath();
          var i = !0;
          this._points.forEach(function (t) {
            t && (i ? (e.moveTo(t._point.x, t._point.y), i = !1) : e.lineTo(t._point.x, t._point.y));
          }), e.stroke();
        }

        e.restore();
      }, e.prototype._additionalProcessing = function (t, e) {
        var i = this;
        this._minX = null, this._minY = null, this._maxX = null, this._maxY = null, this._points.forEach(function (t, e) {
          t && (t.translate(), (null == i._minX || t._point.x < i._minX) && (i._minX = t._point.x), (null == i._minY || t._point.y < i._minY) && (i._minY = t._point.y), (null == i._maxX || t._point.x > i._maxX) && (i._maxX = t._point.x), (null == i._maxY || t._point.y > i._maxY) && (i._maxY = t._point.y));
        }), null == this._minX && (this._minX = 0), null == this._minY && (this._minY = 0), null == this._maxX && (this._maxX = 0), null == this._maxY && (this._maxY = 0);
      }, e.prototype._measure = function () {
        null != this._minX && null != this._maxX && null != this._minY && null != this._maxY && (this._currentMeasure.width = Math.abs(this._maxX - this._minX) + this._lineWidth, this._currentMeasure.height = Math.abs(this._maxY - this._minY) + this._lineWidth);
      }, e.prototype._computeAlignment = function (t, e) {
        null != this._minX && null != this._minY && (this._currentMeasure.left = this._minX - this._lineWidth / 2, this._currentMeasure.top = this._minY - this._lineWidth / 2);
      }, e.prototype.dispose = function () {
        this.reset(), t.prototype.dispose.call(this);
      }, e;
    }(o.Control);

    e.MultiLine = a;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t25 = function t(e, i) {
        return (_t25 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t25(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(10),
        n = i(6),
        s = i(1),
        a = i(5),
        h = i(18),
        l = i(21),
        u = i(22),
        c = i(4),
        _ = function () {
      function t(t) {
        this.name = t, this._groupPanel = new n.StackPanel(), this._selectors = new Array(), this._groupPanel.verticalAlignment = s.Control.VERTICAL_ALIGNMENT_TOP, this._groupPanel.horizontalAlignment = s.Control.HORIZONTAL_ALIGNMENT_LEFT, this._groupHeader = this._addGroupHeader(t);
      }

      return Object.defineProperty(t.prototype, "groupPanel", {
        get: function get() {
          return this._groupPanel;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "selectors", {
        get: function get() {
          return this._selectors;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "header", {
        get: function get() {
          return this._groupHeader.text;
        },
        set: function set(t) {
          "label" !== this._groupHeader.text && (this._groupHeader.text = t);
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype._addGroupHeader = function (t) {
        var e = new a.TextBlock("groupHead", t);
        return e.width = .9, e.height = "30px", e.textWrapping = !0, e.color = "black", e.horizontalAlignment = s.Control.HORIZONTAL_ALIGNMENT_LEFT, e.textHorizontalAlignment = s.Control.HORIZONTAL_ALIGNMENT_LEFT, e.left = "2px", this._groupPanel.addControl(e), e;
      }, t.prototype._getSelector = function (t) {
        if (!(t < 0 || t >= this._selectors.length)) return this._selectors[t];
      }, t.prototype.removeSelector = function (t) {
        t < 0 || t >= this._selectors.length || (this._groupPanel.removeControl(this._selectors[t]), this._selectors.splice(t, 1));
      }, t;
    }();

    e.SelectorGroup = _;

    var f = function (t) {
      function e() {
        return null !== t && t.apply(this, arguments) || this;
      }

      return r(e, t), e.prototype.addCheckbox = function (t, e, i) {
        void 0 === e && (e = function e(t) {}), void 0 === i && (i = !1);
        i = i || !1;
        var r = new h.Checkbox();
        r.width = "20px", r.height = "20px", r.color = "#364249", r.background = "#CCCCCC", r.horizontalAlignment = s.Control.HORIZONTAL_ALIGNMENT_LEFT, r.onIsCheckedChangedObservable.add(function (t) {
          e(t);
        });
        var o = s.Control.AddHeader(r, t, "200px", {
          isHorizontal: !0,
          controlFirst: !0
        });
        o.height = "30px", o.horizontalAlignment = s.Control.HORIZONTAL_ALIGNMENT_LEFT, o.left = "4px", this.groupPanel.addControl(o), this.selectors.push(o), r.isChecked = i, this.groupPanel.parent && this.groupPanel.parent.parent && (r.color = this.groupPanel.parent.parent.buttonColor, r.background = this.groupPanel.parent.parent.buttonBackground);
      }, e.prototype._setSelectorLabel = function (t, e) {
        this.selectors[t].children[1].text = e;
      }, e.prototype._setSelectorLabelColor = function (t, e) {
        this.selectors[t].children[1].color = e;
      }, e.prototype._setSelectorButtonColor = function (t, e) {
        this.selectors[t].children[0].color = e;
      }, e.prototype._setSelectorButtonBackground = function (t, e) {
        this.selectors[t].children[0].background = e;
      }, e;
    }(_);

    e.CheckboxGroup = f;

    var p = function (t) {
      function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e._selectNb = 0, e;
      }

      return r(e, t), e.prototype.addRadio = function (t, e, i) {
        void 0 === e && (e = function e(t) {}), void 0 === i && (i = !1);
        var r = this._selectNb++,
            o = new l.RadioButton();
        o.name = t, o.width = "20px", o.height = "20px", o.color = "#364249", o.background = "#CCCCCC", o.group = this.name, o.horizontalAlignment = s.Control.HORIZONTAL_ALIGNMENT_LEFT, o.onIsCheckedChangedObservable.add(function (t) {
          t && e(r);
        });
        var n = s.Control.AddHeader(o, t, "200px", {
          isHorizontal: !0,
          controlFirst: !0
        });
        n.height = "30px", n.horizontalAlignment = s.Control.HORIZONTAL_ALIGNMENT_LEFT, n.left = "4px", this.groupPanel.addControl(n), this.selectors.push(n), o.isChecked = i, this.groupPanel.parent && this.groupPanel.parent.parent && (o.color = this.groupPanel.parent.parent.buttonColor, o.background = this.groupPanel.parent.parent.buttonBackground);
      }, e.prototype._setSelectorLabel = function (t, e) {
        this.selectors[t].children[1].text = e;
      }, e.prototype._setSelectorLabelColor = function (t, e) {
        this.selectors[t].children[1].color = e;
      }, e.prototype._setSelectorButtonColor = function (t, e) {
        this.selectors[t].children[0].color = e;
      }, e.prototype._setSelectorButtonBackground = function (t, e) {
        this.selectors[t].children[0].background = e;
      }, e;
    }(_);

    e.RadioGroup = p;

    var d = function (t) {
      function e() {
        return null !== t && t.apply(this, arguments) || this;
      }

      return r(e, t), e.prototype.addSlider = function (t, e, i, r, o, n, a) {
        void 0 === e && (e = function e(t) {}), void 0 === i && (i = "Units"), void 0 === r && (r = 0), void 0 === o && (o = 0), void 0 === n && (n = 0), void 0 === a && (a = function a(t) {
          return 0 | t;
        });
        var h = new u.Slider();
        h.name = i, h.value = n, h.minimum = r, h.maximum = o, h.width = .9, h.height = "20px", h.color = "#364249", h.background = "#CCCCCC", h.borderColor = "black", h.horizontalAlignment = s.Control.HORIZONTAL_ALIGNMENT_LEFT, h.left = "4px", h.paddingBottom = "4px", h.onValueChangedObservable.add(function (t) {
          h.parent.children[0].text = h.parent.children[0].name + ": " + a(t) + " " + h.name, e(t);
        });
        var l = s.Control.AddHeader(h, t + ": " + a(n) + " " + i, "30px", {
          isHorizontal: !1,
          controlFirst: !1
        });
        l.height = "60px", l.horizontalAlignment = s.Control.HORIZONTAL_ALIGNMENT_LEFT, l.left = "4px", l.children[0].name = t, this.groupPanel.addControl(l), this.selectors.push(l), this.groupPanel.parent && this.groupPanel.parent.parent && (h.color = this.groupPanel.parent.parent.buttonColor, h.background = this.groupPanel.parent.parent.buttonBackground);
      }, e.prototype._setSelectorLabel = function (t, e) {
        this.selectors[t].children[0].name = e, this.selectors[t].children[0].text = e + ": " + this.selectors[t].children[1].value + " " + this.selectors[t].children[1].name;
      }, e.prototype._setSelectorLabelColor = function (t, e) {
        this.selectors[t].children[0].color = e;
      }, e.prototype._setSelectorButtonColor = function (t, e) {
        this.selectors[t].children[1].color = e;
      }, e.prototype._setSelectorButtonBackground = function (t, e) {
        this.selectors[t].children[1].background = e;
      }, e;
    }(_);

    e.SliderGroup = d;

    var y = function (t) {
      function e(e, i) {
        void 0 === i && (i = []);
        var r = t.call(this, e) || this;

        if (r.name = e, r.groups = i, r._buttonColor = "#364249", r._buttonBackground = "#CCCCCC", r._headerColor = "black", r._barColor = "white", r._barHeight = "2px", r._spacerHeight = "20px", r._bars = new Array(), r._groups = i, r.thickness = 2, r._panel = new n.StackPanel(), r._panel.verticalAlignment = s.Control.VERTICAL_ALIGNMENT_TOP, r._panel.horizontalAlignment = s.Control.HORIZONTAL_ALIGNMENT_LEFT, r._panel.top = 5, r._panel.left = 5, r._panel.width = .95, i.length > 0) {
          for (var o = 0; o < i.length - 1; o++) {
            r._panel.addControl(i[o].groupPanel), r._addSpacer();
          }

          r._panel.addControl(i[i.length - 1].groupPanel);
        }

        return r.addControl(r._panel), r;
      }

      return r(e, t), e.prototype._getTypeName = function () {
        return "SelectionPanel";
      }, Object.defineProperty(e.prototype, "headerColor", {
        get: function get() {
          return this._headerColor;
        },
        set: function set(t) {
          this._headerColor !== t && (this._headerColor = t, this._setHeaderColor());
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._setHeaderColor = function () {
        for (var t = 0; t < this._groups.length; t++) {
          this._groups[t].groupPanel.children[0].color = this._headerColor;
        }
      }, Object.defineProperty(e.prototype, "buttonColor", {
        get: function get() {
          return this._buttonColor;
        },
        set: function set(t) {
          this._buttonColor !== t && (this._buttonColor = t, this._setbuttonColor());
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._setbuttonColor = function () {
        for (var t = 0; t < this._groups.length; t++) {
          for (var e = 0; e < this._groups[t].selectors.length; e++) {
            this._groups[t]._setSelectorButtonColor(e, this._buttonColor);
          }
        }
      }, Object.defineProperty(e.prototype, "labelColor", {
        get: function get() {
          return this._labelColor;
        },
        set: function set(t) {
          this._labelColor !== t && (this._labelColor = t, this._setLabelColor());
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._setLabelColor = function () {
        for (var t = 0; t < this._groups.length; t++) {
          for (var e = 0; e < this._groups[t].selectors.length; e++) {
            this._groups[t]._setSelectorLabelColor(e, this._labelColor);
          }
        }
      }, Object.defineProperty(e.prototype, "buttonBackground", {
        get: function get() {
          return this._buttonBackground;
        },
        set: function set(t) {
          this._buttonBackground !== t && (this._buttonBackground = t, this._setButtonBackground());
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._setButtonBackground = function () {
        for (var t = 0; t < this._groups.length; t++) {
          for (var e = 0; e < this._groups[t].selectors.length; e++) {
            this._groups[t]._setSelectorButtonBackground(e, this._buttonBackground);
          }
        }
      }, Object.defineProperty(e.prototype, "barColor", {
        get: function get() {
          return this._barColor;
        },
        set: function set(t) {
          this._barColor !== t && (this._barColor = t, this._setBarColor());
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._setBarColor = function () {
        for (var t = 0; t < this._bars.length; t++) {
          this._bars[t].children[0].background = this._barColor;
        }
      }, Object.defineProperty(e.prototype, "barHeight", {
        get: function get() {
          return this._barHeight;
        },
        set: function set(t) {
          this._barHeight !== t && (this._barHeight = t, this._setBarHeight());
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._setBarHeight = function () {
        for (var t = 0; t < this._bars.length; t++) {
          this._bars[t].children[0].height = this._barHeight;
        }
      }, Object.defineProperty(e.prototype, "spacerHeight", {
        get: function get() {
          return this._spacerHeight;
        },
        set: function set(t) {
          this._spacerHeight !== t && (this._spacerHeight = t, this._setSpacerHeight());
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._setSpacerHeight = function () {
        for (var t = 0; t < this._bars.length; t++) {
          this._bars[t].height = this._spacerHeight;
        }
      }, e.prototype._addSpacer = function () {
        var t = new c.Container();
        t.width = 1, t.height = this._spacerHeight, t.horizontalAlignment = s.Control.HORIZONTAL_ALIGNMENT_LEFT;
        var e = new o.Rectangle();
        e.width = 1, e.height = this._barHeight, e.horizontalAlignment = s.Control.HORIZONTAL_ALIGNMENT_LEFT, e.verticalAlignment = s.Control.VERTICAL_ALIGNMENT_CENTER, e.background = this._barColor, e.color = "transparent", t.addControl(e), this._panel.addControl(t), this._bars.push(t);
      }, e.prototype.addGroup = function (t) {
        this._groups.length > 0 && this._addSpacer(), this._panel.addControl(t.groupPanel), this._groups.push(t), t.groupPanel.children[0].color = this._headerColor;

        for (var e = 0; e < t.selectors.length; e++) {
          t._setSelectorButtonColor(e, this._buttonColor), t._setSelectorButtonBackground(e, this._buttonBackground);
        }
      }, e.prototype.removeGroup = function (t) {
        if (!(t < 0 || t >= this._groups.length)) {
          var e = this._groups[t];
          this._panel.removeControl(e.groupPanel), this._groups.splice(t, 1), t < this._bars.length && (this._panel.removeControl(this._bars[t]), this._bars.splice(t, 1));
        }
      }, e.prototype.setHeaderName = function (t, e) {
        e < 0 || e >= this._groups.length || (this._groups[e].groupPanel.children[0].text = t);
      }, e.prototype.relabel = function (t, e, i) {
        if (!(e < 0 || e >= this._groups.length)) {
          var r = this._groups[e];
          i < 0 || i >= r.selectors.length || r._setSelectorLabel(i, t);
        }
      }, e.prototype.removeFromGroupSelector = function (t, e) {
        if (!(t < 0 || t >= this._groups.length)) {
          var i = this._groups[t];
          e < 0 || e >= i.selectors.length || i.removeSelector(e);
        }
      }, e.prototype.addToGroupCheckbox = function (t, e, i, r) {
        (void 0 === i && (i = function i() {}), void 0 === r && (r = !1), t < 0 || t >= this._groups.length) || this._groups[t].addCheckbox(e, i, r);
      }, e.prototype.addToGroupRadio = function (t, e, i, r) {
        (void 0 === i && (i = function i() {}), void 0 === r && (r = !1), t < 0 || t >= this._groups.length) || this._groups[t].addRadio(e, i, r);
      }, e.prototype.addToGroupSlider = function (t, e, i, r, o, n, s, a) {
        (void 0 === i && (i = function i() {}), void 0 === r && (r = "Units"), void 0 === o && (o = 0), void 0 === n && (n = 0), void 0 === s && (s = 0), void 0 === a && (a = function a(t) {
          return 0 | t;
        }), t < 0 || t >= this._groups.length) || this._groups[t].addSlider(e, i, r, o, n, s, a);
      }, e;
    }(o.Rectangle);

    e.SelectionPanel = y;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t26 = function t(e, i) {
        return (_t26 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t26(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(6),
        n = i(0),
        s = i(16),
        a = function () {
      return function () {};
    }();

    e.KeyPropertySet = a;

    var h = function (t) {
      function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.onKeyPressObservable = new n.Observable(), e.defaultButtonWidth = "40px", e.defaultButtonHeight = "40px", e.defaultButtonPaddingLeft = "2px", e.defaultButtonPaddingRight = "2px", e.defaultButtonPaddingTop = "2px", e.defaultButtonPaddingBottom = "2px", e.defaultButtonColor = "#DDD", e.defaultButtonBackground = "#070707", e.shiftButtonColor = "#7799FF", e.selectedShiftThickness = 1, e.shiftState = 0, e._currentlyConnectedInputText = null, e._connectedInputTexts = [], e._onKeyPressObserver = null, e;
      }

      return r(e, t), e.prototype._getTypeName = function () {
        return "VirtualKeyboard";
      }, e.prototype._createKey = function (t, e) {
        var i = this,
            r = s.Button.CreateSimpleButton(t, t);
        return r.width = e && e.width ? e.width : this.defaultButtonWidth, r.height = e && e.height ? e.height : this.defaultButtonHeight, r.color = e && e.color ? e.color : this.defaultButtonColor, r.background = e && e.background ? e.background : this.defaultButtonBackground, r.paddingLeft = e && e.paddingLeft ? e.paddingLeft : this.defaultButtonPaddingLeft, r.paddingRight = e && e.paddingRight ? e.paddingRight : this.defaultButtonPaddingRight, r.paddingTop = e && e.paddingTop ? e.paddingTop : this.defaultButtonPaddingTop, r.paddingBottom = e && e.paddingBottom ? e.paddingBottom : this.defaultButtonPaddingBottom, r.thickness = 0, r.isFocusInvisible = !0, r.shadowColor = this.shadowColor, r.shadowBlur = this.shadowBlur, r.shadowOffsetX = this.shadowOffsetX, r.shadowOffsetY = this.shadowOffsetY, r.onPointerUpObservable.add(function () {
          i.onKeyPressObservable.notifyObservers(t);
        }), r;
      }, e.prototype.addKeysRow = function (t, e) {
        var i = new o.StackPanel();
        i.isVertical = !1, i.isFocusInvisible = !0;

        for (var r = 0; r < t.length; r++) {
          var n = null;
          e && e.length === t.length && (n = e[r]), i.addControl(this._createKey(t[r], n));
        }

        this.addControl(i);
      }, e.prototype.applyShiftState = function (t) {
        if (this.children) for (var e = 0; e < this.children.length; e++) {
          var i = this.children[e];
          if (i && i.children) for (var r = i, o = 0; o < r.children.length; o++) {
            var n = r.children[o];

            if (n && n.children[0]) {
              var s = n.children[0];
              "⇧" === s.text && (n.color = t ? this.shiftButtonColor : this.defaultButtonColor, n.thickness = t > 1 ? this.selectedShiftThickness : 0), s.text = t > 0 ? s.text.toUpperCase() : s.text.toLowerCase();
            }
          }
        }
      }, Object.defineProperty(e.prototype, "connectedInputText", {
        get: function get() {
          return this._currentlyConnectedInputText;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.connect = function (t) {
        var e = this;

        if (!this._connectedInputTexts.some(function (e) {
          return e.input === t;
        })) {
          null === this._onKeyPressObserver && (this._onKeyPressObserver = this.onKeyPressObservable.add(function (t) {
            if (e._currentlyConnectedInputText) {
              switch (e._currentlyConnectedInputText._host.focusedControl = e._currentlyConnectedInputText, t) {
                case "⇧":
                  return e.shiftState++, e.shiftState > 2 && (e.shiftState = 0), void e.applyShiftState(e.shiftState);

                case "←":
                  return void e._currentlyConnectedInputText.processKey(8);

                case "↵":
                  return void e._currentlyConnectedInputText.processKey(13);
              }

              e._currentlyConnectedInputText.processKey(-1, e.shiftState ? t.toUpperCase() : t), 1 === e.shiftState && (e.shiftState = 0, e.applyShiftState(e.shiftState));
            }
          })), this.isVisible = !1, this._currentlyConnectedInputText = t, t._connectedVirtualKeyboard = this;
          var i = t.onFocusObservable.add(function () {
            e._currentlyConnectedInputText = t, t._connectedVirtualKeyboard = e, e.isVisible = !0;
          }),
              r = t.onBlurObservable.add(function () {
            t._connectedVirtualKeyboard = null, e._currentlyConnectedInputText = null, e.isVisible = !1;
          });

          this._connectedInputTexts.push({
            input: t,
            onBlurObserver: r,
            onFocusObserver: i
          });
        }
      }, e.prototype.disconnect = function (t) {
        var e = this;

        if (t) {
          var i = this._connectedInputTexts.filter(function (e) {
            return e.input === t;
          });

          1 === i.length && (this._removeConnectedInputObservables(i[0]), this._connectedInputTexts = this._connectedInputTexts.filter(function (e) {
            return e.input !== t;
          }), this._currentlyConnectedInputText === t && (this._currentlyConnectedInputText = null));
        } else this._connectedInputTexts.forEach(function (t) {
          e._removeConnectedInputObservables(t);
        }), this._connectedInputTexts = [];

        0 === this._connectedInputTexts.length && (this._currentlyConnectedInputText = null, this.onKeyPressObservable.remove(this._onKeyPressObserver), this._onKeyPressObserver = null);
      }, e.prototype._removeConnectedInputObservables = function (t) {
        t.input._connectedVirtualKeyboard = null, t.input.onFocusObservable.remove(t.onFocusObserver), t.input.onBlurObservable.remove(t.onBlurObserver);
      }, e.prototype.dispose = function () {
        t.prototype.dispose.call(this), this.disconnect();
      }, e.CreateDefaultLayout = function (t) {
        var i = new e(t);
        return i.addKeysRow(["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "←"]), i.addKeysRow(["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"]), i.addKeysRow(["a", "s", "d", "f", "g", "h", "j", "k", "l", ";", "'", "↵"]), i.addKeysRow(["⇧", "z", "x", "c", "v", "b", "n", "m", ",", ".", "/"]), i.addKeysRow([" "], [{
          width: "200px"
        }]), i;
      }, e;
    }(o.StackPanel);

    e.VirtualKeyboard = h;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t27 = function t(e, i) {
        return (_t27 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t27(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = function (t) {
      function e(e) {
        var i = t.call(this, e) || this;
        return i.name = e, i._cellWidth = 20, i._cellHeight = 20, i._minorLineTickness = 1, i._minorLineColor = "DarkGray", i._majorLineTickness = 2, i._majorLineColor = "White", i._majorLineFrequency = 5, i._background = "Black", i._displayMajorLines = !0, i._displayMinorLines = !0, i;
      }

      return r(e, t), Object.defineProperty(e.prototype, "displayMinorLines", {
        get: function get() {
          return this._displayMinorLines;
        },
        set: function set(t) {
          this._displayMinorLines !== t && (this._displayMinorLines = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "displayMajorLines", {
        get: function get() {
          return this._displayMajorLines;
        },
        set: function set(t) {
          this._displayMajorLines !== t && (this._displayMajorLines = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "background", {
        get: function get() {
          return this._background;
        },
        set: function set(t) {
          this._background !== t && (this._background = t, this._markAsDirty());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "cellWidth", {
        get: function get() {
          return this._cellWidth;
        },
        set: function set(t) {
          this._cellWidth = t, this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "cellHeight", {
        get: function get() {
          return this._cellHeight;
        },
        set: function set(t) {
          this._cellHeight = t, this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "minorLineTickness", {
        get: function get() {
          return this._minorLineTickness;
        },
        set: function set(t) {
          this._minorLineTickness = t, this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "minorLineColor", {
        get: function get() {
          return this._minorLineColor;
        },
        set: function set(t) {
          this._minorLineColor = t, this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "majorLineTickness", {
        get: function get() {
          return this._majorLineTickness;
        },
        set: function set(t) {
          this._majorLineTickness = t, this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "majorLineColor", {
        get: function get() {
          return this._majorLineColor;
        },
        set: function set(t) {
          this._majorLineColor = t, this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "majorLineFrequency", {
        get: function get() {
          return this._majorLineFrequency;
        },
        set: function set(t) {
          this._majorLineFrequency = t, this._markAsDirty();
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._draw = function (t, e) {
        if (e.save(), this._applyStates(e), this._isEnabled && this._processMeasures(t, e)) {
          this._background && (e.fillStyle = this._background, e.fillRect(this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height));
          var i = this._currentMeasure.width / this._cellWidth,
              r = this._currentMeasure.height / this._cellHeight,
              o = this._currentMeasure.left + this._currentMeasure.width / 2,
              n = this._currentMeasure.top + this._currentMeasure.height / 2;

          if (this._displayMinorLines) {
            e.strokeStyle = this._minorLineColor, e.lineWidth = this._minorLineTickness;

            for (var s = -i / 2; s < i / 2; s++) {
              var a = o + s * this.cellWidth;
              e.beginPath(), e.moveTo(a, this._currentMeasure.top), e.lineTo(a, this._currentMeasure.top + this._currentMeasure.height), e.stroke();
            }

            for (var h = -r / 2; h < r / 2; h++) {
              var l = n + h * this.cellHeight;
              e.beginPath(), e.moveTo(this._currentMeasure.left, l), e.lineTo(this._currentMeasure.left + this._currentMeasure.width, l), e.stroke();
            }
          }

          if (this._displayMajorLines) {
            e.strokeStyle = this._majorLineColor, e.lineWidth = this._majorLineTickness;

            for (s = -i / 2 + this._majorLineFrequency; s < i / 2; s += this._majorLineFrequency) {
              a = o + s * this.cellWidth;
              e.beginPath(), e.moveTo(a, this._currentMeasure.top), e.lineTo(a, this._currentMeasure.top + this._currentMeasure.height), e.stroke();
            }

            for (h = -r / 2 + this._majorLineFrequency; h < r / 2; h += this._majorLineFrequency) {
              l = n + h * this.cellHeight;
              e.moveTo(this._currentMeasure.left, l), e.lineTo(this._currentMeasure.left + this._currentMeasure.width, l), e.closePath(), e.stroke();
            }
          }
        }

        e.restore();
      }, e.prototype._getTypeName = function () {
        return "DisplayGrid";
      }, e;
    }(i(9).Control);

    e.DisplayGrid = o;
  }, function (t, e, i) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = i(1),
        o = i(6),
        n = i(5);
    e.name = "Statics", r.Control.AddHeader = function (t, e, i, s) {
      var a = new o.StackPanel("panel"),
          h = !s || s.isHorizontal,
          l = !s || s.controlFirst;
      a.isVertical = !h;
      var u = new n.TextBlock("header");
      return u.text = e, u.textHorizontalAlignment = r.Control.HORIZONTAL_ALIGNMENT_LEFT, h ? u.width = i : u.height = i, l ? (a.addControl(t), a.addControl(u), u.paddingLeft = "5px") : (a.addControl(u), a.addControl(t), u.paddingRight = "5px"), u.shadowBlur = t.shadowBlur, u.shadowColor = t.shadowColor, u.shadowOffsetX = t.shadowOffsetX, u.shadowOffsetY = t.shadowOffsetY, a;
    };
  }, function (t, e, i) {
    "use strict";

    function r(t) {
      for (var i in t) {
        e.hasOwnProperty(i) || (e[i] = t[i]);
      }
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), r(i(41)), r(i(52)), r(i(53)), r(i(25));
  }, function (t, e, i) {
    "use strict";

    function r(t) {
      for (var i in t) {
        e.hasOwnProperty(i) || (e[i] = t[i]);
      }
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), r(i(24)), r(i(14)), r(i(3)), r(i(13)), r(i(42)), r(i(43)), r(i(47)), r(i(48)), r(i(49)), r(i(50)), r(i(51)), r(i(8));
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t28 = function t(e, i) {
        return (_t28 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t28(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(8),
        n = i(0),
        s = i(3),
        a = function (t) {
      function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e._radius = 5, e;
      }

      return r(e, t), Object.defineProperty(e.prototype, "radius", {
        get: function get() {
          return this._radius;
        },
        set: function set(t) {
          var e = this;
          this._radius !== t && (this._radius = t, n.Tools.SetImmediate(function () {
            e._arrangeChildren();
          }));
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._mapGridNode = function (t, e) {
        var i = t.mesh;

        if (i) {
          var r = this._cylindricalMapping(e);

          switch (t.position = r, this.orientation) {
            case s.Container3D.FACEORIGIN_ORIENTATION:
              i.lookAt(new BABYLON.Vector3(-r.x, r.y, -r.z));
              break;

            case s.Container3D.FACEORIGINREVERSED_ORIENTATION:
              i.lookAt(new BABYLON.Vector3(2 * r.x, r.y, 2 * r.z));
              break;

            case s.Container3D.FACEFORWARD_ORIENTATION:
              break;

            case s.Container3D.FACEFORWARDREVERSED_ORIENTATION:
              i.rotate(BABYLON.Axis.Y, Math.PI, BABYLON.Space.LOCAL);
          }
        }
      }, e.prototype._cylindricalMapping = function (t) {
        var e = new n.Vector3(0, t.y, this._radius),
            i = t.x / this._radius;
        return n.Matrix.RotationYawPitchRollToRef(i, 0, 0, n.Tmp.Matrix[0]), n.Vector3.TransformNormal(e, n.Tmp.Matrix[0]);
      }, e;
    }(o.VolumeBasedPanel);

    e.CylinderPanel = a;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t29 = function t(e, i) {
        return (_t29 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t29(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(14),
        n = i(0),
        s = i(26),
        a = i(6),
        h = i(11),
        l = i(5),
        u = i(12),
        c = function (t) {
      function e(e, i) {
        void 0 === i && (i = !0);
        var r = t.call(this, e) || this;
        return r._shareMaterials = !0, r._shareMaterials = i, r.pointerEnterAnimation = function () {
          r.mesh && r._frontPlate.setEnabled(!0);
        }, r.pointerOutAnimation = function () {
          r.mesh && r._frontPlate.setEnabled(!1);
        }, r;
      }

      return r(e, t), e.prototype._disposeTooltip = function () {
        this._tooltipFade = null, this._tooltipTextBlock && this._tooltipTextBlock.dispose(), this._tooltipTexture && this._tooltipTexture.dispose(), this._tooltipMesh && this._tooltipMesh.dispose(), this.onPointerEnterObservable.remove(this._tooltipHoverObserver), this.onPointerOutObservable.remove(this._tooltipOutObserver);
      }, Object.defineProperty(e.prototype, "tooltipText", {
        get: function get() {
          return this._tooltipTextBlock ? this._tooltipTextBlock.text : null;
        },
        set: function set(t) {
          var e = this;

          if (t) {
            if (!this._tooltipFade) {
              this._tooltipMesh = BABYLON.MeshBuilder.CreatePlane("", {
                size: 1
              }, this._backPlate._scene);
              var i = BABYLON.MeshBuilder.CreatePlane("", {
                size: 1,
                sideOrientation: BABYLON.Mesh.DOUBLESIDE
              }, this._backPlate._scene),
                  r = new n.StandardMaterial("", this._backPlate._scene);
              r.diffuseColor = BABYLON.Color3.FromHexString("#212121"), i.material = r, i.isPickable = !1, this._tooltipMesh.addChild(i), i.position.z = .05, this._tooltipMesh.scaling.y = 1 / 3, this._tooltipMesh.position.y = .7, this._tooltipMesh.position.z = -.15, this._tooltipMesh.isPickable = !1, this._tooltipMesh.parent = this._backPlate, this._tooltipTexture = u.AdvancedDynamicTexture.CreateForMesh(this._tooltipMesh), this._tooltipTextBlock = new l.TextBlock(), this._tooltipTextBlock.scaleY = 3, this._tooltipTextBlock.color = "white", this._tooltipTextBlock.fontSize = 130, this._tooltipTexture.addControl(this._tooltipTextBlock), this._tooltipFade = new BABYLON.FadeInOutBehavior(), this._tooltipFade.delay = 500, this._tooltipMesh.addBehavior(this._tooltipFade), this._tooltipHoverObserver = this.onPointerEnterObservable.add(function () {
                e._tooltipFade && e._tooltipFade.fadeIn(!0);
              }), this._tooltipOutObserver = this.onPointerOutObservable.add(function () {
                e._tooltipFade && e._tooltipFade.fadeIn(!1);
              });
            }

            this._tooltipTextBlock && (this._tooltipTextBlock.text = t);
          } else this._disposeTooltip();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "text", {
        get: function get() {
          return this._text;
        },
        set: function set(t) {
          this._text !== t && (this._text = t, this._rebuildContent());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "imageUrl", {
        get: function get() {
          return this._imageUrl;
        },
        set: function set(t) {
          this._imageUrl !== t && (this._imageUrl = t, this._rebuildContent());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "backMaterial", {
        get: function get() {
          return this._backMaterial;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "frontMaterial", {
        get: function get() {
          return this._frontMaterial;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "plateMaterial", {
        get: function get() {
          return this._plateMaterial;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "shareMaterials", {
        get: function get() {
          return this._shareMaterials;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._getTypeName = function () {
        return "HolographicButton";
      }, e.prototype._rebuildContent = function () {
        this._disposeFacadeTexture();

        var t = new a.StackPanel();

        if (t.isVertical = !0, this._imageUrl) {
          var e = new h.Image();
          e.source = this._imageUrl, e.paddingTop = "40px", e.height = "180px", e.width = "100px", e.paddingBottom = "40px", t.addControl(e);
        }

        if (this._text) {
          var i = new l.TextBlock();
          i.text = this._text, i.color = "white", i.height = "30px", i.fontSize = 24, t.addControl(i);
        }

        this._frontPlate && (this.content = t);
      }, e.prototype._createNode = function (e) {
        return this._backPlate = n.MeshBuilder.CreateBox(this.name + "BackMesh", {
          width: 1,
          height: 1,
          depth: .08
        }, e), this._frontPlate = n.MeshBuilder.CreateBox(this.name + "FrontMesh", {
          width: 1,
          height: 1,
          depth: .08
        }, e), this._frontPlate.parent = this._backPlate, this._frontPlate.position.z = -.08, this._frontPlate.isPickable = !1, this._frontPlate.setEnabled(!1), this._textPlate = t.prototype._createNode.call(this, e), this._textPlate.parent = this._backPlate, this._textPlate.position.z = -.08, this._textPlate.isPickable = !1, this._backPlate;
      }, e.prototype._applyFacade = function (t) {
        this._plateMaterial.emissiveTexture = t, this._plateMaterial.opacityTexture = t;
      }, e.prototype._createBackMaterial = function (t) {
        var e = this;
        this._backMaterial = new s.FluentMaterial(this.name + "Back Material", t.getScene()), this._backMaterial.renderHoverLight = !0, this._pickedPointObserver = this._host.onPickedPointChangedObservable.add(function (t) {
          t ? (e._backMaterial.hoverPosition = t, e._backMaterial.hoverColor.a = 1) : e._backMaterial.hoverColor.a = 0;
        });
      }, e.prototype._createFrontMaterial = function (t) {
        this._frontMaterial = new s.FluentMaterial(this.name + "Front Material", t.getScene()), this._frontMaterial.innerGlowColorIntensity = 0, this._frontMaterial.alpha = .5, this._frontMaterial.renderBorders = !0;
      }, e.prototype._createPlateMaterial = function (t) {
        this._plateMaterial = new n.StandardMaterial(this.name + "Plate Material", t.getScene()), this._plateMaterial.specularColor = n.Color3.Black();
      }, e.prototype._affectMaterial = function (t) {
        this._shareMaterials ? (this._host._sharedMaterials.backFluentMaterial ? this._backMaterial = this._host._sharedMaterials.backFluentMaterial : (this._createBackMaterial(t), this._host._sharedMaterials.backFluentMaterial = this._backMaterial), this._host._sharedMaterials.frontFluentMaterial ? this._frontMaterial = this._host._sharedMaterials.frontFluentMaterial : (this._createFrontMaterial(t), this._host._sharedMaterials.frontFluentMaterial = this._frontMaterial)) : (this._createBackMaterial(t), this._createFrontMaterial(t)), this._createPlateMaterial(t), this._backPlate.material = this._backMaterial, this._frontPlate.material = this._frontMaterial, this._textPlate.material = this._plateMaterial, this._rebuildContent();
      }, e.prototype.dispose = function () {
        t.prototype.dispose.call(this), this._disposeTooltip(), this.shareMaterials || (this._backMaterial.dispose(), this._frontMaterial.dispose(), this._plateMaterial.dispose(), this._pickedPointObserver && (this._host.onPickedPointChangedObservable.remove(this._pickedPointObserver), this._pickedPointObserver = null));
      }, e;
    }(o.Button3D);

    e.HolographicButton = c;
  }, function (t, e, i) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = i(0),
        o = i(45);
    e.fShader = o;
    var n = i(46);
    e.vShader = n, e.registerShader = function () {
      r.Effect.ShadersStore.fluentVertexShader = n, r.Effect.ShadersStore.fluentPixelShader = o;
    };
  }, function (t, e) {
    t.exports = "precision highp float;\nvarying vec2 vUV;\nuniform vec4 albedoColor;\n#ifdef INNERGLOW\nuniform vec4 innerGlowColor;\n#endif\n#ifdef BORDER\nvarying vec2 scaleInfo;\nuniform float edgeSmoothingValue;\nuniform float borderMinValue;\n#endif\n#ifdef HOVERLIGHT\nvarying vec3 worldPosition;\nuniform vec3 hoverPosition;\nuniform vec4 hoverColor;\nuniform float hoverRadius;\n#endif\n#ifdef TEXTURE\nuniform sampler2D albedoSampler;\n#endif\nvoid main(void) {\nvec3 albedo=albedoColor.rgb;\nfloat alpha=albedoColor.a;\n#ifdef TEXTURE\nalbedo=texture2D(albedoSampler,vUV).rgb;\n#endif\n#ifdef HOVERLIGHT\nfloat pointToHover=(1.0-clamp(length(hoverPosition-worldPosition)/hoverRadius,0.,1.))*hoverColor.a;\nalbedo=clamp(albedo+hoverColor.rgb*pointToHover,0.,1.);\n#else\nfloat pointToHover=1.0;\n#endif\n#ifdef BORDER \nfloat borderPower=10.0;\nfloat inverseBorderPower=1.0/borderPower;\nvec3 borderColor=albedo*borderPower;\nvec2 distanceToEdge;\ndistanceToEdge.x=abs(vUV.x-0.5)*2.0;\ndistanceToEdge.y=abs(vUV.y-0.5)*2.0;\nfloat borderValue=max(smoothstep(scaleInfo.x-edgeSmoothingValue,scaleInfo.x+edgeSmoothingValue,distanceToEdge.x),\nsmoothstep(scaleInfo.y-edgeSmoothingValue,scaleInfo.y+edgeSmoothingValue,distanceToEdge.y));\nborderColor=borderColor*borderValue*max(borderMinValue*inverseBorderPower,pointToHover); \nalbedo+=borderColor;\nalpha=max(alpha,borderValue);\n#endif\n#ifdef INNERGLOW\n\nvec2 uvGlow=(vUV-vec2(0.5,0.5))*(innerGlowColor.a*2.0);\nuvGlow=uvGlow*uvGlow;\nuvGlow=uvGlow*uvGlow;\nalbedo+=mix(vec3(0.0,0.0,0.0),innerGlowColor.rgb,uvGlow.x+uvGlow.y); \n#endif\ngl_FragColor=vec4(albedo,alpha);\n}";
  }, function (t, e) {
    t.exports = "precision highp float;\n\nattribute vec3 position;\nattribute vec3 normal;\nattribute vec2 uv;\n\nuniform mat4 world;\nuniform mat4 viewProjection;\nvarying vec2 vUV;\n#ifdef BORDER\nvarying vec2 scaleInfo;\nuniform float borderWidth;\nuniform vec3 scaleFactor;\n#endif\n#ifdef HOVERLIGHT\nvarying vec3 worldPosition;\n#endif\nvoid main(void) {\nvUV=uv;\n#ifdef BORDER\nvec3 scale=scaleFactor;\nfloat minScale=min(min(scale.x,scale.y),scale.z);\nfloat maxScale=max(max(scale.x,scale.y),scale.z);\nfloat minOverMiddleScale=minScale/(scale.x+scale.y+scale.z-minScale-maxScale);\nfloat areaYZ=scale.y*scale.z;\nfloat areaXZ=scale.x*scale.z;\nfloat areaXY=scale.x*scale.y;\nfloat scaledBorderWidth=borderWidth; \nif (abs(normal.x) == 1.0) \n{\nscale.x=scale.y;\nscale.y=scale.z;\nif (areaYZ>areaXZ && areaYZ>areaXY)\n{\nscaledBorderWidth*=minOverMiddleScale;\n}\n}\nelse if (abs(normal.y) == 1.0) \n{\nscale.x=scale.z;\nif (areaXZ>areaXY && areaXZ>areaYZ)\n{\nscaledBorderWidth*=minOverMiddleScale;\n}\n}\nelse \n{\nif (areaXY>areaYZ && areaXY>areaXZ)\n{\nscaledBorderWidth*=minOverMiddleScale;\n}\n}\nfloat scaleRatio=min(scale.x,scale.y)/max(scale.x,scale.y);\nif (scale.x>scale.y)\n{\nscaleInfo.x=1.0-(scaledBorderWidth*scaleRatio);\nscaleInfo.y=1.0-scaledBorderWidth;\n}\nelse\n{\nscaleInfo.x=1.0-scaledBorderWidth;\nscaleInfo.y=1.0-(scaledBorderWidth*scaleRatio);\n} \n#endif \nvec4 worldPos=world*vec4(position,1.0);\n#ifdef HOVERLIGHT\nworldPosition=worldPos.xyz;\n#endif\ngl_Position=viewProjection*worldPos;\n}\n";
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t30 = function t(e, i) {
        return (_t30 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t30(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = function (t) {
      function e(e, i) {
        var r = t.call(this, i) || this;
        return r._currentMesh = e, r.pointerEnterAnimation = function () {
          r.mesh && r.mesh.scaling.scaleInPlace(1.1);
        }, r.pointerOutAnimation = function () {
          r.mesh && r.mesh.scaling.scaleInPlace(1 / 1.1);
        }, r.pointerDownAnimation = function () {
          r.mesh && r.mesh.scaling.scaleInPlace(.95);
        }, r.pointerUpAnimation = function () {
          r.mesh && r.mesh.scaling.scaleInPlace(1 / .95);
        }, r;
      }

      return r(e, t), e.prototype._getTypeName = function () {
        return "MeshButton3D";
      }, e.prototype._createNode = function (t) {
        var e = this;
        return this._currentMesh.getChildMeshes().forEach(function (t) {
          t.metadata = e;
        }), this._currentMesh;
      }, e.prototype._affectMaterial = function (t) {}, e;
    }(i(14).Button3D);

    e.MeshButton3D = o;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t31 = function t(e, i) {
        return (_t31 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t31(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(0),
        n = i(3),
        s = function (t) {
      function e() {
        return null !== t && t.apply(this, arguments) || this;
      }

      return r(e, t), e.prototype._mapGridNode = function (t, e) {
        var i = t.mesh;

        if (i) {
          t.position = e.clone();
          var r = o.Tmp.Vector3[0];

          switch (r.copyFrom(e), this.orientation) {
            case n.Container3D.FACEORIGIN_ORIENTATION:
            case n.Container3D.FACEFORWARD_ORIENTATION:
              r.addInPlace(new BABYLON.Vector3(0, 0, -1)), i.lookAt(r);
              break;

            case n.Container3D.FACEFORWARDREVERSED_ORIENTATION:
            case n.Container3D.FACEORIGINREVERSED_ORIENTATION:
              r.addInPlace(new BABYLON.Vector3(0, 0, 1)), i.lookAt(r);
          }
        }
      }, e;
    }(i(8).VolumeBasedPanel);

    e.PlanePanel = s;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t32 = function t(e, i) {
        return (_t32 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t32(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(8),
        n = i(0),
        s = i(3),
        a = function (t) {
      function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e._iteration = 100, e;
      }

      return r(e, t), Object.defineProperty(e.prototype, "iteration", {
        get: function get() {
          return this._iteration;
        },
        set: function set(t) {
          var e = this;
          this._iteration !== t && (this._iteration = t, n.Tools.SetImmediate(function () {
            e._arrangeChildren();
          }));
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._mapGridNode = function (t, e) {
        var i = t.mesh,
            r = this._scatterMapping(e);

        if (i) {
          switch (this.orientation) {
            case s.Container3D.FACEORIGIN_ORIENTATION:
            case s.Container3D.FACEFORWARD_ORIENTATION:
              i.lookAt(new n.Vector3(0, 0, -1));
              break;

            case s.Container3D.FACEFORWARDREVERSED_ORIENTATION:
            case s.Container3D.FACEORIGINREVERSED_ORIENTATION:
              i.lookAt(new n.Vector3(0, 0, 1));
          }

          t.position = r;
        }
      }, e.prototype._scatterMapping = function (t) {
        return t.x = (1 - 2 * Math.random()) * this._cellWidth, t.y = (1 - 2 * Math.random()) * this._cellHeight, t;
      }, e.prototype._finalProcessing = function () {
        for (var t = [], e = 0, i = this._children; e < i.length; e++) {
          var r = i[e];
          r.mesh && t.push(r.mesh);
        }

        for (var o = 0; o < this._iteration; o++) {
          t.sort(function (t, e) {
            var i = t.position.lengthSquared(),
                r = e.position.lengthSquared();
            return i < r ? 1 : i > r ? -1 : 0;
          });

          for (var s = Math.pow(this.margin, 2), a = Math.max(this._cellWidth, this._cellHeight), h = n.Tmp.Vector2[0], l = n.Tmp.Vector3[0], u = 0; u < t.length - 1; u++) {
            for (var c = u + 1; c < t.length; c++) {
              if (u != c) {
                t[c].position.subtractToRef(t[u].position, l), h.x = l.x, h.y = l.y;
                var _ = a,
                    f = h.lengthSquared() - s;
                (f -= Math.min(f, s)) < Math.pow(_, 2) && (h.normalize(), l.scaleInPlace(.5 * (_ - Math.sqrt(f))), t[c].position.addInPlace(l), t[u].position.subtractInPlace(l));
              }
            }
          }
        }
      }, e;
    }(o.VolumeBasedPanel);

    e.ScatterPanel = a;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t33 = function t(e, i) {
        return (_t33 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t33(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(8),
        n = i(0),
        s = i(3),
        a = function (t) {
      function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e._radius = 5, e;
      }

      return r(e, t), Object.defineProperty(e.prototype, "radius", {
        get: function get() {
          return this._radius;
        },
        set: function set(t) {
          var e = this;
          this._radius !== t && (this._radius = t, n.Tools.SetImmediate(function () {
            e._arrangeChildren();
          }));
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._mapGridNode = function (t, e) {
        var i = t.mesh;

        if (i) {
          var r = this._sphericalMapping(e);

          switch (t.position = r, this.orientation) {
            case s.Container3D.FACEORIGIN_ORIENTATION:
              i.lookAt(new BABYLON.Vector3(-r.x, -r.y, -r.z));
              break;

            case s.Container3D.FACEORIGINREVERSED_ORIENTATION:
              i.lookAt(new BABYLON.Vector3(2 * r.x, 2 * r.y, 2 * r.z));
              break;

            case s.Container3D.FACEFORWARD_ORIENTATION:
              break;

            case s.Container3D.FACEFORWARDREVERSED_ORIENTATION:
              i.rotate(BABYLON.Axis.Y, Math.PI, BABYLON.Space.LOCAL);
          }
        }
      }, e.prototype._sphericalMapping = function (t) {
        var e = new n.Vector3(0, 0, this._radius),
            i = t.y / this._radius,
            r = -t.x / this._radius;
        return n.Matrix.RotationYawPitchRollToRef(r, i, 0, n.Tmp.Matrix[0]), n.Vector3.TransformNormal(e, n.Tmp.Matrix[0]);
      }, e;
    }(o.VolumeBasedPanel);

    e.SpherePanel = a;
  }, function (t, e, i) {
    "use strict";

    var r = this && this.__extends || function () {
      var _t34 = function t(e, i) {
        return (_t34 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var i in e) {
            e.hasOwnProperty(i) && (t[i] = e[i]);
          }
        })(e, i);
      };

      return function (e, i) {
        function r() {
          this.constructor = e;
        }

        _t34(e, i), e.prototype = null === i ? Object.create(i) : (r.prototype = i.prototype, new r());
      };
    }();

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = i(3),
        n = i(0),
        s = function (t) {
      function e(e) {
        void 0 === e && (e = !1);
        var i = t.call(this) || this;
        return i._isVertical = !1, i.margin = .1, i._isVertical = e, i;
      }

      return r(e, t), Object.defineProperty(e.prototype, "isVertical", {
        get: function get() {
          return this._isVertical;
        },
        set: function set(t) {
          var e = this;
          this._isVertical !== t && (this._isVertical = t, n.Tools.SetImmediate(function () {
            e._arrangeChildren();
          }));
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype._arrangeChildren = function () {
        for (var t, e = 0, i = 0, r = 0, o = [], s = n.Matrix.Invert(this.node.computeWorldMatrix(!0)), a = 0, h = this._children; a < h.length; a++) {
          if ((p = h[a]).mesh) {
            r++, p.mesh.computeWorldMatrix(!0), p.mesh.getWorldMatrix().multiplyToRef(s, n.Tmp.Matrix[0]);
            var l = p.mesh.getBoundingInfo().boundingBox,
                u = n.Vector3.TransformNormal(l.extendSize, n.Tmp.Matrix[0]);
            o.push(u), this._isVertical ? i += u.y : e += u.x;
          }
        }

        this._isVertical ? i += (r - 1) * this.margin / 2 : e += (r - 1) * this.margin / 2, t = this._isVertical ? -i : -e;

        for (var c = 0, _ = 0, f = this._children; _ < f.length; _++) {
          var p;

          if ((p = f[_]).mesh) {
            r--;
            u = o[c++];
            this._isVertical ? (p.position.y = t + u.y, p.position.x = 0, t += 2 * u.y) : (p.position.x = t + u.x, p.position.y = 0, t += 2 * u.x), t += r > 0 ? this.margin : 0;
          }
        }
      }, e;
    }(o.Container3D);

    e.StackPanel3D = s;
  }, function (t, e, i) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), function (t) {
      for (var i in t) {
        e.hasOwnProperty(i) || (e[i] = t[i]);
      }
    }(i(26));
  }, function (t, e, i) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var r = i(0),
        o = i(3),
        n = function () {
      function t(t) {
        var e = this;
        this._lastControlOver = {}, this._lastControlDown = {}, this.onPickedPointChangedObservable = new r.Observable(), this._sharedMaterials = {}, this._scene = t || r.Engine.LastCreatedScene, this._sceneDisposeObserver = this._scene.onDisposeObservable.add(function () {
          e._sceneDisposeObserver = null, e._utilityLayer = null, e.dispose();
        }), this._utilityLayer = new r.UtilityLayerRenderer(this._scene), this._utilityLayer.onlyCheckPointerDownEvents = !1, this._utilityLayer.mainSceneTrackerPredicate = function (t) {
          return t && t.metadata && t.metadata._node;
        }, this._rootContainer = new o.Container3D("RootContainer"), this._rootContainer._host = this;
        var i = this._utilityLayer.utilityLayerScene;
        this._pointerOutObserver = this._utilityLayer.onPointerOutObservable.add(function (t) {
          e._handlePointerOut(t, !0);
        }), this._pointerObserver = i.onPointerObservable.add(function (t, i) {
          e._doPicking(t);
        }), this._utilityLayer.utilityLayerScene.autoClear = !1, this._utilityLayer.utilityLayerScene.autoClearDepthAndStencil = !1, new r.HemisphericLight("hemi", r.Vector3.Up(), this._utilityLayer.utilityLayerScene);
      }

      return Object.defineProperty(t.prototype, "scene", {
        get: function get() {
          return this._scene;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "utilityLayer", {
        get: function get() {
          return this._utilityLayer;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype._handlePointerOut = function (t, e) {
        var i = this._lastControlOver[t];
        i && (i._onPointerOut(i), delete this._lastControlOver[t]), e && this._lastControlDown[t] && (this._lastControlDown[t].forcePointerUp(), delete this._lastControlDown[t]), this.onPickedPointChangedObservable.notifyObservers(null);
      }, t.prototype._doPicking = function (t) {
        if (!this._utilityLayer || !this._utilityLayer.utilityLayerScene.activeCamera) return !1;
        var e = t.event,
            i = e.pointerId || 0,
            o = e.button,
            n = t.pickInfo;
        if (!n || !n.hit) return this._handlePointerOut(i, t.type === r.PointerEventTypes.POINTERUP), !1;
        var s = n.pickedMesh.metadata;
        return n.pickedPoint && this.onPickedPointChangedObservable.notifyObservers(n.pickedPoint), s._processObservables(t.type, n.pickedPoint, i, o) || t.type === r.PointerEventTypes.POINTERMOVE && (this._lastControlOver[i] && this._lastControlOver[i]._onPointerOut(this._lastControlOver[i]), delete this._lastControlOver[i]), t.type === r.PointerEventTypes.POINTERUP && (this._lastControlDown[e.pointerId] && (this._lastControlDown[e.pointerId].forcePointerUp(), delete this._lastControlDown[e.pointerId]), "touch" === e.pointerType && this._handlePointerOut(i, !1)), !0;
      }, Object.defineProperty(t.prototype, "rootContainer", {
        get: function get() {
          return this._rootContainer;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.containsControl = function (t) {
        return this._rootContainer.containsControl(t);
      }, t.prototype.addControl = function (t) {
        return this._rootContainer.addControl(t), this;
      }, t.prototype.removeControl = function (t) {
        return this._rootContainer.removeControl(t), this;
      }, t.prototype.dispose = function () {
        for (var t in this._rootContainer.dispose(), this._sharedMaterials) {
          this._sharedMaterials.hasOwnProperty(t) && this._sharedMaterials[t].dispose();
        }

        this._sharedMaterials = {}, this._pointerOutObserver && this._utilityLayer && (this._utilityLayer.onPointerOutObservable.remove(this._pointerOutObserver), this._pointerOutObserver = null), this.onPickedPointChangedObservable.clear();
        var e = this._utilityLayer ? this._utilityLayer.utilityLayerScene : null;
        e && this._pointerObserver && (e.onPointerObservable.remove(this._pointerObserver), this._pointerObserver = null), this._scene && this._sceneDisposeObserver && (this._scene.onDisposeObservable.remove(this._sceneDisposeObserver), this._sceneDisposeObserver = null), this._utilityLayer && this._utilityLayer.dispose();
      }, t;
    }();

    e.GUI3DManager = n;
  }]);
});